import React, { Component, useMemo } from "react";
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import "bootstrap/dist/css/bootstrap.css";
import "../CSS/general.css";
import { loginAuthProvider } from "../LoginAuthProvider";
import Axios from "axios";
import { API_ROUTE, Routes } from "../Helpers/Constants";
import TreeView from "@material-ui/lab/TreeView";
import TreeItem from "@material-ui/lab/TreeItem";
import { Button, FormGroup, Label, Input } from "reactstrap";
import { Card, Container, Row, Col } from "reactstrap";
import moment from "moment";
import { format } from 'date-fns';
import Table from "reactstrap/lib/Table";
import lodash from "lodash";
import DatePicker from "react-datepicker";
import { Button as BootStrapButton } from 'react-bootstrap';
import "react-datepicker/dist/react-datepicker.css";
import { Checkbox } from "@material-ui/core";
import { Modal } from "reactstrap";
import { Modal as BootstrapModal, Form } from 'react-bootstrap';
import { default as MultiSelect } from 'react-select';
import "react-select-search/style.css";
import { CopyToClipboard } from "react-copy-to-clipboard";
import {
    Dropdown,
    DropdownToggle,
    DropdownMenu,
    DropdownItem,
    Collapse,
} from "reactstrap";
import exchange from "../images/exchange.png";
import aadIcon from "../images/aad.png";
import aadIconDisabled from "../images/aad-grey.png";
import onedrive from "../images/onedrive.png";
import sharepoint from "../images/sharepoint.png";
import teams from "../images/teams-icon.png";
import exchangeDisabled from "../images/exchange-grey.png";
import AzureToolTip from "../images/AzureToolTip.jpg";
import cloud from "../images/Cloud.png";
import onedriveDisabled from "../images/onedrive-grey.png";
import sharepointDisabled from "../images/sharepoint-grey.png";
import teamsDisabled from "../images/teams-grey.png";
import { NavBar } from "./NavBar";
import 'react-toastify/dist/ReactToastify.css';
import { RestorePoints } from "./RestorePoints";
import { AgGridReact } from "ag-grid-react";
import { Calendar } from "react-calendar";
import { OverlayTrigger, Tooltip, Accordion } from "react-bootstrap";
import AuthenticationContext from "../Store/Authentication-Context";
import 'bootstrap/dist/css/bootstrap.min.css';
import RestoreAccessModal from "./RestoreAccessModal";
import LoaderGif from "../images/365 loading.gif"
import DotsTyping from "../images/DotsTyping.gif";
import Exchanges from "../images/exchange.png";
import Onedrives from "../images/onedrive.png";
import Sharepoints from "../images/sharepoint.png";
import Teams from "../images/teams-icon.png";
import { setItem, getItem, clearAllRestoreIndexedDB } from "./IndexedDBUtils";
export class RestoreTree extends Component {
    static contextType = AuthenticationContext;
    constructor(props) {
        super(props);
        let time = moment(new Date());
        let hour = time.format("HH").toString();
        let minute = time.format("mm").toString();
        let timeString = hour + ":" + minute;
        let guardianValueCheck = (sessionStorage.getItem('GuardianOnlyEnabled-' + new URLSearchParams(window.location.search).get("orgId")).toString() === "true");
        const urlParams = new URLSearchParams(window.location.search);
        const orgId = urlParams.get("orgId");
        const orgName = urlParams.get("orgName");
        this.gridRef = React.createRef();
        let impersonating = false;
        if (orgId) {
            impersonating = true;
        }
        var accountInfo = loginAuthProvider.getAccountInfo();
        let username = accountInfo.account.userName;
        this.state = {
            tenantDomain: sessionStorage.getItem("ManageTenantDomain") ? sessionStorage.getItem("ManageTenantDomain") : "",
            isAzureGuardianOnly: guardianValueCheck,
            isAzureGuardianOnlyLoaded: true,
            guardianStatusLoaded: false,
            disableBtn: true,
            orgId: orgId,
            impersonating: impersonating,
            firstRestoreDate: null,
            lastRestoreDate: null,
            gotRestoreDates: false,
            gettingDeviceCode: false,
            clearCacheChecked: false,
            showConfirmationModal: false,
            restoreSessions: [],
            // Task 14 — PST export progress for the restore session currently open. Held
            // separately from the Veeam-sourced session Status column, which describes the RESTORE
            // SESSION and must not be overloaded with our export's state.
            pstExports: [],
            pstExportMessage: "",
            selectedSessionEvents: [],
            isSelectedSessionEventsLoaded: false,
            restoreSessionGrid: false,
            showRestoreSession: true,
            restoredItem: "",
            siteId: null,
            currentEventsUrl: "",
            allSessionEvents: [],
            filters: { errors: true, warnings: true, success: true },
            restoreType: "",
            siteURL: "",
            mailbox: "",
            destinationOneDriveId: "",
            destinationFolder:"",
            destinationOneDriveUserName: "",
            destinationOneDriveUrl: "",
            restoreDate: new Date(),
            restoreTime: timeString,
            inProgressLeft: false,
            inProgressRight: false,
            ingettingDeviceCode: false,
            inProgressRestore: false,
            searchFailed: "",
            gotSelectItems: false,
            showDropdown: false,
            restore: null,
            openSharepointModal: false,
            showoneDriveModal: false,
            selectItems: [],
            treeItems: [],
            viewItems: [],
            gridViewItems: [],
            oldItems: null,
            oldFlag: false,
            oldPage: 0,
            pageSize: 100,
            isLoading: false,
            type: "",
            gridPage: 0,
            dataCount: 1,
            pageInputValue:1,
            hasLoadedAllData:false,
            noResults: false,
            selectItem: null,
            selectedFolder: null,
            showRestorePoints: false,
            restorePoint: [],
            displayPage: 0,
            loadedCurrentConfig: false,
            nextBlocked: true,
            selectedItems: [],
            clearLeftSection: false,
            isMFA: false,
            itemClicked: "",
            copied: false,
            verificationModalOpen: false,
            restoreAction: "",
            actionType: "",
            deviceCode: "",
            username: username,
            password: "",
            mailModalOpen: false,
            toAnotherMailboxOpen: false,
            allUserList: [],
            mailSendTo: "",
            mailFrom: "",
            mailSubject: "",
            mailMessage: "Here are the files you requested.",
            command: "",
            rootRestoreOpen: false,
            folderRestoreOpen: false,
            itemRestoreOpen: false,
            fileName: "",
            queryString: "",
            restoreJob: null,
            timeoutError: false,
            lastClicked: "",
            downloadModalOpen: false,
            entraModalOpen: false,
            
            downloading: false,
            /*litigation: false,*/
            litigation: {
                state: false,
                popUp: false,
                description: "",
                action: "",
                type: ""
            },
            litigationPopUp: false,
            restoreModalOpen: false,
            restoring: false,
            restoreDetails: {
                restoredItem: "",
            },
            restorePoints: [],
            selectedrestorePoints: [],
            restoreSuccess: null,
            errorMessage: "",
            searchTerm: "",
            searchTermDate: null,
            searchResultsFlag: false,
            SearchQueued: false,
            searchQueries: [],
            searchHistoryQueries: [],
            activeSearchList: {
                QueriesList: [],
                SearchCount: [],
                SetID: [],
                Title: [],
                SubTitle: [],
                BackUpTime: [],
                ValidTime: [],
                SearchQuery: [],
                Url: [],
                Type: [],
                Status: []
            },
            searchHistoryResultCount: [],
            QueryHistory: [],
            restorePointID: "",
            searchType: "null",
            sarchField: "null",
            isDateField: false,
            searchQueryType: "",
            conditionType: "Text",
            conditionOptions: [],
            dateRange: { start: null, end: null },
            value: 0,
            unit: 'KB',
            dropdownValues: {
                customDropdown: '----',
                sensitivityDropdown: '----',
                meetingStatusDropdown: '----',
                attachmentsDropdown: '----',
                flagStatusDropdown: '----',
                colorDropdown: '----',
            },
            searchTermVisible: true,
            lblsearchTermVisible: true,
            searchTermDateVisible: false,
            lblsearchTermDateVisible: false,
            customFieldDropdownVisible: false,
            lblBetweenDatesVisible: false,
            fileSizeVisible: false,
            isDateFields: false,
            isCustomField: false,
            isBooleanField: false,
            isSensitivityField: false,
            isMeetingStatusField: false,
            isFlagStatusField: false,
            isColorField: false,
            isSizeField: false,
            searchFilters: [],
            aadviewItems: [],
            searchPanelOpen: true,
            aadnoResults: true,
            orgName: orgName,
            searchHistoryPanelOpen: false,
            noRestoreDates: false,
            checkRestoreDates: false,
            expandedFolders: ["root"],
            largeDownload: false,
            serverPath: "",
            isEndUser: false,
            restoreMailTo: "",
            usersList: [],
            extraLargeDownload: false,
            columnDefs: [],
            rowSelection: [],
            selectionColumnDef: [],
            AADColumnDefs: [],
            mark: [],
            IsLitigationHoldApplicable:false,
            aadData: null,
            //isEntraButtonEnabled: false,
            entraRestorePoint: null,
            sessionid: '',
            gridApi: null,
            restoreSessionGridApi: null,
            priceModel: {},
            restorePath: "",
            listName: "",
            activeAccordion: "0",
            isAccordionOpen: true, 
            selectedRestoreType: "",
            selectedRestoreDate: "",
            selectedRestorePoint: "",
            showCommentPopup: false,
            restoreChallangeSubmitted: false,
            restoreVisibleMonthandYear: "",
            isRestoreCalanderLoaded: false,
            showRestoreCalendar: false,
            isAADRestoreTableLoaded:false,
            renderRestoreestoreCalendar: <div className="justify-content-center align-items-center d-flex h-100" style={{ minHeight: '225px' }}>
                <img src={LoaderGif} alt="loading" style={{ height: '50px' }} />
            </div>,
            renderAzureRestoreestoreCalendar: <div className="justify-content-center align-items-center d-flex h-100" style={{ minHeight: '225px' }}>
                <img src={LoaderGif} alt="loading" style={{ height: '50px' }} />
            </div>,
            azureGridApi: null,
            AADPreviousCurrent: null,
            AADPreviousCConfigHeadar: null,
            AADReportshow: false,
            restore365ActiveStartDate: new Date(new Date().getFullYear(), new Date().getMonth()),
            multiSelectItemsIds: [],
            multiSelectItems: [],
            bulkRestoreOptions: {
                excludeDrafts: false,
                excludeDeletedItems: false,
                excludeInPlaceHoldItems: false,
                excludeLitigationHoldItems: false
            },

            showBulkRestore:false
        };
        this.handleDropdownChange = this.handleDropdownChange.bind(this);
        this.handleValueChange = this.handleValueChange.bind(this);
        this.handleLitigationDescriptionChange = this.handleLitigationDescriptionChange.bind(this);
        this.resetState = this.resetState.bind(this);
        this.getOrgRestore = this.getOrgRestore.bind(this);
        this.blockInvalidChar = this.blockInvalidChar.bind(this);
        this.getRestore = this.getRestore.bind(this);
        this.getSelectItems = this.getSelectItems.bind(this);
        this.getChildren = this.getChildren.bind(this);
        this.selectItem = this.selectItem.bind(this);
        this.singleSelectItem = this.singleSelectItem.bind(this);
        this.folderClick = this.folderClick.bind(this);
        this.formatDateToUTCString = this.formatDateToUTCString.bind(this);
        this.getView = this.getView.bind(this);
        this.FetchExchangeSharePointData = this.FetchExchangeSharePointData.bind(this);
        this.getTable = this.getTable.bind(this);
        this.convertHeading = this.convertHeading.bind(this);
        this.nextPage = this.nextPage.bind(this);
        this.paginationNextPage = this.paginationNextPage.bind(this);
        this.previousPage = this.previousPage.bind(this);
        this.paginationPreviousPage = this.paginationPreviousPage.bind(this);
        this.selectRestoreItem = this.selectRestoreItem.bind(this);
        this.buildRestore = this.buildRestore.bind(this);
        this.openVerificationModal = this.openVerificationModal.bind(this);
        this.closeVerificationModal = this.closeVerificationModal.bind(this);
        this.openMailModal = this.openMailModal.bind(this);
        this.closeMailModal = this.closeMailModal.bind(this);
        this.mailContinue = this.mailContinue.bind(this);
        this.anotherMailBox = this.anotherMailBox.bind(this);
        this.closesharepointRestoreToModal = this.closesharepointRestoreToModal.bind(this);
        this.closeToAnotherMailBoxRestoreToModal = this.closeToAnotherMailBoxRestoreToModal.bind(this);
        this.sharepointRestoreToContinue = this.sharepointRestoreToContinue.bind(this);
        this.exchangeRestoreToContinue = this.exchangeRestoreToContinue.bind(this);
        this.closeOneDriveRestoreToModal = this.closeOneDriveRestoreToModal.bind(this);
        this.oneDriveRestoreToContinue = this.oneDriveRestoreToContinue.bind(this);
        this.getDeviceCode = this.getDeviceCode.bind(this);
        this.deviceTokenCheck = this.deviceTokenCheck.bind(this);
        this.getRestoreSession = this.getRestoreSession.bind(this);
        this.handleFilter = this.handleFilter.bind(this);

        this.verificationContinue = this.verificationContinue.bind(this);
        this.toggleDropdown = this.toggleDropdown.bind(this);
        this.editParameter = this.editParameter.bind(this);
        this.closeDownloadModal = this.closeDownloadModal.bind(this);
        this.closeRestoreModal = this.closeRestoreModal.bind(this);
        this.resetCheckbox = this.resetCheckbox.bind(this);
        this.handleDateChange = this.handleDateChange.bind(this);
        this.handleTimeChange = this.handleTimeChange.bind(this);
        this.changeSearchTerm = this.changeSearchTerm.bind(this);
        this.search = this.search.bind(this);
        this.changeSearchField = this.changeSearchField.bind(this);
        this.changeSearchType = this.changeSearchType.bind(this);
        this.addToQueryLines = this.addToQueryLines.bind(this);
        this.changeSearchQueryType = this.changeSearchQueryType.bind(this);
        this.deleteQuery = this.deleteQuery.bind(this);
        this.openSearchPanel = this.openSearchPanel.bind(this);
        this.clearFolder = this.clearFolder.bind(this);
        this.getRestoreDates = this.getRestoreDates.bind(this);
        this.openSearchHistoryPanel = this.openSearchHistoryPanel.bind(this);
        this.clearSearch = this.clearSearch.bind(this);
        this.getOrgName = this.getOrgName.bind(this);
        this.handleCheckboxChange = this.handleCheckboxChange.bind(this);
        this.showRestorePointsPopup = this.showRestorePointsPopup.bind(this);
        this.setRestorePoint = this.setRestorePoint.bind(this);
        this.getStringFromDate = this.getStringFromDate.bind(this);
        this.accordianChange = this.accordianChange.bind(this);
        this.handleRestoreChallangeSubmitted = this.handleRestoreChallangeSubmitted.bind(this);
        this.handleCommentSubmitted = this.handleCommentSubmitted.bind(this);
        this.restoreChallengePopup = this.restoreChallengePopup.bind(this);
        this.hideRestorePopup = this.hideRestorePopup.bind(this);
        this.aadorNot = this.aadorNot.bind(this);
        this.onActiveStartDateChange = this.onActiveStartDateChange.bind(this);
        this.findMaxBackupDate = this.findMaxBackupDate.bind(this);
        this.getRestorePointsOnMonth = this.getRestorePointsOnMonth.bind(this);
        this.getIsEndUser();
        this.getRestoreEmailType();
        this.getOrgUsers();
       // this.getOrgName();
        //this.getRestorePoints(new Date());

        this.onGridReady = this.onGridReady.bind(this);
        this.restoreOnGridReady = this.restoreOnGridReady.bind(this);
        this.sessionEventOnGridReady = this.sessionEventOnGridReady.bind(this);
        this.OnItemSelected = this.OnItemSelected.bind(this);
        this.OnselectionChanged = this.OnselectionChanged.bind(this)
        this.setColumnDefinition = this.setColumnDefinition.bind(this);
        this.formatDateColumn = this.formatDateColumn.bind(this);
        this.setDynamicColumnDefinition = this.setDynamicColumnDefinition.bind(this);
        this.PreviewAADdiff = this.PreviewAADdiff.bind(this);
        this.AADReporthandleClose = this.AADReporthandleClose.bind(this);
        this.renderAgGrid = this.renderAgGrid.bind(this);
        this.getRowStyle = this.getRowStyle.bind(this);
        this.getSearchField = this.getSearchField.bind(this);
        this.handleSearchDate = this.handleSearchDate.bind(this);
        this.overlayProgress = this.overlayProgress.bind(this);
        //this.CheckAzureGuardianOnly = this.CheckAzureGuardianOnly.bind(this);

        this.logRestoreSession = this.logRestoreSession.bind(this);
        this.getAADBackupConfigData = this.getAADBackupConfigData.bind(this);
        //this.getCalanderRestorePoints = this.getCalanderRestorePoints.bind(this);
        this.onChange = this.onChange.bind(this);
        //this.onAADChange = this.onAADChange.bind(this);
        this.getAADBackupConfigDataListing = this.getAADBackupConfigDataListing.bind(this);
        this.onClickAADRestore = this.onClickAADRestore.bind(this);
        this.BulkRestore = this.BulkRestore.bind(this);
        this.transformData = this.transformData.bind(this);
        this.showBulkRestore = this.showBulkRestore.bind(this);
        this.hideBulkRestore = this.hideBulkRestore.bind(this);
        this.onBulkRestoreChecked = this.onBulkRestoreChecked.bind(this);
        this.CheckForEntraBackup(orgName, orgId);

    }
    static displayName = RestoreTree.name;
    columnDefs = [
        {
            headerName: "Start time", field: "creationTime", sortable: true, flex: 1, cellStyle: { fontSize: "12px" },
            valueFormatter: (params) => format(new Date(params.value), 'dd-MM-yyyy HH:mm:ss'),
            tooltipValueGetter: (params) => format(new Date(params.value), 'dd-MM-yyyy HH:mm:ss'),
        },
        { headerName: "Name", field: "name", sortable: true, tooltipField: "name",flex:2 , cellStyle: { fontSize: "12px" } },
        {
            headerName: "Status", field: "state", sortable: true, tooltipValueGetter: (params) => {
                if (params.data.state === "Working") {
                    return "Running";
                }
                return params.data.result;
            }, cellStyle: { fontSize: "12px" },
            cellRenderer: (params) => {
                if (params.data.state === "Working") {
                    return (
                        <svg xmlns="http://www.w3.org/2000/svg" version="1.0" width="18" height="18" viewBox="0 0 512.000000 512.000000" preserveAspectRatio="xMidYMid meet">
                        
                                <g transform="translate(0.000000,512.000000) scale(0.100000,-0.100000)" fill="currentColor" stroke="none">
                                <path d="M3933 5015 c-193 -52 -357 -225 -393 -414 -48 -256 98 -508 348 -598 189 -69 399 -18 548 133 204 208 202 528 -5 735 -134 134 -327 190 -498 144z" />
                                <path d="M2175 4226 c-16 -7 -220 -194 -453 -415 -489 -466 -477 -450 -477 -601 0 -85 3 -100 27 -141 68 -116 192 -174 318 -148 30 6 74 22 97 35 24 14 168 158 344 344 l302 320 99 0 c55 0 98 -4 96 -8 -1 -5 -302 -342 -666 -750 l-664 -741 -456 -3 c-449 -3 -458 -4 -513 -26 -65 -26 -140 -87 -175 -144 -35 -54 -57 -151 -51 -215 12 -111 91 -228 187 -278 83 -42 132 -45 784 -45 573 0 624 1 653 18 17 9 171 167 343 350 171 183 315 332 319 330 4 -2 126 -126 269 -277 210 -219 261 -277 257 -295 -3 -11 -41 -255 -86 -541 -65 -416 -80 -534 -76 -587 16 -191 184 -332 375 -315 78 8 179 55 226 107 71 79 75 97 225 900 78 415 141 762 141 770 0 8 -171 186 -380 395 l-380 380 293 293 292 292 215 -216 c255 -255 275 -269 400 -269 73 0 92 4 135 27 36 19 169 146 466 445 389 390 418 422 438 476 27 73 27 131 0 204 -25 65 -94 145 -151 174 -87 44 -210 43 -288 -3 -19 -12 -150 -136 -292 -276 -200 -199 -262 -254 -282 -254 -29 0 -20 -9 -405 347 -300 277 -348 316 -410 337 -56 18 -1055 23 -1096 4z" />

                            </g>
                    </svg>
                    );
                
                } else if (params.data.state === "Stopped") {
                    return params.data.result === "Success" ? (
                        <span style={{ fontSize: '13px' }} aria-hidden="true">✅</span>
                    ) : params.data.result === "Failed" ? (
                            <span style={{ fontSize: '13px' }} aria-hidden="true">❌</span>
                        ) : params.data.result === "Warning" ? (
                                <span style={{ fontSize: '13px' }} aria-hidden="true">⚠️</span>
                    ) : (
                        params.data.result
                    );
                }
                return params.data.state;
            }

        }
    ];
    aggridColumnDefs = [
        {
            headerName: "Action",
            field: "message",
            cellRenderer : (params) => {
                const status = params.data.status?.toLowerCase();

                const icon =
                    status === "success" ? "✅" :
                        status === "warning" ? "⚠️" :
                            status === "running" ? "⏳" :
                                "❌";

                const message = params.value || "";

                return (
                    <div
                        style={{
                            display: "flex",
                            lineHeight: 1.4,
                            whiteSpace: "normal",
                            wordWrap: "break-word",
                        }}
                    >
                        <span style={{ marginRight: 4 }}>{icon}</span>
                        <span
                            style={{
                                display: "-webkit-box",
                                WebkitLineClamp: 2,
                                WebkitBoxOrient: "vertical",
                                overflow: "hidden",
                                textOverflow: "ellipsis",
                                flex: 1,
                            }}
                        >
                            {message}
                        </span>
                    </div>
                );
            },
            flex: 7,
            sortable: true,
            tooltipField: "message",
            minWidth:800
        },
        {
            headerName: "Duration",
            field: "duration",
            valueFormatter: (params) => {
                if (!params.value || params.value === "00:00:00") return "";
                const parts = params.value.split(":");
                if (parts.length < 3) return params.value;
                let [h, m, s] = parts;
                if (s.includes(".")) {
                    let [sec, ms] = s.split(".");
                    ms = (parseFloat(`0.${ms}`) * 100).toFixed(0).padStart(2, "0");
                    s = `${sec}.${ms}`;
                }
                return `${h}:${m}:${s}`;
            },
            flex: 1,
            sortable: true,
            minWidth: 120,
        }
    ];

    defaultColDef = {
        flex: 1,
        filter: false,
        sortable: true,
        resizable: true
    };
    componentDidMount() {
        this.getOrgName();
        this.setState({
            checkRestoreDates: true
        });
        this.getRestoreSession();
    }

    // Task 14 — an export runs for hours, so the poll must not outlive the screen.
    componentWillUnmount() {
        this.stopPstExportPolling();
    }

    stopPstExportPolling() {
        if (this.pstExportTimer) {
            clearInterval(this.pstExportTimer);
            this.pstExportTimer = null;
        }
    }

    // Task 14 — starts the 15-second poll, unless one is already running. Deliberately idempotent:
    // it is called both when an export is triggered and when a restore session is opened, and two
    // intervals would double the traffic for no benefit.
    startPstExportPolling() {
        if (this.pstExportTimer) return;
        this.pstExportTimer = setInterval(() => this.pollPstExportStatus(), 15000);
    }

    // Reads the export state for the restore session currently open. Stops itself the moment none
    // are live, so a customer who is not exporting anything generates no traffic at all.
    async pollPstExportStatus() {
        const restoreId = this.state.restore && this.state.restore.id;
        if (!restoreId || !this.state.orgId) {
            this.stopPstExportPolling();
            return;
        }

        const authContext = this.props.authContext || this.context;
        const { setAuthContext } = authContext;

        try {
            const tokenString = await setAuthContext(new Date());
            const config = {
                headers: {
                    Authorisation: `Bearer ` + tokenString,
                    CloudCoverToken: sessionStorage.getItem('CloudCoverToken'),
                },
            };

            const response = await Axios.get(
                API_ROUTE + Routes.PST_EXPORT_STATUS(this.state.orgId, restoreId), config);

            const exports = Array.isArray(response.data) ? response.data : [];
            this.setState({ pstExports: exports });

            // IsInProgress is decided by the backend against the same status list the database
            // indexes filter on, so the portal never has to know the status vocabulary.
            if (exports.some((e) => e.isInProgress === true || e.IsInProgress === true)) {
                // Self-arming: one call is enough to pick up an export that was already running
                // when the session was opened, without the caller having to know.
                this.startPstExportPolling();
            } else {
                this.stopPstExportPolling();
                // A finished export usually means new files; refresh the session's event list so
                // the produced parts appear without the user reloading.
                this.getRestoreSession();
            }
        } catch (reason) {
            // A transient failure must not kill the indicator — the next tick retries. Only a
            // dead session is worth surrendering to.
            if (reason?.response?.status === 440) {
                this.stopPstExportPolling();
                window.location.href = "/TimeoutErrorHandler";
            }
        }
    }
    hideRestorePopup() {
        this.setState({
            showCommentPopup: false,
        });
    }
    close = () => {
        this.setState({ isModalOpen: false });
    };

    handleFilterChange = (filterType) => {
        this.setState((prevState) => {
            const updatedFilters = {
                ...prevState.filters,
                [filterType]: !prevState.filters[filterType],
            };

            const isAnyFilterActive = updatedFilters.success || updatedFilters.warnings || updatedFilters.errors;

            const filteredEvents = isAnyFilterActive
                ? prevState.allSessionEvents.filter(event =>
                    (updatedFilters.success && event.status.toLowerCase() === "success") ||
                    (updatedFilters.warnings && event.status.toLowerCase() === "warning") ||
                    (updatedFilters.errors && event.status.toLowerCase() === "failed")
                )
                : [];

            return {
                filters: updatedFilters,
                selectedSessionEvents: filteredEvents
            };
        }, () => {
            if (this.state.restoreSessionGridApi) {
                this.state.restoreSessionGridApi.setGridOption('rowData', this.state.selectedSessionEvents);
            }
        });
    };

    handleNewRestoreClick = () => {
        this.setState((prevState) => ({
            isAccordionOpen: !prevState.isAccordionOpen,
            activeAccordion: prevState.isAccordionOpen ? "" : "0",
            restoreSessionGrid: false,
            allSessionEvents: false,
            viewItems: [],
            gridViewItems: [],
            restore: false
        }));
    };
    toggleGridVisibility = () => {
        this.setState((prevState) => ({
            restoreSessionGrid: !prevState.restoreSessionGrid,
            isAccordionOpen: false,
            restore: false,
            searchResultsFlag: false,
            viewItems: [],
            gridViewItems: [],
        }),
            () => {
                this.getRestoreSession();
            }
        );
    };
    handleCommentSubmitted = () => {
        this.setState({
            showCommentPopup: false,
            viewItems: [],
            gridViewItems: [],
            selectedItems: []
        });
        if (this.state.selectedRestoreType === '365 Backup') {
            this.getRestorePoints(new Date());
            this.accordianChange("next");
            this.aadorNot(false);
            this.getActiveSearchList()
            this.setState({ showRestoreSession: true })
        }
        else if (this.state.selectedRestoreType === 'Azure Backup') {
            this.accordianChange("aadazure");
            this.aadorNot(true);
        //    this.setState({ showRestoreSession : false})
        }
    };
    restoreChallengePopup = (aadorNot) => {
        this.setState({
            showCommentPopup: true
        });
        if (aadorNot) {
            this.setState({
                selectedRestoreType: "Azure Backup"
            });
        }
        else {
            this.setState({
                selectedRestoreType: "365 Backup",
                isRestoreCalanderLoaded: false
            });
        }
    };

    removeCSS() {
        var oldLinks = document.body.childNodes;
        for (var i = 0; i < oldLinks.length; i++) { }
    }

    handleDateChange(date) {
        this.setState({
            restoreDate: date,
        });
    }

    handleBetweenDateChange = (key, date) => {
        this.setState(prevState => {
            // Update the date range with the new date for the given key
            const newDateRange = { ...prevState.dateRange, [key]: date };
            const startDate = newDateRange.start ? this.formatDate(newDateRange.start) : '';
            const endDate = newDateRange.end ? this.formatDate(newDateRange.end) : '';
            const rangeString = startDate && endDate ? `${startDate} b/w ${endDate}` : '';

            return {
                dateRange: newDateRange,
                searchTermRangeStart: startDate,
                searchTermRangeEnd: endDate,
                searchTermDate: rangeString,
                searchTerm: rangeString 
            };
        });
    };


    formatDate = (date) => {
        if (!date) return '';
        const d = new Date(date);
        let month = '' + (d.getMonth() + 1);
        let day = '' + d.getDate();
        const year = d.getFullYear();
        if (month.length < 2) month = '0' + month;
        if (day.length < 2) day = '0' + day;
        return [year, month, day].join('-');
    };



    handleSearchDate = (date) => {
        var d = date,
            month = '' + (d.getMonth() + 1),
            day = '' + d.getDate(),
            year = d.getFullYear();

        if (month.length < 2)
            month = '0' + month;
        if (day.length < 2)
            day = '0' + day;

        let searchDate = [year, month, day].join('-');
        this.setState({
            searchTermDate: date,
            searchTerm: searchDate,
        });
    }
    showRestorePointsPopup() {
        this.setState({ showRestorePoints: false });
    }

    setRestorePoint(params) {
        this.resetState("");
        const fullBackupTime = params.localBackupTimeStr;
        const hasMonthName = /[a-zA-Z]/.test(this.state.selectedRestoreDate);
        let localBackupTimeStr;

        if (hasMonthName) {
            // Assign the full string
            localBackupTimeStr = fullBackupTime;
        } else {
            // Extract only HH:mm:ss (the last 8 characters)
            localBackupTimeStr = fullBackupTime.split(' ')[1];
        }
        this.setState({
            restorePoint: params,
            restoreDate: new Date(params.backupTime),
            restorePointID: params.id.toString(),
            restoreDateTime: params.backupTimeStr,
            restoreTime: this.getStringFromDate(params.backupTimeStr),
            clearLeftSection: true,
            activeAccordion: "3",
            selectedRestorePoint: localBackupTimeStr
        });
    }

    getStringFromDate = (d) => {
        var timeString = d.split(' ')[1];
        return timeString.substring(0, 8);
    }

    handleTimeChange(time) {
        this.setState({
            restoreTime: time,
        });
    }
    handleCheckboxChange(event) {
        this.setState(
            {
                clearCacheChecked: !this.state.clearCacheChecked
            })
    }
    openDownloadModal(event, action, type) {
        event.preventDefault();
        let queryString = "";
        let largeDownload = false;
        if (this.state.restoreType === "vex") {
            if (type === "item") {
                if (this.state.selectItem !== undefined || this.state.selectItem !== null)
                    queryString = this.state.selectItem.actions[0].href.replace(
                        "/exportToPst",
                        "/items/" + action
                    );
                if (this.state.selectedItems.length > 10) {
                    largeDownload = true;
                }
            } else if (type === "folder") {
                queryString = this.state.selectItem.actions[0].href.replace(
                    "/exportToPst",
                    "/folders/" + this.state.selectedFolder.id + "/" + action
                );
                largeDownload = true;
            } else if (type === "root") {
                queryString = this.state.selectItem.actions[0].href;
                largeDownload = true;
            }
        }
        else if (this.state.restoreType === "vesp1") {
            if (this.state.lastClicked === "Libraries") {
                queryString = this.state.selectItem.libraries.replace(
                    "/libraries",
                    "/documents/" + action
                );
            } else if (this.state.lastClicked === "Lists") {
                queryString = this.state.selectItem.lists.replace(
                    "/lists",
                    "/lists/" + this.state.selectedFolder.id + "/" + action
                );
            } else if (this.state.lastClicked === "Subsites") {
                queryString = this.state.restorePath + "/" + action
                largeDownload = true;
            }
        }
        else if (this.state.restoreType === "vesp") {
            if (this.state.lastClicked === "Libraries") {
                queryString = this.state.restorePath + "/documents/" + action;
            } else if (this.state.lastClicked === "Lists") {
                queryString = this.state.restorePath + "/lists/" + this.state.selectedFolder.id + "/" + action;
            } else if (this.state.lastClicked === "Subsites") {
                queryString = this.state.restorePath +  action;
                largeDownload = true;
            }
        }
        else if (this.state.restoreType === "veod") {

            if (type === "item") {
                queryString = this.state.selectItem.getFolders.replace("/folders?parentId=Root", "/documents/" + action);
            } else if (type === "folder") {
                queryString = this.state.selectItem.getFolders.replace(
                    "/folders?parentId=Root",
                    "/folders/" + this.state.selectedFolder.id + "/" + action
                );
                largeDownload = true;
            }
        }
        else if (this.state.restoreType === "vet") {
            if (type === "item") {
                if (this.state.selectedFolder.title === "Posts") {
                    queryString = this.state.selectItem.getFolders.replace(
                        "/channels",
                        "/posts/" + action
                    );
                } else {
                    queryString = this.state.selectItem.getFolders.replace(
                        "/channels",
                        "/files/" + action
                    );
                }
            } else if (type === "folder") {
                queryString = this.state.selectItem.actions[0].href.replace(
                    "/libraries",
                    "/folders/" + this.state.selectedFolder.id + "/" + action
                );
                largeDownload = true;
            }
        }

        this.setState(
            {
                restoreAction: action,
                actionType: type,
                downloadModalOpen: true,
                downloading: true,
                restoreModalOpen: false,
                restoring: false,
                restoreDetails: {
                    restoredItem: "",
                },
                restoreSuccess: null,
                queryString: queryString,
                largeDownload: largeDownload
            },
            () => {
                this.buildRestore();
            }
        );
    }

    openMailModal(event, action, type) {
        event.preventDefault();
        let queryString = "";


        if (this.state.restoreType === "vex") {
            if (type === "item") {
                queryString = this.state.selectItem.actions[0].href.replace(
                    "/exportToPst",
                    "/items/" + action
                );
            }
        } else if (this.state.restoreType === "vesp") {
            if (this.state.lastClicked === "Libraries") {
                queryString = this.state.selectItem.libraries.replace(
                    "/libraries",
                    "/documents/" + action
                );
            } else if (this.state.lastClicked === "Lists") {
                queryString = this.state.selectItem.lists.replace(
                    "/lists",
                    "/lists/" + this.state.selectedFolder.id + "/" + action
                );
            } else if (this.state.lastClicked === "Subsites") {
                queryString = this.state.restorePath + "/" + action
            }
        } else if (this.state.restoreType === "veod") {
            if (type === "item") {
                queryString = this.state.selectItem.getFolders.replace(
                    "/folders?parentId=Root",
                    "/documents/" + action
                );
            } else if (type === "folder") {
                queryString = this.state.selectItem.getFolders.replace(
                    "/folders?parentId=Root",
                    "/folders/" + this.state.selectedFolder.id + "/" + action
                );
            } else if (type === "root") {
                queryString = this.state.selectItem.getFolders.replace(
                    "/folders?parentId=Root",
                    "/documents/" + action
                );
            }
        } else if (this.state.restoreType === "vet") {
            if (type === "item") {
                queryString = this.state.selectItem.getFolders.replace(
                    "/channels",
                    "/files/" + action
                );
            } else if (type === "folder") {
                queryString = this.state.selectItem.actions[0].href.replace(
                    "/libraries",
                    "/folders/" + this.state.selectedFolder.id + "/" + action
                );
            } else if (type === "root") {
            }
        }
        if (action === "sendtoDefaultaddress") {
            this.setState(
                {
                    restoreAction: action,
                    actionType: type,
                    queryString: queryString,
                },
                () => {
                    this.buildRestore();
                }
            );
        } else {
            this.setState({
                restoreAction: action,
                actionType: type,
                queryString: queryString,
                mailModalOpen: true,
                largeDownload: false
            });
        }
    }

    async getRestoreDownloads(e) {
        if (e) {
            e.preventDefault();
        }
        const authContext = this.props.authContext || this.context;
        const { setAuthContext } = authContext;
        var tokenString = await setAuthContext(new Date());

        const config = {
            headers: {
                Authorisation: `Bearer ` + tokenString,
                CloudCoverToken: sessionStorage.getItem('CloudCoverToken'),
            },
        };
        Axios.get(API_ROUTE + Routes.GET_RESTORE_DOWNLOADS(this.state.orgId), config)
            .then((response) => {
                this.setState({ disableBtn: false });
            })
            .catch((reason) => {
                console.log(reason);
                if (reason?.response?.status === 440) {
                    window.location.href = "/TimeoutErrorHandler";
                }
            });
    }

    openVerificationModal(event, action, type) {
        if (event) {
            event.preventDefault();
        }
        //this.setState(
        //    {
        //        verificationModalOpen: true
        //    }
        //);
        let queryString = "";
        let restoreDetails = { restoreType: this.state.restoreType, restoredItem: "" };

        if (this.state.restoreType === "vex") {
          
            if (type === "root") {
                var actions = this.state.selectItem.actions;

                for (var i = 0; i < actions.length; i++) {
                    const actionItem = actions[i];
                    if (actionItem.name === "RestoreToOriginalLocation" && action==="restore") {
                        queryString = actionItem.href;
                        restoreDetails.restoredItem = "Restore To Original Location";
                    }
                    if (actionItem.name === "RestoreTo" && action === "restoreTo") {
                        queryString = actionItem.href;
                        restoreDetails.restoredItem = "Restore To Original Location";
                    }
                }
            } else if (type === "item") {
                queryString = this.state.selectItem.actions[0].href.replace(
                    "/exportToPst",
                    "/items/" + action
                );
                restoreDetails.restoredItem = "Item Restore";
            } else if (type === "folder") {
                queryString = this.state.selectItem.actions[0].href.replace(
                    "/exportToPst",
                    "/folders/" + this.state.selectedFolder.id + "/" + action
                );
                restoreDetails.restoredItem = "folder restore";
            }
        } else if (this.state.restoreType === "vesp") {
            if (type === "root") {
                queryString = this.state.selectItem.libraries.replace(
                    "/libraries",
                    "/" + action
                );
                restoreDetails.restoredItem = "root restore";
            } else if (type === "folder") {
                if (this.state.lastClicked === "Libraries") {
                    /*queryString = this.state.selectItem.libraries.replace(
                        "/libraries",
                        "/libraries/" + this.state.selectedFolder.id + "/" + action
                    );*/
                    queryString = this.state.selectedFolder.self + "/" + action;
                } else if (this.state.lastClicked === "Lists") {
                    queryString = this.state.selectItem.lists.replace(
                        "/lists",
                        "/lists/" + this.state.selectedFolder.id + "/" + action
                    );
                } else if (this.state.lastClicked === "Subsites") {
                    queryString = this.state.restorePath + "/" + action
                    restoreDetails.restoredItem = "folder restore";
                }
            } else if (type === "item") {
                if (this.state.lastClicked === "Libraries") {
                    queryString = this.state.restorePath + "/documents/" + action;
                   
                } else if (this.state.lastClicked === "Lists") {
                    queryString = this.state.restorePath +
                        "/items/" + action;
                  
                } else if (this.state.lastClicked === "Subsites") {
                    queryString = this.state.restorePath + "/" + action
                }
                restoreDetails.restoredItem = "item restore";

            }
        } else if (this.state.restoreType === "veod") {
            if (type === "item") {
                queryString = this.state.selectItem.getFolders.replace(
                    "/folders?parentId=Root",
                    "/documents/" + action
                );
                restoreDetails.restoredItem = "item restore";
            } else if (type === "folder") {
                queryString = this.state.selectItem.getFolders.replace(
                    "/folders?parentId=Root",
                    "/folders/" + this.state.selectedFolder.id + "/" + action
                );
                restoreDetails.restoredItem = "folder restore";
            } else if (type === "root") {
                queryString = this.state.selectItem.getFolders.replace(
                    "/folders?parentId=Root",
                    "/" + action
                );
                restoreDetails.restoredItem = "root restore";
            }
        } else if (this.state.restoreType === "vet") {
            if (type === "item") {
                if (this.state.selectedFolder.title === "Files") {
                    queryString = this.state.selectItem.getFolders.replace(
                        "/channels",
                        "/files/" + action
                    );
                } else if (this.state.selectedFolder.title === "Posts") {
                    queryString = this.state.selectItem.getFolders.replace(
                        "/channels",
                        "/posts/" + action
                    );
                } else if (this.state.selectedFolder.title === "Tabs") {
                    queryString = this.state.selectItem.getFolders.replace(
                        "/channels",
                        "/channels/" + this.state.lastClicked + "/tabs/" + action
                    );

                } else {
                    queryString = this.state.selectItem.getFolders.replace(
                        "/channels",
                        "/files/" + action
                    );
                }
                restoreDetails.restoredItem = "item restore";
            } else if (type === "folder") {
                if (!this.state.selectedFolder) {
                    queryString = this.state.selectItem.getFolders.replace(
                        "/channels",
                        "/channels/" + this.state.lastClicked + "/" + action
                    );
                }
                else if (this.state.selectedFolder.title === "Tabs") {
                    queryString = this.state.selectItem.getFolders.replace(
                        "/channels",
                        "/channels/" + this.state.lastClicked + "/tabs/" +
                        //this.state.selectedFolder.id + "/" +
                        action
                    );
                }
                else if (this.state.selectedFolder.title === "Files") {
                    queryString = this.state.selectItem.getFolders.replace(
                        "/channels",
                        //"/channels/" + this.state.lastClicked +
                        "/files/" + action
                    );
                } else if (this.state.selectedFolder.title === "Posts") {
                    queryString = this.state.selectItem.getFolders.replace(
                        "/channels",
                        //"/channels/" + this.state.lastClicked +
                        "/posts/" + action
                    );
                }
                else {
                    queryString = this.state.selectItem.getFolders.replace(
                        "/channels",
                        "/channels/" + this.state.lastClicked + "/" + action
                    );
                }
                restoreDetails.restoredItem = "folder restore";
            } else if (type === "root") {
                queryString = this.state.selectItem.getFolders.replace(
                    "/channels",
                    "/" + action
                );
            }
        }
        this.setState({ restoreDetails });
        this.setState(
            {
                restoreAction: action,
                actionType: type,
                queryString: queryString,
                largeDownload: false
            },
            () => {
                /*if (this.state.isMFA && !this.state.gettingDeviceCode) {*/
                    this.buildRestore();
                //}
            }
        );
    }

    CustomUserOption = (props, optionData) => {
        return (
            <button
                {...props}
                style={{ width: '100%' }}
                className={`select-search__option ${props.selected ? 'selected' : ''}`}
                type="button"
            >
                <OverlayTrigger
                    placement="top"
                    delay={{ show: 100, hide: 100 }}
                    overlay={
                        <Tooltip id={`tooltip-${optionData.name}`}>
                            {optionData.email}
                        </Tooltip>
                    }
                >
                    <span>{optionData.name}</span>
                </OverlayTrigger>
            </button>
        );
    };

    //CustomMailOption = (props, optionData) => {
    //    return (
    //        <button
    //            style={{ width: '100%' }}
    //            className={`select-search__option ${props.selected ? 'selected' : ''}`}
    //            onClick={(e) => props.onMouseDown(e)}
    //            onMouseDown={props.onMouseDown}
    //            onMouseEnter={props.onMouseEnter}
    //            onMouseMove={props.onMouseMove}
    //            type="button"
    //        >
    //            <OverlayTrigger
    //                placement="top"
    //                delay={{ show: 100, hide: 100 }}
    //                overlay={
    //                    <Tooltip id={`tooltip-${optionData.name}`}>
    //                        {optionData.msid}
    //                    </Tooltip>
    //                }
    //            >
    //                <span>{optionData.name}</span>
    //            </OverlayTrigger>
    //        </button>
    //    );
    //};


    //handleAnotherMailboxChange = (selectedValue) => {
    //    this.setState({ mailbox: selectedValue});
    //};

    closeMailModal(event) {
        event.preventDefault();
        this.setState({
            restoreAction: "",
            downloadModalOpen: false,
            downloading: false,
            litigation: {
                state: false,
                popUp: false,
                description: "",
                action: "",
                type: ""
            },
            /*litigation: false,*/
            litigationPopUp: false,
            verificationModalOpen: false,
            mailModalOpen: false,
            restoreModalOpen: false,
            restoreSuccess: null,
            restoring: false,
            restoreDetails: {
                restoredItem: "",
            },
        });
    }
    closesharepointRestoreToModal(event) {
        event.preventDefault();
        this.setState({
            restoreAction: "",
            downloadModalOpen: false,
            downloading: false,
            litigation: {
                state: false,
                popUp: false,
                description: "",
                action: "",
                type: ""
            },
            /*litigation: false,*/
            verificationModalOpen: false,
            mailModalOpen: false,
            openSharepointModal: false,
            restoreModalOpen: false,
            restoreSuccess: null,
            restoring: false,
            restoreDetails: {
                restoredItem: "",
            },
        });
    }

    closeToAnotherMailBoxRestoreToModal(event) {
        event.preventDefault();
        this.setState({
            restoreAction: "",
            downloadModalOpen: false,
            downloading: false,
            litigation: {
                state: false,
                popUp: false,
                description: "",
                action: "",
                type: ""
            },
            /*litigation: false,*/
            verificationModalOpen: false,
            mailModalOpen: false,
            toAnotherMailboxOpen: false,
            restoreModalOpen: false,
            restoreSuccess: null,
            restoring: false,
            restoreDetails: {
                restoredItem: "",
            },
        });
    }

    closeOneDriveRestoreToModal(event) {
        event.preventDefault();
        this.setState({
            restoreAction: "",
            downloadModalOpen: false,
            downloading: false,
            litigation: {
                state: false,
                popUp: false,
                description: "",
                action: "",
                type: ""
            },
            /*litigation: false,*/
            verificationModalOpen: false,
            mailModalOpen: false,
            showoneDriveModal: false,
            restoreModalOpen: false,
            restoreSuccess: null,
            restoring: false,
            restoreDetails: {
                restoredItem: "",
            },
        });
    } 

    mailContinue(event) {
        event.preventDefault();
        this.setState(
            {
                mailModalOpen: false,
                restoreModalOpen: true,
                restoring: true,
            },
            () => {
                this.buildRestore(null);
            }
        );
    }

    async anotherMailBox(event, type) {
                this.setState({
                    toAnotherMailboxOpen: true,
                    type: type
                });
    }
    exchangeRestoreToContinue(event) {
        event.preventDefault();
        this.setState(
            {
                toAnotherMailboxOpen: false,
                //  restoreModalOpen: true,
                //   restoring: true,
            },
            () => {
                // this.buildRestore(null);
                this.openVerificationModal(event, "restoreTo", this.state.type);
            }
        );
    }
    sharepointRestoreToContinue(event) {
        event.preventDefault();
        this.setState(
            {
                openSharepointModal: false,
             //  restoreModalOpen: true,
             //   restoring: true,
            },
            () => {
                // this.buildRestore(null);
                this.openVerificationModal(event, "restoreTo",this.state.type);
            }
        );
    }
    oneDriveRestoreToContinue(event) {
        event.preventDefault();
        this.setState(
            {
                showoneDriveModal: false,
                //  restoreModalOpen: true,
                //   restoring: true,
            },
            () => {
                // this.buildRestore(null);
                this.openVerificationModal(event, "copyTo", this.state.type);
            }
        );
    }

    closeVerificationModal(event) {
        event.preventDefault();
        this.setState({
            verificationModalOpen: false,
            gettingDeviceCode: false,
            restoreAction: "",
            downloadModalOpen: false,
            downloading: false,
            litigation: {
                state: false,
                popUp: false,
                description: "",
                action: "",
                type: ""
            },
            /*litigation: false,*/
            mailModalOpen: false,
            restoreModalOpen: false,
            restoreSuccess: null,
            restoring: false,
            restoreDetails: {
                restoredItem: "",
            },
            deviceCode: "",
            password: "",
        });
    }

    async getDeviceCode() {
        const authContext = this.props.authContext || this.context;
        const { setAuthContext } = authContext;
        var tokenString = await setAuthContext(new Date());
        this.setState(
            {
                ingettingDeviceCode: true,
                gettingDeviceCode: true,
                deviceCode: "",
            },
            () => {
                const config = {
                    headers: {
                        Authorisation: `Bearer ` + tokenString,
                        CloudCoverToken: sessionStorage.getItem('CloudCoverToken'),
                    }
                };

                let queryString = this.state.restore.links.organization.href + "/restoreDeviceCode";
                queryString = queryString.replace("https://127.0.0.1:4443/", this.state.serverPath);
                
                Axios.get(API_ROUTE + Routes.GET_RESTORE_DEVICE_CODE(this.state.orgId, encodeURIComponent(queryString)),  config)
                    .then((response) => {
                        let deviceCode = response.data;
                        this.setState({
                            deviceCode: deviceCode,
                            inProgressRight: false,
                            ingettingDeviceCode: false,
                            disableBtn: true
                        });
                        // this.deviceTokenCheck(tokenString);
                    })
                    .catch((reason) => {
                        this.setState({
                            ingettingDeviceCode: false,
                            inProgressRight: false,
                        });
                        if (reason?.response?.status === 440) {
                            window.location.href = "/TimeoutErrorHandler";
                        }
                    });
            }
        );
    }
    async deviceTokenCheck(tokenString) {
        const config = {
            headers: {
                Authorisation: `Bearer ` + tokenString,
                CloudCoverToken: sessionStorage.getItem('CloudCoverToken'),
            },
        };
        Axios.get(API_ROUTE + Routes.CHECK_DEVICE_CODE(this.state.orgId, this.state.deviceCode), config)
            .then((response) => {
                this.setState({ disableBtn: false });
            })
            .catch((reason) => {
                console.log(reason);
                if (reason?.response?.status === 440) {
                    window.location.href = "/TimeoutErrorHandler";
                }
            });
    }

    
    async getRestoreSession(tokenString) {
        const config = {
            headers: {
                Authorisation: `Bearer ` + tokenString,
                CloudCoverToken: sessionStorage.getItem('CloudCoverToken'),
            },
        };

        try {
            const response = await Axios.get(
                `${API_ROUTE}${Routes.GET_FILTERED_RESTORESESSION}/${this.state.orgId}/${this.state.username}`,
                config
            );

            this.setState({ restoreSessions: response.data, loading: false }, () => {
                if (!this.gridApi) return;

                if (response.data.length === 0) {
                    this.gridApi.setGridOption('activeOverlay', 'agNoRowsOverlay');
                    this.gridApi.setGridOption("loading", false);
                } else {
                    this.gridApi.setGridOption("loading", false);
                }
            });


        } catch (error) {
            console.error("Error fetching restore sessions:", error);
            if (this.gridApi) {
                this.gridApi.setGridOption('activeOverlay', 'agNoRowsOverlay');
            }
            else if (error?.response?.status === 440) {
                window.location.href = "/TimeoutErrorHandler";
            }
        }
    }

    async verificationContinue() {
        const authContext = this.props.authContext || this.context;
        const { setAuthContext } = authContext;
        var tokenString = await setAuthContext(new Date());
        let isDownload = false;
        isDownload = (this.state.fileName != null && this.state.fileName !== "");
        //let myTimeout;
        //if (isDownload) {
        //    myTimeout = setTimeout(function () {
        //        this.setState({ extraLargeDownload: true });
        //    }.bind(this), 120000);
        //}
        this.setState(
            {
                verificationModalOpen: false,
            },
            () => {
                let restoreJob = this.state.restoreJob;
                let queryString = this.state.queryString;
                let data = {
                    Job: restoreJob,
                    Command: "Not needed after v6 upgrade",
                    QueryString: queryString,
                    IsDownload: isDownload,
                    OrgId: this.state.orgId,
                    OrgName: this.state.tenantDomain,
                    Litigation: this.state.litigation.state,
                    LitigationDescription: this.state.litigation.description,
                };
                let timeout = 4500000;
                if (this.state.litigation.state || isDownload) {
                    this.logRestoreSession(tokenString);
                }
                if (this.state.litigation.state) {
                    /*if (this.state.litigation){*/
                    let downloadType = "zip";
                    if (this.state.command === "exporttoPst") {
                        downloadType = "pst";
                    } else if (this.state.command === "export") {
                        downloadType = "html";
                    }

                    let fileName = this.state.fileName;
                    data.DownloadType = downloadType;
                    data.FileName = fileName;

                    const config = {
                        headers: {
                            Authorisation: `Bearer ` + tokenString,
                            CloudCoverToken: sessionStorage.getItem('CloudCoverToken'),
                        },
                        timeout: timeout,
                        responseType: "blob",
                    };
                    Axios.post(API_ROUTE + Routes.LITIGATION_HOLD, data, config)
                        .then((response) => {
                            this.overlayProgress(false);
                            this.setState({
                                inProgressRight: false,
                                mailModalOpen: false,
                                deviceCode: "",
                                verificationModalOpen: false,
                                selectedItems: [],
                                downloading: false,
                                //restoring: false,
                                extraLargeDownload: false,
                            });
                        })
                        .catch((reason) => {
                            this.setState({
                                inProgressRight: false,
                                mailModalOpen: false,
                                verificationModalOpen: false,
                                downloading: false,
                                litigation: {
                                    state: false,
                                    popUp: false,
                                    description: "",
                                    action: "",
                                    type: ""
                                },
                                /*litigation: false,*/
                                deviceCode: "",
                                //restoring: false,
                                selectedItems: [],
                                extraLargeDownload: false,
                                errorMessage: reason.response.data.message,
                            });
                            if (reason?.response?.status === 440) {
                                window.location.href = "/TimeoutErrorHandler";
                            }
                        });
                }
                else if (isDownload) {
                    let downloadType = "zip";
                    if (this.state.command === "exporttoPst") {
                        downloadType = "pst";
                    } else if (this.state.command === "export") {
                        downloadType = "html";
                    }
                    let _sessionID = this.state.sessionid;
                    let sessionId = _sessionID.split('/')
                    data.RestoreId = sessionId[sessionId.length - 1]
                    let fileName = this.state.fileName;
                    data.DownloadType = downloadType;
                    data.FileName = fileName;

                    const config = {
                        headers: {
                            Authorisation: `Bearer ` + tokenString,
                            CloudCoverToken: sessionStorage.getItem('CloudCoverToken'),
                        },
                        timeout: timeout,
                        responseType: "blob",
                    };
                    this.setState({
                        selectedItems: [],
                    });

                    if (this.state.restoreType === "vex" || this.state.restoreType === "veod" || this.state.restoreType === "vesp") {
                        data = {
                            Job: this.state.restoreJob,
                            OrgId: this.state.orgId,
                            OrgName: this.state.tenantDomain,
                            DownloadType: downloadType,
                            FileName: fileName
                        };
                        let endPoint = "";
                        if (this.state.restoreType === "vex") {
                            endPoint = Routes.RESTORE + this.state.restore.id + "/" + Routes.MAILBOX_DOWNLOAD;
                        }
                        else if (this.state.restoreType === "veod") {
                            endPoint = Routes.RESTORE + this.state.restore.id + "/" + Routes.ONEDRIVE_DOWNLOAD;
                        }
                        else if (this.state.restoreType === "vesp") {
                            endPoint = Routes.RESTORE + this.state.restore.id + "/" + Routes.SHAREPOINT_DOWNLOAD;
                        }
                        let actionType = this.state.actionType;
                        if (this.state.actionType === "folder") {
                            data.FolderId = this.state.selectedFolder.id
                            actionType = "folder"
                        }
                        if (this.state.restoreType === "vesp") {
                            if (this.state.actionType === "item") {

                                actionType = "item";
                            }
                            else {

                                if (this.state.lastClicked.toLowerCase().includes("libraries") && this.state.selectedFolder.isContainerRoot) {
                                    actionType = "libraries";
                                }
                                else if (this.state.lastClicked.toLowerCase().includes("subsites")) {
                                    actionType = "subsites";
                                }
                                else if (this.state.lastClicked.toLowerCase().includes("lists") && this.state.selectedFolder.isContainerRoot) {
                                    actionType = "lists";
                                }
                            }
                        }
                        let selectedItem = this.state.restoreType === "vesp" ? this.state.siteId : this.state.selectItem.id;
                        Axios.post(API_ROUTE + endPoint + "/" + selectedItem + "/" + actionType, data, config)
                            .then((response) => {
                                this.overlayProgress(false);
                                this.setState({
                                    inProgressRight: false,
                                    mailModalOpen: false,
                                    deviceCode: "",
                                    verificationModalOpen: false,
                                    downloading: false,
                                    extraLargeDownload: false,
                                });

                                // Task 14 — a PST export now returns 202 Accepted: the work has been
                                // QUEUED, not completed. OneDrive and SharePoint downloads on this
                                // same path still return 200 and are unchanged, so this is gated on
                                // the status code rather than on the restore type.
                                if (response.status === 202) {
                                    this.setState({
                                        pstExportMessage: "PST export in progress. We will email you when your files are ready.",
                                    });
                                    this.pollPstExportStatus();
                                    this.startPstExportPolling();
                                }
                            })
                            .catch(async (reason) => {
                                // The request is sent with responseType "blob", so an error body
                                // arrives as a Blob and reason.response.data.message is undefined.
                                // Without reading it back as text the user is shown nothing at all.
                                let message = "";
                                try {
                                    const body = reason?.response?.data;
                                    if (body instanceof Blob) {
                                        const text = await body.text();
                                        message = text ? (JSON.parse(text).message || "") : "";
                                    } else {
                                        message = body?.message || "";
                                    }
                                } catch {
                                    message = "";
                                }

                                // Task 14 — 409 is the duplicate rule doing its job, not a failure.
                                if (reason?.response?.status === 409) {
                                    message = message || "An export is already in progress for this mailbox";
                                }

                                this.setState({
                                    inProgressRight: false,
                                    mailModalOpen: false,
                                    verificationModalOpen: false,
                                    downloading: false,
                                    litigation: {
                                        state: false,
                                        popup: false,
                                        description: "",
                                        action: "",
                                        type: ""
                                    },
                                    deviceCode: "",
                                    extraLargeDownload: false,
                                    errorMessage: message,
                                });

                                // An export is already running, so the indicator belongs on screen.
                                if (reason?.response?.status === 409) {
                                    this.pollPstExportStatus();
                                    this.startPstExportPolling();
                                }

                                if (reason?.response?.status === 440) {
                                    window.location.href = "/TimeoutErrorHandler";
                                }
                            });
                    }
                    else if (this.state.restoreType === "vet" && this.state.actionType === "item" && this.state.selectedFolder.title === "Files") {
                        data = {
                            Job: this.state.restoreJob,
                            OrgId: this.state.orgId,
                            OrgName: this.state.tenantDomain,
                            DownloadType: downloadType,
                            FileName: fileName
                        };
                        let actionType = this.state.actionType;
                        if (this.state.selectedFolder.title === "Files") {
                            actionType = "files";
                        }
                        Axios.post(API_ROUTE + Routes.RESTORE + this.state.restore.id + "/" + Routes.TEAMS_DOWNLOAD + "/" + this.state.selectItem.id + "/" + actionType, data, config)
                            .then((response) => {
                                this.overlayProgress(false);
                                this.setState({
                                    inProgressRight: false,
                                    mailModalOpen: false,
                                    deviceCode: "",
                                    verificationModalOpen: false,
                                    downloading: false,
                                    extraLargeDownload: false,
                                });
                            })
                            .catch((reason) => {
                                this.setState({
                                    inProgressRight: false,
                                    mailModalOpen: false,
                                    verificationModalOpen: false,
                                    downloading: false,
                                    litigation: {
                                        state: false,
                                        popup: false,
                                        description: "",
                                        action: "",
                                        type: ""
                                    },
                                    deviceCode: "",
                                    extraLargeDownload: false,
                                    errorMessage: reason.response.data.message,
                                });
                                if (reason?.response?.status === 440) {
                                    window.location.href = "/TimeoutErrorHandler";
                                }
                            });
                    }
                    else {
                        Axios.post(API_ROUTE + Routes.COMPLETE_RESTORE, data, config)
                            .then((response) => {
                                this.overlayProgress(false);
                                //let saveType = fileName.includes(".zip") ? "application/zip" : fileName.includes(".pst") ? "application/vnd.ms-outlook" : fileName.includes(".html") ? "text/html" : "";
                                //if (response.headers["content-type"].includes("vnd.ms-outlook-msg")) {
                                //    saveType = "application/vnd.ms-outlook";
                                //    fileName = "exchange-file.msg";
                                //}

                                //var blob = new Blob([response.data], {
                                //    type: saveType,
                                //});
                                //clearTimeout(myTimeout);

                                //saveAs(blob, fileName);
                                // this.logRestoreSession(tokenString);
                                this.setState({
                                    inProgressRight: false,
                                    mailModalOpen: false,
                                    deviceCode: "",
                                    verificationModalOpen: false,
                                    // selectedItems: [],
                                    downloading: false,
                                    //restoring: false,
                                    extraLargeDownload: false,
                                });
                            })
                            .catch((reason) => {
                                this.setState({
                                    inProgressRight: false,
                                    mailModalOpen: false,
                                    verificationModalOpen: false,
                                    downloading: false,
                                    litigation: {
                                        state: false,
                                        popup: false,
                                        description: "",
                                        action: "",
                                        type: ""
                                    },
                                    /*litigation: false,*/
                                    deviceCode: "",
                                    //restoring: false,
                                    // selectedItems: [],
                                    extraLargeDownload: false,
                                    errorMessage: reason.response.data.message,
                                });
                                if (reason?.response?.status === 440) {
                                    window.location.href = "/TimeoutErrorHandler";
                                }
                            });
                    }


                }
                else if (this.state.restoreType === "vex" && (this.state.restoreAction === "restoreTo" || this.state.restoreAction === "sendtoDefaultaddress" || this.state.restoreAction === "sendtoDifferentaddress" || this.state.restoreAction === "restore")) {
                    const config = {
                        headers: {
                            Authorisation: `Bearer ` + tokenString,
                            CloudCoverToken: sessionStorage.getItem('CloudCoverToken'),
                        },
                    };
                    this.setState({
                        selectedItems: [],
                    });
                    data = {
                        Job: this.state.restoreJob,
                        OrgId: this.state.orgId,
                        OrgName: this.state.tenantDomain
                    };
                    if (this.state.actionType === "folder") {
                        data.FolderId = this.state.selectedFolder.id
                    }
                    let endPoint = "";
                    if (this.state.restoreAction === "restoreTo") {
                        endPoint = Routes.RESTORE + this.state.restore.id + "/" + Routes.MAILBOX_ANOTHER_LOCATION + "/" + this.state.selectItem.id + "/" + this.state.actionType;
                    }
                    else if (this.state.restoreAction === "sendtoDefaultaddress") {
                        endPoint = Routes.RESTORE + this.state.restore.id + "/" + Routes.MAILBOX_MAILTO_OWNER + "/" + this.state.selectItem.id;
                    }
                    else if (this.state.restoreAction === "sendtoDifferentaddress") {
                        endPoint = Routes.RESTORE + this.state.restore.id + "/" + Routes.MAILBOX_MAILTO_SOMEONE + "/" + this.state.selectItem.id;
                    }
                    else if (this.state.restoreAction === "restore") {
                        endPoint = Routes.RESTORE + this.state.restore.id + "/" + Routes.MAILBOX_ORIGINAL_LOCATION + "/" + this.state.selectItem.id + "/" + this.state.actionType;
                    }
                    Axios.post(API_ROUTE + endPoint, data, config)
                        .then((response) => {
                            this.overlayProgress(false);
                            this.setState({
                                restoreSuccess: response.data,
                                inProgressRight: false,
                                mailModalOpen: false,
                                verificationModalOpen: false,
                                downloading: false,
                                deviceCode: "",
                            });
                        })
                        .catch((reason) => {
                            this.setState({
                                inProgressRight: false,
                                mailModalOpen: false,
                                verificationModalOpen: false,
                                deviceCode: "",
                                downloading: false,
                                litigation: {
                                    state: false,
                                    popUp: false,
                                    description: "",
                                    action: "",
                                    type: ""
                                },
                                restoreDetails: {
                                    restoredItem: "",
                                },
                            });
                            if (reason?.response?.status === 440) {
                                window.location.href = "/TimeoutErrorHandler";
                            }
                        });
                }
                else if (this.state.restoreType === "veod" && (this.state.restoreAction === "copyTo" || this.state.restoreAction === "send" || this.state.restoreAction === "restore")) {
                    const config = {
                        headers: {
                            Authorisation: `Bearer ` + tokenString,
                            CloudCoverToken: sessionStorage.getItem('CloudCoverToken'),
                        },
                    };
                    this.setState({
                        selectedItems: [],
                    });
                    data = {
                        Job: this.state.restoreJob,
                        OrgId: this.state.orgId,
                        OrgName: this.state.tenantDomain
                    };
                    if (this.state.actionType === "folder") {
                        data.FolderId = this.state.selectedFolder.id
                    }
                    let endPoint = "";
                    if (this.state.restoreAction === "copyTo") {
                        endPoint = Routes.RESTORE + this.state.restore.id + "/" + Routes.ONEDRIVE_ANOTHER_LOCATION + "/" + this.state.selectItem.id + "/" + this.state.actionType;
                    }
                    else if (this.state.restoreAction === "send") {
                        endPoint = Routes.RESTORE + this.state.restore.id + "/" + Routes.ONEDRIVE_MAILTO_SOMEONE + "/" + this.state.selectItem.id + "/" + this.state.actionType;
                    }
                    else if (this.state.restoreAction === "restore") {
                        endPoint = Routes.RESTORE + this.state.restore.id + "/" + Routes.ONEDRIVE_ORIGINAL_LOCATION + "/" + this.state.selectItem.id + "/" + this.state.actionType;
                    }
                    Axios.post(API_ROUTE + endPoint, data, config)
                        .then((response) => {
                            this.overlayProgress(false);
                            this.setState({
                                restoreSuccess: response.data,
                                inProgressRight: false,
                                mailModalOpen: false,
                                verificationModalOpen: false,
                                downloading: false,
                                deviceCode: "",
                            });
                        })
                        .catch((reason) => {
                            this.setState({
                                inProgressRight: false,
                                mailModalOpen: false,
                                verificationModalOpen: false,
                                deviceCode: "",
                                downloading: false,
                                litigation: {
                                    state: false,
                                    popUp: false,
                                    description: "",
                                    action: "",
                                    type: ""
                                },
                                restoreDetails: {
                                    restoredItem: "",
                                },
                            });
                            if (reason?.response?.status === 440) {
                                window.location.href = "/TimeoutErrorHandler";
                            }
                        });
                }
                else if (this.state.restoreType === "vesp" && (this.state.restoreAction === "copyTo" || this.state.restoreAction === "send" || this.state.restoreAction === "restore")) {
                    const config = {
                        headers: {
                            Authorisation: `Bearer ` + tokenString,
                            CloudCoverToken: sessionStorage.getItem('CloudCoverToken'),
                        },
                    };
                    this.setState({
                        selectedItems: [],
                    });
                    data = {
                        Job: this.state.restoreJob,
                        OrgId: this.state.orgId,
                        OrgName: this.state.tenantDomain
                    };
                    let actionType = this.state.actionType;
                    if (this.state.actionType === "folder") {
                        data.FolderId = this.state.selectedFolder.id
                        actionType = "folder";

                        if (this.state.lastClicked.toLowerCase().includes("libraries") && this.state.selectedFolder.isContainerRoot) {
                            actionType = "libraries";
                        }
                        else if (this.state.lastClicked.toLowerCase().includes("subsites")) {
                            actionType = "subsites";
                        }
                        else if (this.state.lastClicked.toLowerCase().includes("lists") && this.state.selectedFolder.isContainerRoot) {
                            actionType = "lists";
                        }
                     }

                    let endPoint = "";
                    let isType = true;
                    if (this.state.restoreAction === "copyTo") {
                        endPoint = Routes.RESTORE + this.state.restore.id + "/" + Routes.SHAREPOINT_ANOTHER_LOCATION + "/" + this.state.siteId + "/" + actionType;
                    }
                    else if (this.state.restoreAction === "send") {
                        endPoint = Routes.RESTORE + this.state.restore.id + "/" + Routes.SHAREPOINT_MAILTO_SOMEONE + "/" + this.state.siteId + "/" + actionType;
                    }
                    else if (this.state.restoreAction === "restore") {
                        endPoint = Routes.RESTORE + this.state.restore.id + "/" + Routes.SHAREPOINT_ORIGINAL_LOCATION + "/" + this.state.siteId + "/" + actionType;
                    }
                    else {
                        isType = false;
                    }
                    if (isType) {
                        Axios.post(API_ROUTE + endPoint, data, config)
                            .then((response) => {
                                this.overlayProgress(false);
                                this.setState({
                                    restoreSuccess: response.data,
                                    inProgressRight: false,
                                    mailModalOpen: false,
                                    verificationModalOpen: false,
                                    downloading: false,
                                    deviceCode: "",
                                });
                            })
                            .catch((reason) => {
                                this.setState({
                                    inProgressRight: false,
                                    mailModalOpen: false,
                                    verificationModalOpen: false,
                                    deviceCode: "",
                                    downloading: false,
                                    litigation: {
                                        state: false,
                                        popUp: false,
                                        description: "",
                                        action: "",
                                        type: ""
                                    },
                                    restoreDetails: {
                                        restoredItem: "",
                                    },
                                });
                                if (reason?.response?.status === 440) {
                                    window.location.href = "/TimeoutErrorHandler";
                                }
                            });
                    }
                    else {
                        const config = {
                            headers: {
                                Authorisation: `Bearer ` + tokenString,
                                CloudCoverToken: sessionStorage.getItem('CloudCoverToken'),
                            },
                        };
                        this.setState({
                            selectedItems: [],
                        });
                        Axios.post(API_ROUTE + Routes.COMPLETE_RESTORE, data, config)
                            .then((response) => {
                                this.overlayProgress(false);
                                //this.logRestoreSession(tokenString);
                                this.setState({
                                    restoreSuccess: response.data,
                                    inProgressRight: false,
                                    mailModalOpen: false,
                                    verificationModalOpen: false,
                                    //  selectedItems: [],
                                    downloading: false,
                                    deviceCode: "",
                                    //restoring: false,
                                });
                            })
                            .catch((reason) => {
                                this.setState({
                                    inProgressRight: false,
                                    mailModalOpen: false,
                                    verificationModalOpen: false,
                                    //  selectedItems: [],
                                    deviceCode: "",
                                    downloading: false,
                                    litigation: {
                                        state: false,
                                        popUp: false,
                                        description: "",
                                        action: "",
                                        type: ""
                                    },
                                    /*litigation: false,*/
                                    //restoring: false,
                                    restoreDetails: {
                                        restoredItem: "",
                                    },
                                });
                                if (reason?.response?.status === 440) {
                                    window.location.href = "/TimeoutErrorHandler";
                                }
                            });
                    }
                    
                }
                else if (this.state.restoreType === "vet" && (this.state.restoreAction === "send" || this.state.restoreAction === "restore")) {
                    const config = {
                        headers: {
                            Authorisation: `Bearer ` + tokenString,
                            CloudCoverToken: sessionStorage.getItem('CloudCoverToken'),
                        },
                    };
                    this.setState({
                        selectedItems: [],
                    });
                    data = {
                        Job: this.state.restoreJob,
                        OrgId: this.state.orgId,
                        OrgName: this.state.tenantDomain
                    };
                    let isType = true;
                    let actionType = this.state.actionType;
                    if (this.state.actionType === "folder") {
                        if (this.state.selectedFolder.title === "Posts") {
                            data.FolderId = this.state.selectedFolder.id
                            actionType = "posts";
                        }
                        else if (this.state.selectedFolder.title === "Files") {
                            data.FolderId = this.state.selectedFolder.id
                            actionType = "files";
                        }
                        else if (this.state.selectedFolder.title === "Tabs") {
                            data.FolderId = this.state.selectedFolder.id.replace(/tabs+$/, "");
                            actionType = "tabs";
                        }
                        else {
                            data.FolderId = this.state.selectedFolder.id
                            actionType = "folder";
                        }
                        
                    }
                    if (this.state.actionType === "item") {
                        if (this.state.selectedFolder.title === "Posts") {
                            data.FolderId = this.state.selectedFolder.id
                            actionType = "posts";
                        }
                        else if (this.state.selectedFolder.title === "Files") {
                            data.FolderId = this.state.selectedFolder.id
                            actionType = "files";
                        }
                        else if (this.state.selectedFolder.title === "Tabs") {//
                            data.FolderId = this.state.selectedFolder.id.replace(/tabs+$/, "");
                            actionType = "tabs";
                        }
                    }
                    let endPoint = "";
                    if (this.state.restoreAction === "send") {
                        endPoint = Routes.RESTORE + this.state.restore.id + "/" + Routes.TEAMS_MAILTO_SOMEONE + "/" + this.state.selectItem.id + "/" + actionType;
                    }
                    else if (this.state.restoreAction === "restore") {
                        endPoint = Routes.RESTORE + this.state.restore.id + "/" + Routes.TEAMS_ORIGINAL_LOCATION + "/" + this.state.selectItem.id + "/" + actionType
                    }
                    else {
                        isType = false;
                    }
                    if (isType) {
                        Axios.post(API_ROUTE + endPoint, data, config)
                            .then((response) => {
                                this.overlayProgress(false);
                                this.setState({
                                    restoreSuccess: response.data,
                                    inProgressRight: false,
                                    mailModalOpen: false,
                                    verificationModalOpen: false,
                                    downloading: false,
                                    deviceCode: "",
                                });
                            })
                            .catch((reason) => {
                                this.setState({
                                    inProgressRight: false,
                                    mailModalOpen: false,
                                    verificationModalOpen: false,
                                    deviceCode: "",
                                    downloading: false,
                                    litigation: {
                                        state: false,
                                        popUp: false,
                                        description: "",
                                        action: "",
                                        type: ""
                                    },
                                    restoreDetails: {
                                        restoredItem: "",
                                    },
                                });
                                if (reason?.response?.status === 440) {
                                    window.location.href = "/TimeoutErrorHandler";
                                }
                            });
                    }
                    else {
                        const config = {
                            headers: {
                                Authorisation: `Bearer ` + tokenString,
                                CloudCoverToken: sessionStorage.getItem('CloudCoverToken'),
                            },
                        };
                        this.setState({
                            selectedItems: [],
                        });
                        Axios.post(API_ROUTE + Routes.COMPLETE_RESTORE, data, config)
                            .then((response) => {
                                this.overlayProgress(false);
                                //this.logRestoreSession(tokenString);
                                this.setState({
                                    restoreSuccess: response.data,
                                    inProgressRight: false,
                                    mailModalOpen: false,
                                    verificationModalOpen: false,
                                    //  selectedItems: [],
                                    downloading: false,
                                    deviceCode: "",
                                    //restoring: false,
                                });
                            })
                            .catch((reason) => {
                                this.setState({
                                    inProgressRight: false,
                                    mailModalOpen: false,
                                    verificationModalOpen: false,
                                    //  selectedItems: [],
                                    deviceCode: "",
                                    downloading: false,
                                    litigation: {
                                        state: false,
                                        popUp: false,
                                        description: "",
                                        action: "",
                                        type: ""
                                    },
                                    /*litigation: false,*/
                                    //restoring: false,
                                    restoreDetails: {
                                        restoredItem: "",
                                    },
                                });
                                if (reason?.response?.status === 440) {
                                    window.location.href = "/TimeoutErrorHandler";
                                }
                            });
                    }
                    
                }
                else {
                    const config = {
                        headers: {
                            Authorisation: `Bearer ` + tokenString,
                            CloudCoverToken: sessionStorage.getItem('CloudCoverToken'),
                        },
                    };
                    this.setState({
                        selectedItems: [],
                    });
                    Axios.post(API_ROUTE + Routes.COMPLETE_RESTORE, data, config)
                        .then((response) => {
                            this.overlayProgress(false);
                            //this.logRestoreSession(tokenString);
                            this.setState({
                                restoreSuccess: response.data,
                                inProgressRight: false,
                                mailModalOpen: false,
                                verificationModalOpen: false,
                                //  selectedItems: [],
                                downloading: false,
                                deviceCode: "",
                                //restoring: false,
                            });
                        })
                        .catch((reason) => {
                            this.setState({
                                inProgressRight: false,
                                mailModalOpen: false,
                                verificationModalOpen: false,
                                //  selectedItems: [],
                                deviceCode: "",
                                downloading: false,
                                litigation: {
                                    state: false,
                                    popUp: false,
                                    description: "",
                                    action: "",
                                    type: ""
                                },
                                /*litigation: false,*/
                                //restoring: false,
                                restoreDetails: {
                                    restoredItem: "",
                                },
                            });
                            if (reason?.response?.status === 440) {
                                window.location.href = "/TimeoutErrorHandler";
                            }
                        });
                }
            }
        );
    }

    logRestoreSession(token) {
        const config = {
            headers: {
                Authorisation: `Bearer ` + token,
                CloudCoverToken: sessionStorage.getItem('CloudCoverToken'),
            },
        };
        let _sessionID = this.state.sessionid;
        let sessionId = _sessionID.split('/')

        let data = {
            RestoreId: sessionId[sessionId.length - 1],
            OrgId: this.state.orgId
        };
        Axios.post(API_ROUTE + Routes.LOG_RESTORESESSION, data, config)
            .then((response) => {
                console.log('log successfull')
             /*  if (response.data.toLowerCase() === "success" || response.data.toLowerCase() === "fail") {

                    const status = response.data.toLowerCase();
                    if (status === "success" || status === "fail") {
                        const isSuccess = status === "success"; // Convert to boolean
                        this.sendEmailNotification(token,isSuccess);
                        console.log('Email notification triggered');
                    }
                }*/
            })
            .catch((reason) => {
                console.log('error occured')
                if (reason?.response?.status === 440) {
                    window.location.href = "/TimeoutErrorHandler";
                }
            });
    }
    async sendEmailNotification(token, isSuccess) {
        const { restoreDetails } = this.state;
        const authContext = this.props.authContext || this.context;
        const { setAuthContext } = authContext;
        var tokenString = await setAuthContext(new Date());
        const config = {
            headers: {
                Authorisation: `Bearer ` + tokenString,
                CloudCoverToken: sessionStorage.getItem('CloudCoverToken'),
            },
        };
        if (restoreDetails && restoreDetails.restoredItem) {

            const payload = {
                restoredItem: restoreDetails.restoredItem
            };

            Axios.post(`${API_ROUTE + Routes.RESTORE_SEND_EMAIL}?isSuccess=${isSuccess}`, payload, config)
                .then((response) => {
                    console.log("Email sent successfully:", response.data);
                })
                .catch((error) => {
                    console.error("Failed to send email:", error);
                });
        }
    }
    handleRowClick = async (event) => {
        const sessionData = event.data;
        const eventsUrl = sessionData.links.restoreSessionEvents.href;
        this.setState({ currentEventsUrl: eventsUrl, isSelectedSessionEventsLoaded: false });
        const authContext = this.props.authContext || this.context;
        const { setAuthContext } = authContext;
        var tokenString = await setAuthContext(new Date());
        if (this.state.restoreSessionGridApi) {
            this.state.restoreSessionGridApi.setGridOption("loading", true);
        }
        try {
            let _sessionID = eventsUrl;
            let sessionId = _sessionID.split('/')
            let RestoreId = eventsUrl.split('/')[sessionId.indexOf('restoresessions') + 1]
            const config = {
                headers: {
                    Authorisation: `Bearer ` + tokenString,
                    CloudCoverToken: sessionStorage.getItem('CloudCoverToken'),
                },
            };
            const response = await Axios.get(
                `${API_ROUTE + Routes.RESTORESESSION_EVENT_LIST}/${this.state.orgId}/${RestoreId}`,
                config
            );

            let responseData = JSON.parse(response.data);
            responseData = responseData.map(value => ({
                ...value,
                message: value.message.replace(/(target: )([A-Za-z]:\\)?[^\\]*\\(SystemTemp\\)/, '$1$3')
            }));
            
                this.setState({
                    allSessionEvents: responseData,
                    filters: { success: true, warnings: true, errors: true },
                    selectedSessionEvents: responseData || [],
                    isSelectedSessionEventsLoaded: true
                },
                    () => {
                        if (this.state.restoreSessionGridApi) {
                            this.state.restoreSessionGridApi.setGridOption("loading", false);
                            this.state.restoreSessionGridApi.setGridOption('rowData', responseData);
                        }
                    }
                );
        } catch (reason) {
            if (reason?.response?.status === 440) {
                window.location.href = "/TimeoutErrorHandler";
            }
            toast.error('Error fetching the data', { autoClose: 10000 });
            this.setState({
                selectedSessionEvents: [],
                isSelectedSessionEventsLoaded: true
            });
            if (this.state.restoreSessionGridApi) {
                this.state.restoreSessionGridApi.setGridOption("loading", false);
            }
        }
    };
    refreshSessionEventClick = async () => {
        const url = this.state.currentEventsUrl
        const authContext = this.props.authContext || this.context;
        const { setAuthContext } = authContext;
        this.setState({
            isSelectedSessionEventsLoaded: false
        });
        var tokenString = await setAuthContext(new Date());
        if (this.state.restoreSessionGridApi) {
            this.state.restoreSessionGridApi.setGridOption("loading", true);
        }
        try {
            let _sessionID = url;
            let sessionId = _sessionID.split('/')
            let RestoreId = url.split('/')[sessionId.indexOf('restoresessions') + 1]
            const config = {
                headers: {
                    Authorisation: `Bearer ` + tokenString,
                    CloudCoverToken: sessionStorage.getItem('CloudCoverToken'),
                },
            };
            const response = await Axios.get(
                `${API_ROUTE + Routes.RESTORESESSION_EVENT_LIST}/${this.state.orgId}/${RestoreId}`,
                config
            );
            let responseData = JSON.parse(response.data);
            responseData = responseData.map(value => ({
                ...value,
                message: value.message.replace(/(target: )([A-Za-z]:\\)?[^\\]*\\(SystemTemp\\)/, '$1$3')
            }));
            this.setState({
                allSessionEvents: responseData,
                filters: { success: true, warnings: true, errors: true },
                selectedSessionEvents: responseData || [],
                isSelectedSessionEventsLoaded:true
            },
                () => {
                    if (this.state.restoreSessionGridApi) {
                        this.state.restoreSessionGridApi.setGridOption("loading", false);
                        this.state.restoreSessionGridApi.setGridOption('rowData', responseData);
                    }
                }
            );
        } catch (reason) {
            if (reason?.response?.status === 440) {
                window.location.href = "/TimeoutErrorHandler";
            }
            toast.error('Error fetching the data', { autoClose: 10000 });
            this.setState({
                selectedSessionEvents: [],
                isSelectedSessionEventsLoaded: true
            });
            if (this.state.restoreSessionGridApi) {
                this.state.restoreSessionGridApi.setGridOption("loading", false);
            }
        }
    };

    buildRestore(event) {
        if (event) {
            event.preventDefault();
        }
        let restoreType = "";
        let restoreAction = this.state.restoreAction;
        let actionType = this.state.actionType;
        switch (this.state.restoreType) {
            case "vex":
                restoreType = "mailboxes";
                break;
            case "veod":
                restoreType = "onedrives";
                break;
            case "vesp":
                restoreType = "sites";
                break;
            case "vet":
                restoreType = "teams";
                break;
            default:
                break;
        }
        let restoreString = restoreType + "-" + actionType + "-" + restoreAction;
        let restoreJob = {};
        let restoreToCopyToType = "";
        let username = this.state.username;
        let items = [];
        ////let folders = [];
        ////let restoreToOrginalLocation = false;
        let command = "";
        ////let successMessage = "";
        let outputFile;
        this.state.selectedItems.forEach((item) => {
            if (item.id)
            {
                if (restoreType==="teams") {
                    
                    items.push({
                        Id: item.id.toString(),
                        ChannelId: this.state.lastClicked
                    });
                } else {
                   
                    items.push({ Id: item.id.toString() });
                }
}
        });
        switch (restoreString) {
            case "teams-item-save":
                restoreJob.Files = items;
               // restoreJob.channelId = this.state.lastClicked;
                command = "save";
                outputFile = "Teams-files.zip";
                break;
            case "teams-item-export":
                let postItems = [];
                this.state.selectedItems.forEach((item) => {
                    postItems.push({ PostId: item.postId.toString() });
                });
                restoreJob.posts = postItems;
                restoreJob.channelId = this.state.lastClicked;
                command = "export";
                outputFile = "Teams-Posts.html";
                break;
            case "teams-foder-restore":
                ////restoreToOrginalLocation = true;
                //restoreJob.userName = username;
                restoreJob.ChangedItems = true;
                restoreJob.DeletedItems = false;
                restoreJob.RestoreListViews = true;
                restoreJob.channelId = this.state.lastClicked;
                //restoreJob.List = RestoreSelection[5];
                restoreJob.DocumentVersion = "last";
                restoreJob.DocumentLastVersionAction = "Merge";
                restoreJob.RestorePermissions = "true";
                restoreJob.SendSharedLinksNotification = "false";
                restoreJob.RestoreChangedItems = true;
                command = "restoreto";
                break;
            case "teams-item-restore":
            case "teams-folder-restore":
                ////restoreToOrginalLocation = true;
                //restoreJob.usercode = this.state.deviceCode;

                //restoreJob.channelId = this.state.lastClicked;
                if (!this.state.selectedFolder ) {
                    restoreJob.channelId = this.state.lastClicked;
                    //restoreJob.userName = username;
                    restoreJob.RestoreChangedItems = true;
                    restoreJob.RestoreMissingItems = true;
                    restoreJob.RestoreMembers = true;
                    restoreJob.RestoreSettings = true;
                    restoreJob.FileVersion = "last";
                    restoreJob.FileLastVersionAction = "overwrite";
                /*    restoreJob.ChangedItems = true;
                    restoreJob.DeletedItems = false;
                    restoreJob.RestoreListViews = true;
                    restoreJob.channelId = this.state.lastClicked;
                    //restoreJob.List = RestoreSelection[5];
                    restoreJob.DocumentVersion = "last";
                    restoreJob.DocumentLastVersionAction = "Merge";
                    restoreJob.RestorePermissions = "true";
                    restoreJob.SendSharedLinksNotification = "false";
                    restoreJob.RestoreChangedItems = true;*/
                    command = "restoreto";
                } else {
                    command = "restore";
                    if (this.state.selectedFolder.title === "Posts") {
                        //restoreJob.userName = username;
                        restoreJob.channelId = this.state.lastClicked;
                        restoreJob.posts = items;
                    } else if (this.state.selectedFolder.title === "Tabs") {
                        // restoreJob.userName = username;
                        restoreJob.channelId = this.state.lastClicked;
                            restoreJob.tabs = items;
                       
                        restoreJob.RestoreMissingTabs = true;
                        restoreJob.RestoreChangedTabs = true;
                    } else {
                        //restoreJob.userName = username;
                        restoreJob.RestoreChangedItems = true;
                        restoreJob.RestoreMissingItems = true;
                        restoreJob.RestoreMembers = true;
                        restoreJob.RestoreSettings = true;
                        restoreJob.FileVersion = "last";
                        restoreJob.FileLastVersionAction = "overwrite";
                        restoreJob.Files = items;
                        //restoreJob.ChannelId = this.state.lastClicked;
                    }
                }
                
                break;
            case "teams-root-restore":
                ////restoreToOrginalLocation = true;
                //restoreJob.usercode = this.state.deviceCode;
                //restoreJob.userName = username;
                restoreJob.RestoreChangedItems = true;
                restoreJob.RestoreMissingItems = true;
                restoreJob.RestoreMembers = true;
                restoreJob.RestoreSettings = true;
                restoreJob.FileVersion = "last";
                restoreJob.FileLastVersionAction = "overwrite";
                command = "restore";
                break;
            case "teams-item-send":
                restoreJob.to = this.state.mailSendTo;
                restoreJob.channelId = this.state.lastClicked;
                //restoreJob.from = username;
                restoreJob.subject = this.state.mailSubject;
                restoreJob.text = this.state.mailMessage;
                restoreJob.Files = items;
                command = "send";
                ////successMessage ="Selected files have been sent " + this.state.mailSendTo;
                break;
            case "sites-root-restore":
                ////restoreToOrginalLocation = true;
                //restoreJob.userName = username;
                //restoreJob.usercode = this.state.deviceCode;
                restoreJob.impersonationAccountName = sessionStorage.getItem('UserEmailID');
                restoreJob.DocumentVersion = "last";
                restoreJob.DocumentLastVersionAction = "Merge";
                restoreJob.RestorePermissions = "true";
                restoreJob.RestoreListViews = true;
                restoreJob.ChangedItems = true;
                restoreJob.DeletedItems = true;
                restoreJob.RestoreSubsites = true;
                restoreJob.RestoreMasterPages = true;
                restoreJob.SendSharedLinksNotification = "false";
                restoreJob.userName = this.state.username;
                command = "restoreto";
                break;
            case "sites-root-restoreTo":

                //restoreJob.usercode = this.state.deviceCode;
                restoreJob.impersonationAccountName = sessionStorage.getItem('UserEmailID');
                restoreJob.DocumentLastVersionAction = "Overwrite";
                restoreJob.Alias = "last";
                restoreJob.RestoreListViews = true;
                restoreJob.RestorePermissions = "true";
                restoreJob.SiteURL = this.state.siteURL;
                restoreJob.ChangedItems = true;
                restoreJob.DeletedItems = true;
                restoreJob.RestoreSubsites = true;
                restoreJob.RestoreMasterPages = true;
                restoreJob.SendSharedLinksNotification = "false";
                restoreJob.userName = this.state.username;
                restoreJob.documentVersion = "All";
                command = "restoreto";
                break;
            case "sites-item-restore":
                //restoreJob.usercode = this.state.deviceCode;
                ////restoreToOrginalLocation = true;
                //restoreJob.userName = username;
                restoreJob.ChangedItems = true;
                restoreJob.DeletedItems = true;
                restoreJob.RestoreListViews = true;
                //restoreJob.List = RestoreSelection[5];
                restoreJob.DocumentVersion = "last";
                restoreJob.DocumentLastVersionAction = "Merge";
                restoreJob.RestorePermissions = "true";
                restoreJob.SendSharedLinksNotification = "false";
                command = "restoreto";
                if (this.state.lastClicked === "Libraries") {
                    restoreJob.Documents = items;
                    restoreJob.List = this.state.listName;
                } else if (this.state.lastClicked === "Lists") {
                    restoreJob.items = items;
                    restoreJob.List = this.state.selectedFolder.title;
                }
                break;
            case "sites-item-restoreTo":
                //restoreJob.usercode = this.state.deviceCode;
                ////restoreToOrginalLocation = true;
                //restoreJob.userName = username;
                restoreJob.ChangedItems = true;
                restoreJob.DeletedItems = true;
                restoreJob.RestoreListViews = true;
                restoreJob.SiteURL = this.state.siteURL;

                //restoreJob.List = RestoreSelection[5];
                restoreJob.DocumentVersion = "last";
                restoreJob.DocumentLastVersionAction = "Merge";
                restoreJob.RestorePermissions = "true";
                restoreJob.SendSharedLinksNotification = "false";
                command = "restoreto";
                if (this.state.lastClicked === "Libraries") {
                    restoreJob.Documents = items;
                    restoreJob.List = this.state.listName;
                } else if (this.state.lastClicked === "Lists") {
                    restoreJob.items = items;
                    restoreJob.List = this.state.selectedFolder.title;
                }
                restoreToCopyToType = "vesp";
                break;
            case "sites-folder-restore":
                //restoreJob.usercode = this.state.deviceCode;
                ////restoreToOrginalLocation = true;
                //restoreJob.userName = username;
                restoreJob.impersonationAccountName = sessionStorage.getItem('UserEmailID');
                restoreJob.ChangedItems = true;
                restoreJob.DeletedItems = true;
                restoreJob.RestoreListViews = true;
                restoreJob.RestoreSubsites = true;
                restoreJob.RestoreMasterPages = true;
              
                if (this.state.lastClicked === "Libraries") {
                    restoreJob.Documents = null;
                    restoreJob.List = this.state.listName;
                } else if (this.state.lastClicked === "Lists") {
                    restoreJob.items = items;
                    restoreJob.List = this.state.selectedFolder.title;
                }
                restoreJob.DocumentVersion = "last";
                restoreJob.DocumentLastVersionAction = "Merge";
                restoreJob.RestorePermissions = "true";
                restoreJob.SendSharedLinksNotification = "false";
                command = "restoreto";
                break;
            case "sites-folder-restoreTo":
                //restoreJob.usercode = this.state.deviceCode;
                ////restoreToOrginalLocation = true;
                restoreJob.impersonationAccountName = sessionStorage.getItem('UserEmailID');
                restoreJob.SiteURL = this.state.siteURL;
                restoreJob.RestoreSubsites = true;
                restoreJob.RestoreMasterPages = true;
                restoreJob.ChangedItems = true;
                restoreJob.DeletedItems = true;
                restoreJob.RestoreListViews = true;
                if (this.state.lastClicked === "Libraries") {
                    restoreJob.Documents = null;
                    restoreJob.List = this.state.listName;
                } else if (this.state.lastClicked === "Lists") {
                    restoreJob.items = items;
                    restoreJob.List = this.state.selectedFolder.title;
                }
                restoreJob.DocumentVersion = "last";
                restoreJob.DocumentLastVersionAction = "Merge";
                restoreJob.RestorePermissions = "true";
                restoreJob.SendSharedLinksNotification = "false";
                command = "restoreto";
                restoreToCopyToType = "vesp";
                break;
            case "sites-item-send":
                restoreJob.to = this.state.mailSendTo;
                //restoreJob.from = username;
                restoreJob.subject = this.state.mailSubject;
                restoreJob.text = this.state.mailMessage;
                restoreJob.Documents = items;
                command = "sendTo";
                ////successMessage ="Selected files have been sent " + this.state.mailSendTo;
                //SetMailServer("Site");
                break;
            case "sites-folderMailto":
                restoreJob.to = this.state.mailSendTo;
                //restoreJob.from = username;
                restoreJob.subject = this.state.mailSubject;
                restoreJob.text = this.state.mailMessage;
                command = "sendTo";
                ////successMessage = "Selected files have been sent " + this.state.mailSendTo;
                //SetMailServer("Site");
                break;
            case "sites-item-save":
                restoreJob.Documents = items;
                command = "save";
                outputFile = "Sharepoint-files.zip";
                break;
            case "sites-folderexporttoLocal":
                command = "save";
                outputFile = "Sharepoint-folder.zip";
                break;
            case "mailboxes-root-restore":
                //Device code set already in GetAuthCode()
                //restoreJob.usercode = this.state.deviceCode;

                break;
            case "mailboxes-item-sendtoDefaultaddress":
                restoreJob.items = items;
                command = "sendtoDefaultaddress";
                ////successMessage = "Restored items have been sent to the owner.";
                //SetMailServer("Mail");
                break;
            case "mailboxes-item-sendtoDifferentaddress":
                /*if (CallingCommand.Value == "")
                  {
                      CallingCommand.Value = "mailboxes-Mailto";
                      //MailToPopup.Show();
                      return;
                  }*/
                restoreJob.to = this.state.mailSendTo;
                //restoreJob.from = username;
                restoreJob.subject = this.state.mailSubject;
                restoreJob.text = this.state.mailMessage;
                restoreJob.items = items;
                command = "sendtoDifferentaddress";
                ////successMessage = "Email Message have been sent " + this.state.mailSendTo;
                //SetMailServer("mail");
                break;
            case "mailboxes-restore": //mailboxes-root-restoreToOriginalLocation  
                ////restoreToOrginalLocation = true;
                // restoreJob.userName = username;
                restoreJob.items = items;
                command = "restoreToOriginalLocation";
                ////successMessage = "Selected files have been restore ";
                //CallingCommand.Value = "";
                break;
            case "mailboxes-folder-restore":
                //srestoreJob.usercode = this.state.deviceCode;

                ////restoreToOrginalLocation = true;
                //restoreJob.userName = username;
                command = "restoreToOriginalLocation";
                break;
            case "mailboxes-save":
                restoreJob.items = items;
                command = "savetoMsg";
                outputFile = "exchange-files.zip";
                break;
            case "mailboxes-sendtoDefaultaddress":
                restoreJob.items = items;
                command = "sendtoDefaultaddress";
                ////successMessage = "Restored items have been sent to the owner.";
                //SetMailServer("Mail");
                break;
            case "mailboxes-item-restore":
            case "mailboxes-item-RestoreToOriginalLocation":
                //restoreJob.usercode = this.state.deviceCode;
                ////restoreToOrginalLocation = true;
                restoreJob.items = items;
                command = "restoreToOriginalLocation";
                ////successMessage = "Selected files have been restore ";
                //CallingCommand.Value = "";
                break;
            case "mailboxes-item-save":
                restoreJob.items = items;
                command = "savetoMsg";
                outputFile = "exchange-files.zip";
                break;
            case "mailboxes-item-exporttoPst":
            case "mailboxes-root-exporttoPst":
                restoreJob.items = items;
                // Task 14 — the PST size limit is applied SERVER-SIDE by the export job; the portal
                // no longer sends it. It was hard-coded false here, which read as the portal
                // disabling splitting.
                command = "exporttoPst";
                outputFile = "exchange.pst";
                break;
            case "mailboxes-exporttoPst": //mailboxes-item-exporttoPst
                restoreJob.items = items;
                command = "exporttoPst";
                outputFile = "exchange.pst";
                break;
            case "mailboxes-folder-exporttoPst":
                command = "exporttoPst";
                outputFile = "exchange.pst";
                break;
            case "mailboxes-sendtoDifferentaddress":
                /*if (CallingCommand.Value == "")
                  {
                      CallingCommand.Value = "mailboxes-Mailto";
                      //MailToPopup.Show();
                      return;
                  }*/
                restoreJob.to = this.state.mailSendTo;
                //restoreJob.from = username;
                restoreJob.subject = this.state.mailSubject;
                restoreJob.text = this.state.mailMessage;
                restoreJob.items = items;
                command = "sendtoDifferentaddress";
                ////successMessage =  "Email Message have been sent " + this.state.mailSendTo;
                //SetMailServer("mail");
                break;
            case "mailboxes-root-restoreTo":
                restoreJob.Folder = "";
                //restoreJob.OfficeOrganizationName = "M365x02790501.OnMicrosoft.com";
                restoreJob.ChangedItems = true;
                restoreJob.DeletedItems = true;
                restoreJob.markRestoredAsUnread = true;
                restoreJob.excludeDeletedItems = false;
                restoreJob.excludeInPlaceHoldItems = false;
                restoreJob.excludeLitigationHoldItems = false;
                restoreJob.excludeDrafts = true;
                restoreJob.markRestoredAsUnread = true;
                restoreJob.mailbox = this.state.mailbox;
                restoreJob.officeOrganizationName = sessionStorage.getItem("ManageTenantDomain"); 
                restoreJob.OfficeRegion = "Worldwide";
                command = "restoreto";
                break;
            case "mailboxes-folder-restoreTo":
                restoreJob.Folder = "";
                restoreJob.ChangedItems = true;
                restoreJob.DeletedItems = true;
                restoreJob.markRestoredAsUnread = true;
                restoreJob.excludeDeletedItems = false;
                restoreJob.excludeInPlaceHoldItems = false;
                restoreJob.excludeLitigationHoldItems = false;
                restoreJob.excludeDrafts = false;
                restoreJob.markRestoredAsUnread = true;
                restoreJob.mailbox = this.state.mailbox;
                restoreJob.officeOrganizationName = sessionStorage.getItem("ManageTenantDomain"); 
                restoreJob.OfficeRegion = "Worldwide";
                command = "restoreto";
                break;
            case "mailboxes-item-restoreTo":
                restoreJob.Folder = "";
                restoreJob.ChangedItems = true;
                restoreJob.DeletedItems = true;
                restoreJob.markRestoredAsUnread = true;
                restoreJob.excludeDeletedItems = false;
                restoreJob.excludeInPlaceHoldItems = false;
                restoreJob.items = items;
                restoreJob.excludeLitigationHoldItems = false;
                restoreJob.excludeDrafts = false;
                restoreJob.markRestoredAsUnread = true;
                restoreJob.mailbox = this.state.mailbox;
                restoreJob.officeOrganizationName = sessionStorage.getItem("ManageTenantDomain"); 
                restoreJob.OfficeRegion = "Worldwide";
                command = "restoreto";
                break;
            case "onedrives-root-restore":
            case "onedrives-item-restore":
                /*restoreJob.usercode = this.state.deviceCode;*/

                ////restoreToOrginalLocation = true;
                //                restoreJob.userName = username;
                restoreJob.DocumentAction = "keep";
                restoreJob.DocumentVersion = "last";
                restoreJob.Documents = items;
                command = "restoreToOriginalLocation";
                break;
            case "onedrives-root-copyTo":
            case "onedrives-item-copyTo":
                /*restoreJob.usercode = this.state.deviceCode;*/
                restoreJob.changedItems = true;
                restoreJob.deletedItems = true;
                restoreJob.restorePermissions = "true";
                restoreJob.sendSharedLinksNotification = "true";
                restoreJob.onedrive = {
                    id: this.state.destinationOneDriveId,
                    name: this.state.destinationOneDriveUserName,
                    url: this.state.destinationOneDriveUrl,

                };
                restoreJob.folder = this.state.destinationFolder;
                restoreJob.documentVersion = "All";
                restoreJob.documentLastVersionAction = "Overwrite";

                restoreJob.Documents = items;
                command = "restoreToOriginalLocation";
                restoreToCopyToType = "veod";
                break;
            case "onedrives-folder-restore":
                //restoreJob.usercode = this.state.deviceCode;

                ////restoreToOrginalLocation = true;
                //                restoreJob.userName = username;
                restoreJob.DocumentAction = "keep";
                restoreJob.DocumentVersion = "last";
                command = "restoreToOriginalLocation";
                break;
            case "onedrives-folder-copyTo":
                //restoreJob.usercode = this.state.deviceCode;

                restoreJob.changedItems = true;
                restoreJob.deletedItems = true;
                restoreJob.restorePermissions = "true";
                restoreJob.sendSharedLinksNotification = "true";
                restoreJob.onedrive = {
                    id: this.state.destinationOneDriveId,
                    name: this.state.destinationOneDriveUserName,
                    url: this.state.destinationOneDriveUrl,

                };
                restoreJob.folder = this.state.destinationFolder;
                restoreJob.documentVersion = "All";
                restoreJob.documentLastVersionAction = "Overwrite";
                //                restoreJob.userName = username;
                restoreJob.DocumentAction = "keep";
                restoreJob.DocumentVersion = "last";
                command = "restoreToOriginalLocation";
                restoreToCopyToType = "veod";
                break;
            case "onedrives-item-save":
                restoreJob.asZip = true;
                restoreJob.Documents = items;
                command = "save";
                outputFile = "onedrive-files.zip";
                break;
            case "onedrives-folder-save":
                command = "save";
                outputFile = "onedrive-files.zip";
                break;
            case "onedrives-item-send":
                /*if (CallingCommand.Value == "")
                  {
                      CallingCommand.Value = "onedrives-Mailto";
                      //MailToPopup.Show();
                      return;
                  }*/
                restoreJob.to = this.state.mailSendTo;
                //restoreJob.from = username;
                restoreJob.subject = this.state.mailSubject;
                restoreJob.text = this.state.mailMessage;
                restoreJob.Documents = items;
                command = "sendTo";
                ////successMessage = "Selected files have been sent " + this.state.mailSendTo;
                //SetMailServer("OD");
                break;
            case "onedrives-folder-send":

                restoreJob.to = this.state.mailSendTo;
                //restoreJob.from = username;
                restoreJob.subject = this.state.mailSubject;
                restoreJob.text = this.state.mailMessage;
                command = "sendTo";
                ////successMessage = "Selected files have been sent " + this.state.mailSendTo;
                //SetMailServer("OD");
                break;
            default:
                break;
        }
       
        if (
            restoreAction === "sendtoDefaultaddress" ||
            restoreAction === "restore" || restoreAction === "restoreTo" || restoreAction ==="copyTo"
        ) {
            this.setState(
                {
                    restoreJob: restoreJob,
                    restoreAction: restoreAction,
                    command: command,
                    restoring: true,
                    restoreModalOpen: true,
                    mailFrom: username,
                    fileName: outputFile,
                },
                () => {
                    this.verificationContinue(restoreToCopyToType);
                }
            );
        } else {
            this.setState(
                {
                    restoreJob: restoreJob,
                    restoreAction: restoreAction,
                    command: command,
                    mailFrom: username,
                    fileName: outputFile,
                },
                () => {
                    this.verificationContinue(restoreToCopyToType);
                }
            );
        }
    }

    toggleDropdown(event, menu) {
        event.preventDefault();
        if (menu === "itemRestoreOpen") {
            if (this.state.searchHistoryPanelOpen) {
                this.setState((prevState) => ({
                    searchHistoryPanelOpen: false
                }));
            }

        }
        this.setState({
            [menu]: !this.state[menu],
        });
    }

    editParameter(event) {
        event.preventDefault();
        let value = event.target.value;

        let parameter = event.target.name;

        if (parameter === "destinationOneDriveUrl") {
            if (value !== "null") {

                let selectedItem = this.state.selectItems.find(site => site.email === value);
                this.setState({
                    destinationOneDriveId: selectedItem.id,
                    destinationOneDriveUserName: selectedItem.title,
                    [parameter]: value,
                });
            }
            else {
                this.setState({
                    destinationOneDriveId: "",
                    destinationOneDriveUserName: "",
                    [parameter]: "",
                });
            }

        }
        else {
            this.setState({
                [parameter]: value,
            });
        }

      
    }

    changeSearchTerm(event) {
        event.preventDefault();
        let value = event.target.value;
        this.setState({
            searchTerm: value,
        });
    }
    getSearchField = (e) => {
        if (this.state.isDateFields) {
            return (<DatePicker
                selected={this.state.searchTerm}
                minDate={this.state.firstRestoreDate}
                maxDate={this.state.lastRestoreDate}
                onChange={(date) => this.handleDateChange(date)}
                dateFormat="dd/MM/yyyy"
                style={{ maxHeight: "30px" }}
                className="mr-1 datepicker"
            />)
        }
        return (<Input
            value={this.state.searchTerm}
            onChange={this.changeSearchTerm}
            type="text"
            name="searchTerm"
            id="searchTerm"
        />)
    }

    clearSearch(event) {
        event.preventDefault();
        const oldItems = this.state.oldItems;
        const oldBlocked = this.state.oldFlag;
        const oldPage = this.state.oldPage;
        this.setState({
            viewItems: oldItems ? oldItems : [],
            gridViewItems: oldItems ? oldItems : [],
            nextBlocked: oldBlocked,
            displayPage: oldPage,
            errorMessage: "",
            //oldItems: [],
            searchResultsFlag: false,
            noResults: oldItems ? oldItems.length === 0 : false,
            searchQueries: [],
            searchType: "null",
        }, () => {
            if (this.state.gridApi) {
                this.state.gridApi.setGridOption('rowData', []);
                this.state.gridApi.refreshCells();
                this.state.gridApi.setGridOption('rowData', this.state.viewItems);
                this.state.gridApi.setGridOption('rowData', this.state.gridViewItems);
                this.state.gridApi.refreshCells();
            }
            this.resetSearchValues();
        });
    }

    async getActiveSearchList() {
        const authContext = this.props.authContext || this.context;
        const { setAuthContext } = authContext;
        var tokenString = await setAuthContext(new Date());
        const config = {
            headers: {
                Authorisation: `Bearer ` + tokenString,
                CloudCoverToken: sessionStorage.getItem('CloudCoverToken'),
            },
        };
        Axios.get(API_ROUTE + Routes.GET_ACTIVE_SEARCH_LIST(this.state.orgId, sessionStorage.getItem("UserName")), config)
            .then((response) => {
                if (response.data !== "") {
                    const data = JSON.parse(response.data);
                    const parsedData = data.map(item => ({
                        QueriesList: JSON.parse(item.QueriesList),
                        SearchCount: parseInt(item.SearchCount), 
                        SetID: item.SetID, 
                        Title: item.Title,
                        SubTitle: item.SubTitle,
                        BackUpTime: item.BackUpTime,
                        ValidTime: new Date(item.ValidTime), 
                        SearchQuery: JSON.parse(item.SearchQuery),
                        Url: item.Url,
                        Type: item.Type,
                        Status: item.Status 
                    }));
                    this.setState({

                        activeSearchList: {
                            QueriesList: parsedData.map(item => item.QueriesList),
                            SearchCount: parsedData.map(item => item.SearchCount),
                            SetID: parsedData.map(item => item.SetID),
                            Title: parsedData.map(item => item.Title),
                            SubTitle: parsedData.map(item => item.SubTitle),
                            BackUpTime: parsedData.map(item => item.BackUpTime),
                            ValidTime: parsedData.map(item => item.ValidTime),
                            SearchQuery: parsedData.map(item => item.SearchQuery),
                            Url: parsedData.map(item => item.Url),
                            Type: parsedData.map(item => item.Type),
                            Status: parsedData.map(item => item.Status) 
                        },
                        QueryHistory: data,
                        searchHistoryQueries: data.map(item => JSON.parse(item.QueriesList)),
                        searchHistoryResultCount: data.map(item => JSON.parse(item.SearchCount))
                    });
                }


            })
            .catch((reason) => {
                this.overlayProgress(false);
                console.log(reason);

                this.setState({
                    inProgressRight: false,
                });
                if (reason?.response?.status === 440) {
                    window.location.href = "/TimeoutErrorHandler";
                }
            });

    }
    
    createSelectItem(type, url, titles)
    {
        let json;
        let restoreSession = this.state.restore.id;
        let userdetail = { title: "", email: "" };
        let title = userdetail.title;
        let email = userdetail.email;
        try {
            userdetail = JSON.parse(titles);
            title = userdetail.title || "";
            email = userdetail.email || "";
        }
        catch (ex) {
            email = title;
        }
        if (type.toLowerCase() === "mailboxes") {
            const mailboxIdMatch = url.match(/mailboxes\/([a-f0-9-]+)/);
            const mailboxId = mailboxIdMatch ? mailboxIdMatch[1] : null;

            if (mailboxId) {
                json = {
                    id: mailboxId,
                    title: title,
                    getFolders: `/restoresessions/${restoreSession}/organization/mailboxes/${mailboxId}/folders?parentId=root`,
                    email: email,
                    actions: [
                        {
                            name: "ExportToPST",
                            href: `/restoresessions/${restoreSession}/organization/mailboxes/${mailboxId}/exportToPst`,
                            type: "POST"
                        },
                        {
                            name: "RestoreTo",
                            href: `/restoresessions/${restoreSession}/organization/mailboxes/${mailboxId}/restoreTo`,
                            type: "POST"
                        },
                        {
                            name: "RestoreToOriginalLocation",
                            href: `/restoresessions/${restoreSession}/organization/mailboxes/${mailboxId}/restore`,
                            type: "POST"
                        },
                        {
                            name: "Search",
                            href: `/restoresessions/${restoreSession}/organization/mailboxes/${mailboxId}/search`,
                            type: "POST"
                        }
                    ]
                };

            }
            else {
                json = null;
            }
        }
        else if (type.toLowerCase() === "sites") {
            const siteIdMatch = url.match(/sites\/([a-f0-9-]+)/);
            const siteId = siteIdMatch ? siteIdMatch[1] : null;
            this.setState({ siteId: siteId });
            if (siteId) {
                json = {
                    sites: `/restoresessions/${restoreSession}/organization/sites?parentId=${siteId}`,
                    libraries: `/restoresessions/${restoreSession}/organization/sites/${siteId}/libraries`,
                    lists: `/restoresessions/${restoreSession}/organization/sites/${siteId}/lists`,
                    id: siteId,
                    title: title,
                    getFolders: `/restoresessions/${restoreSession}/organization/sites/${siteId}/folders`,
                    email: email.toUpperCase(),
                    actions: []
                };

            } else {
                json = null;
            }
        }
        else if (type.toLowerCase() === "onedrives")
        {
            const oneDriveIdMatch = url.match(/onedrives\/([a-f0-9-]+)/);
            const oneDriveId = oneDriveIdMatch ? oneDriveIdMatch[1] : null;

            // Create the JSON structure
            if (oneDriveId) {
                json = {
                    getItems: `/restoresessions/${restoreSession}/organization/onedrives/${oneDriveId}/documents?parentId=Root`,
                    id: oneDriveId,
                    title: title, 
                    getFolders: `/restoresessions/${restoreSession}/organization/onedrives/${oneDriveId}/folders?parentId=Root`,
                    email: email.toUpperCase(), 
                    actions: null
                };

            } else {
                json = null;
            }

        }
        else if (type.toLowerCase() === "teams")
        {
            json = null;
        }

        this.setState({
            selectItem: json
        })
    }

    async showSearch(event, q) {
        if (event) {
            event.preventDefault();
        }
        const authContext = this.props.authContext || this.context;
        const { setAuthContext } = authContext;
        var tokenString = await setAuthContext(new Date());
        const config = {
            headers: {
                Authorisation: `Bearer ` + tokenString,
                CloudCoverToken: sessionStorage.getItem('CloudCoverToken'),
            },
        };
        let restoreType;
        switch (this.state.activeSearchList.Type[q].toLowerCase()) {
            case 'mailboxes':
                restoreType = 'vex';
                break;
            case 'sites':
                restoreType = 'vesp';
                break;
            case 'onedrives':
                restoreType = 'veod'; 
                break;
            case 'teams':
                restoreType = 'vet';
                break;
            default:
                restoreType = ''; 
        }   
        this.setState({
            SearchQueued: false,
            searchHistoryPanelOpen: false,
            searchPanelOpen: false,
            restoreType: restoreType,
            inProgressRight: true,
            selectItem: null,
            viewItems: [],
            gridViewItems: [],
        });
        
        let href = this.state.activeSearchList.Url[q];
        let page = 0;
        let data = {
            Href: href,
            Body: JSON.stringify(this.state.activeSearchList.SearchQuery[q]),
            Page: page,
            Type: restoreType,
            Query: JSON.stringify(this.state.activeSearchList.QueriesList[q]),
            RestorePointID: this.state.restorePointID ? this.state.restorePointID : " ",
            OrgId: this.state.orgId,
            Title: this.state.activeSearchList.Title[q] ? this.state.activeSearchList.Title[q] : "",
            SubTitle: this.state.activeSearchList.SubTitle[q] ? this.state.activeSearchList.SubTitle[q] : "",
            RPointDateTime: this.state.activeSearchList.BackUpTime[q] ? this.state.activeSearchList.BackUpTime[q] : "",
            UserMailID: sessionStorage.getItem("UserName"),
        };
        Axios.post(API_ROUTE + Routes.SEARCH(this.state.orgId), data, config)
            .then((response) => {
                this.overlayProgress(false);
                    let results = response.data.results;
                    let restoreSession = response.data.restoreSession;
                    if (results.length > 0) {
                        this.renderAgGrid(results);
                    }
                    let nextBlocked = false;
                    if (results.length < 30) {
                        nextBlocked = true;
                    }
                    this.setState(
                        {
                            inProgressRight: false,
                            searchResultsFlag: true,
                            displayPage: page,
                            viewItems: response.data.results,
                            noResults: !(response.data.results.length > 0),
                            nextBlocked: nextBlocked,
                            restoreType: restoreType,
                            restore: restoreSession,
                            // Task 14 — clear any indicator left from a previously opened session;
                            // the check below repopulates it for this one.
                            pstExports: [],
                            serverPath: restoreSession.serverPath,
                            isMFA: restoreSession.isMFA,
                            searchFilters: restoreSession.fields,
                            sessionid: restoreSession.links.self.href,

                        },
                        () => {
                                // Task 14 — pick up an export that was already running when this
                                // restore session was opened. Self-arming: if anything is live the
                                // poll starts itself, and if not this is the only request made.
                                this.pollPstExportStatus();
                            if (this.state.activeSearchList.Title[q] !== "" && (this.state.selectItem === null || this.state.restoreType !== restoreType || this.state.restoreDateTime !== this.state.activeSearchList.BackUpTime[q])) {
                                this.createSelectItem(this.state.activeSearchList.Type[q].toLowerCase(), this.state.activeSearchList.Url[q], this.state.activeSearchList.Title[q]);
                            }
                        }
                    );
            })
            .catch((reason) => {
                this.overlayProgress(false);
                console.log(reason);

                this.setState({
                    inProgressRight: false,
                });
                if (reason?.response?.status === 440) {
                    window.location.href = "/TimeoutErrorHandler";
                }
            });
    }

    async search(event, direction, date = "") {
        if (event) {
            event.preventDefault();
        }
        const authContext = this.props.authContext || this.context;
        const { setAuthContext } = authContext;
        var tokenString = await setAuthContext(new Date());
        const config = {
            headers: {
                Authorisation: `Bearer ` + tokenString,
                CloudCoverToken: sessionStorage.getItem('CloudCoverToken'),
            },
        };
        this.overlayProgress(true);
        this.setState(
            {
                inProgressRight: true,
                SearchQueued: false,
                oldFlag: this.state.nextBlocked,
                oldPage: this.state.displayPage,
                oldItems: !this.state.searchResultsFlag ? this.state.viewItems : this.state.oldItems,
                errorMessage: "",
            },
            () => {
                if (this.state.restoreType === "aad") {
                    let fileName = "";
                    var restorePoint = null;
                    for (var i = 0; i < this.state.mark.length; i++) {
                        restorePoint = this.state.mark[i];

                        if (restorePoint.restoreDate.includes(date)) {
                            this.setState({
                                entraRestorePoint: restorePoint
                            });
                            fileName = restorePoint.fileName;
                            break;
                        }
                    }
                    this.getAADBackupConfigData(fileName, this.state.orgName);
                    return;
                }
                let searchBody = "";
                for (var j = 0; j < this.state.searchQueries.length; j++) {
                    const line = this.state.searchQueries[j]; 
                    let fields = line.Field.split(',');
                    let field = fields[0].trim();
                    searchBody += field;

                    if (line.Inclusion === "contains") {
                        searchBody += ":";
                        searchBody += line.Term;
                    } else if (line.Inclusion === "isNot") {
                        searchBody += ": -";
                        searchBody += line.Term;
                    }else if (line.Inclusion === "isExactly") {
                        searchBody += ":";
                        searchBody += line.Term;
                    } else if (line.Inclusion === "lessThan") {
                        searchBody += ":<";
                        searchBody += line.Term;
                    } else if (line.Inclusion === "greaterThan") {
                        searchBody += ":>";
                        searchBody += line.Term;
                    } else if (line.Inclusion === "startsWith") {
                        searchBody += ":";
                        searchBody += `${line.Term}*`;
                    } else if (line.Inclusion === "endsWith") {
                        searchBody += ":";
                        searchBody += `*${line.Term}`; 
                    } else if (line.Inclusion === "doesNotContain") {
                        searchBody += ": -";
                        searchBody += line.Term;
                    }
                    // else if (line.Inclusion === "wordEquals") {
                    //    searchBody += ":";
                    //    searchBody += line.Term;
                    //}
                    //else if (line.Inclusion === "wordStartsWith") {
                    //    searchBody += ":^=";
                    //    searchBody += line.Term;
                    //}
                    else if (line.Inclusion === "lessThanOrEqual") {
                        searchBody += ":<=";
                        searchBody += line.Term;
                    } else if (line.Inclusion === "greaterThanOrEqual") {
                        searchBody += ":>=";
                        searchBody += line.Term;
                    } else if (line.Inclusion === "between") {
                        const start = this.state.searchTermRangeStart;
                        const end = this.state.searchTermRangeEnd;
                        let fieldName = line.Field ; 
                        searchBody = `${fieldName}:>${start} AND ${fieldName}:<${end}`;
                    } else if (line.Inclusion === "last7Days") {
                        const currentDate = new Date();
                        const last7DaysDate = new Date();
                        last7DaysDate.setDate(currentDate.getDate() - 7);

                        const currentDateString = currentDate.toISOString().split('T')[0];
                        const last7DaysDateString = last7DaysDate.toISOString().split('T')[0];
                        searchBody = `${line.Field}:>=${last7DaysDateString} AND ${line.Field}:<${currentDateString}`;
                    }
                    else if (["today", "yesterday", "next7Days", "tomorrow",
                            "last Week", "next Week", "this Week", "lastMonth",
                            "nextMonth", "thisMonth", "lastYear", "nextYear",
                            "thisYear"].includes(line.Inclusion)) {
                        searchBody += ":" + line.Inclusion;
                    }

                    if (j < this.state.searchQueries.length - 1) {
                        searchBody += " ";
                    }
                }



                let body = '{"query":"' + searchBody + '"}';
                //let restoreSearch = false;
                let href = "";
                if (this.state.restoreType === "vet") {
                    if (this.state.searchType === "Tabs") {
                        let channelId = this.state.selectedFolder.id;
                        channelId = channelId.substring(0, channelId.length - 4)
                        href = this.state.selectItem.getFolders + "/" + channelId + "/tabs";
                    }
                    else {
                        href = this.state.selectItem.getFolders.replace("channels", this.state.searchType);
                    }

                }
                else if (this.state.selectItem) {
                    if (this.state.selectItem.sites)
                    {
                        href = this.state.selectItem.sites.split("?parentId=")[0] + "/" + this.state.selectItem.id ;
                        if (this.state.selectedFolder) {
                            if (!["libraries", "subsites", "lists"].includes(this.state.selectedFolder.title.toLowerCase()))
                                href = this.state.selectedFolder.self;
                        }
                     }

                    else {
                        href = this.state.selectItem.getFolders;
                        href = href.includes("?parentId=Root") ? href.replace("/folders?parentId=Root", "") : href.replace("/folders?parentId=root", "");
                        if (this.state.selectedFolder)
                            href = href + "/folders/" + this.state.selectedFolder.id;
                    }
                }
                else
                {
                    //restoreSearch = true;
                    href = this.state.restore.links.organization.href
                    if (this.state.restoreType === "vex") {
                        href = href + "/mailboxes";
                    } else if (this.state.restoreType === "vesp") {
                        href = href + "/sites";
                    } else if (this.state.restoreType === "veod") {
                        href = href + "/onedrives";
                    }
                }
                href = href + "/search"
                
                let page = this.state.displayPage;
                if (direction === "previous") {
                    page = page - 1;
                } else if (direction === "next") {
                    page = page + 1;
                }
                //href = href.replace("https://127.0.0.1:4443/v6", this.state.serverPath);

                let title = JSON.stringify({
                        title: this.state.selectItem?this.state.selectItem.title:"",
                        email: this.state.selectItem?this.state.selectItem.email:""
                    });


                let subTitle = JSON.stringify({
                    title: "",
                    email: ""
                });
                if (this.state.selectedFolder) {
                    let check = !["libraries", "subsites", "lists"].includes(this.state.selectedFolder.title.toLowerCase());
                        subTitle = JSON.stringify({
                            title: check ? this.state.selectedFolder.title : "",
                            email: check ? this.state.selectedFolder.url :""
                        });
                }
                    
      
                let data = {
                    Href: href,
                    Body: body.toString(),
                    Page: page,
                    Type: this.state.restoreType,   
                    Query: JSON.stringify(this.state.searchQueries),
                    RestorePointID: this.state.restorePointID,
                    OrgId: this.state.orgId,
                    Title: title,
                    SubTitle: subTitle,
                    RPointDateTime: this.state.restoreDateTime ? this.state.restoreDateTime : "",
                    UserMailID: sessionStorage.getItem("UserName"),
                };
                this.delayedResponseTimer = setTimeout(() => {
                    if (!href.toLowerCase().includes("teams"))
                        this.setState({
                            SearchQueued: true,
                            inProgressRight: false,
                            searchPanelOpen: false,
                        }, () => {
                            this.getActiveSearchList();
                        })
                }, 10000); 

                Axios.post(API_ROUTE + Routes.SEARCH(this.state.orgId), data, config)
                    .then((response) => {
                        if (!href.toLowerCase().includes("teams")) {
                            clearTimeout(this.delayedResponseTimer);
                            this.overlayProgress(false);
                            if (response.data.message != null) {
                                this.setState({
                                    inProgressRight: false,
                                    searchFailed: response.data.message,
                                });
                            }
                            else if (response.data.results) {
                                toast.success('Search completed!', { autoClose: 10000 });
                            }
                            let results = response.data.results;
                            if (results.length > 0) {
                                this.renderAgGrid(results);
                            }
                            let nextBlocked = false;
                            if (results.length < 30) {
                                nextBlocked = true;
                            }
                            this.setState({
                                inProgressRight: false,
                                searchFailed: "",
                                searchResultsFlag: true,
                                viewItems: this.state.SearchQueued ? [] : response.data.results,
                                displayPage: page,
                                noResults: !(response.data.results.length > 0),
                                resultToast: true,
                                nextBlocked: nextBlocked,
                                searchPanelOpen: false,
                            }, () => {
                                this.getActiveSearchList();
                            });
                        }
                        else {
                            this.overlayProgress(false);
                            if (response.data.message != null) {
                                this.setState({
                                    inProgressRight: false,
                                    searchFailed: response.data.message,
                                });
                            }
                            else if (response.data.results) {
                                toast.success('Search completed!', { autoClose: 10000 });

                                let results = response.data.results;
                                if (results.length > 0) {
                                    this.renderAgGrid(results);
                                }

                                let nextBlocked = false;
                                if (results.length < 30) {
                                    nextBlocked = true;
                                }

                                this.setState({
                                    inProgressRight: false,
                                    searchFailed: "",
                                    searchResultsFlag: true,
                                    viewItems: response.data.results,
                                    displayPage: page,
                                    noResults: !(response.data.results.length > 0),
                                    resultToast: true,
                                    nextBlocked: nextBlocked,
                                    searchPanelOpen: false,
                                }, () => {
                                    this.getActiveSearchList();
                                });
                            }
                        }
                    })
                    .catch((reason) => {
                        clearTimeout(this.delayedResponseTimer); // Clear the timer if there's an error
                        this.overlayProgress(false);
                        console.log(reason);
                        this.setState({
                            inProgressRight: false,
                            searchFailed: reason,
                        });
                        if (reason?.response?.status === 440) {
                            window.location.href = "/TimeoutErrorHandler";
                        }
                    });
            }
        );
    }

    resetState(restoreType) {
        this.overlayProgress(false);
        this.setState(
            {
                restoreType: restoreType,
                SearchQueued: false,
                inProgressLeft: false,
                inProgressRight: false,
                searchFailed: "",
                inProgressRestore: false,
                gotSelectItems: false,
                restore: null,
                siteURL: "",
                destinationOneDriveId: "",
                type:"",
                destinationOneDriveUserName: "",
                destinationOneDriveUrl: "",
                destinationFolder:"",
                openSharepointModal: false,
                showoneDriveModal: false,
                selectItems: [],
                treeItems: [],
                viewItems: [],
                gridViewItems: [],
                oldItems: null,
                oldPage: 0,
                gettingDeviceCode: false,
                oldFlag: false,
                noResults: false,
                selectItem: null,
                selectedFolder: null,
                displayPage: 0,
                gridPage :0,
                loadedCurrentConfig: false,
                nextBlocked: true,
                selectedItems: [],
                clearLeftSection: false,
                isMFA: false,
                itemClicked: "",
                copied: false,
                verificationModalOpen: false,
                restoreAction: "",
                deviceCode: "",
                password: "",
                mailModalOpen: false,
                mailSendTo: "",
                mailFrom: "",
                mailSubject: "",
                mailMessage: "Here are the files you requested.",
                command: "",
                rootRestoreOpen: false,
                folderRestoreOpen: false,
                itemRestoreOpen: false,
                fileName: "",
                queryString: "",
                restoreJob: null,
                lastClicked: "",
                downloadModalOpen: false,
                entraModalOpen: false,
                downloading: false,
                litigation: {
                    state: false,
                    popUp: false,
                    description: "",
                    action: "",
                    type: ""
                }, 
                /*litigation: false,*/
                restoreModalOpen: false,
                //restorePoints: [],
                restoring: false,
                restoreDetails: {
                    restoredItem: "",
                },
                restoreSuccess: null,
                errorMessage: "",
                searchTerm: "",
                searchResultsFlag: false,
                searchQueries: [],
                searchType: "null",
                sarchField: "null",
                searchQueryType: "",
                value: 0,
                conditionOptions: [],
                searchFilters: [],
                searchPanelOpen: true,
                expandedFolders: ["root"],
                serverPath: "",
                extraLargeDownload: false,
                restorePath: "",
                listName: ""
            },
            () => {
                if (restoreType !== "")
                    this.getRestore();
            }
        );
    }

    //getCalanderRestorePoints() {
    //    Axios.post(API_ROUTE + Routes.GET_RESTOREPOINTS_DATES + '/M365x98575502.onmicrosoft.com')
    //        .then((response) => {
    //            this.overlayProgress(false);
    //            let results = response.data.results;
    //        })
    //        .catch((reason) => {
    //            this.overlayProgress(false);
    //            console.log(reason);
    //            this.setState({
    //                inProgressRight: false,
    //            });
    //        });
    //}

    async getAADBackupConfigData(selectedDate, orgName, restorePoint) {
        const authContext = this.props.authContext || this.context;
        const { setAuthContext } = authContext;
        var tokenString = await setAuthContext(new Date());
        const config = {
            headers: {
                Authorisation: `Bearer ` + tokenString,
                CallDomain: window.location.origin,
                CloudCoverToken: sessionStorage.getItem('CloudCoverToken'),
            },
        };

        var date = selectedDate.split('.')[0];
        Axios.get(API_ROUTE + Routes.ENTRA_CHANGES(this.state.orgId, date, orgName) , config)
            .then((response) => {
                this.overlayProgress(false);
                let results = JSON.parse(response.data);
                var responseData = [];
                var oldData = [];
                var stateData = [];
                var uniqueResources = results.resources.filter(function (resource, index, array) {
                    return array.findIndex(function (otherResource) {
                        return otherResource.resourceInstanceName === resource.resourceInstanceName;
                    }) === index;
                });

                for (var i = 0; i < results.resources.length; i++) {
                    let res = results.resources[i];
                    stateData.push(results);
                    var responseItems = {
                        ConfigItem: res.resourceInstanceName,
                        Property: res.properties[0].parameterName,
                        Previous: res.properties[0].valueInSource,
                        Current: res.properties[0].valueInDestination
                    };
                    var existingIndex = oldData.findIndex(item => item?.resourceInstanceName === res.resourceInstanceName);

                    if (existingIndex !== -1) {
                        responseData[existingIndex].Property += '<>' + responseItems.Property;
                        responseData[existingIndex].Previous += '<>' + responseItems.Previous;
                        responseData[existingIndex].Current += '<>' + responseItems.Current;
                    } else {
                        oldData.push(res);
                        responseData.push(responseItems);
                    }
                }

                // Function to parse a value that could be an array or a string
                function parseValue(value) {
                    try {
                        return JSON.parse(value);
                    } catch (e) {
                        return value;
                    }
                }

                // Function to compare arrays and find added and removed items
                function compareArrays(prevArray, currArray) {
                    let prevSet = new Set(prevArray);
                    let currSet = new Set(currArray);

                    let added = [...currSet].filter(x => !prevSet.has(x));
                    let removed = [...prevSet].filter(x => !currSet.has(x));

                    return { added, removed };
                }

                // Process the responseData to find added and removed items
                responseData.forEach(item => {
                    // Parse Previous and Current values
                    if (item.Previous.split('<>').length === 1 || item.Current.split('<>').length === 1) {
                        let prevValue = parseValue(item.Previous);
                        let currValue = parseValue(item.Current);

                        let prevArray, currArray;

                        if (Array.isArray(prevValue)) {
                            prevArray = prevValue;
                        } else {
                            prevArray = [prevValue];
                        }

                        if (Array.isArray(currValue)) {
                            currArray = currValue;
                        } else {
                            currArray = [currValue];
                        }

                        let { added, removed } = compareArrays(prevArray, currArray);

                        item.Added = added;
                        item.Removed = removed;
                        item.Change = <div>{added}{removed}</div>
                    }
                    else {
                        let prevlist = item.Previous.split('<>');
                        let currlist = item.Current.split('<>');
                        let addedlist = []
                        let removedlist=[]
                        prevlist.forEach((item, index) => {
                            let prevValue = parseValue(item);
                            let currValue = parseValue(currlist[index]);

                            let prevArray, currArray;

                            if (Array.isArray(prevValue)) {
                                prevArray = prevValue;
                            } else {
                                prevArray = [prevValue];
                            }

                            if (Array.isArray(currValue)) {
                                currArray = currValue;
                            } else {
                                currArray = [currValue];
                            }

                            let { added, removed } = compareArrays(prevArray, currArray);
                            addedlist.push(added)
                            removedlist.push(removed)
                        })
                        

                        item.Added = addedlist;
                        item.Removed = removedlist;
                        item.Change = <div>{addedlist}{removedlist}</div>
                    }
                });

                if (this.state.gridApi) {
                    this.state.gridApi.setGridOption('rowData', []);
                    this.state.gridApi.refreshCells();
                    this.state.gridApi.setGridOption('rowData', responseData);
                    this.state.gridApi.refreshCells();
                }
                results.resources = uniqueResources;
                this.setState({
                    inProgressRight: false,
                    searchFailed: "",
                    searchResultsFlag: false,
                    viewItems: responseData,
                    noResults: !(responseData.length > 0),
                    searchPanelOpen: false,
                    aadData: results,
                    rp: restorePoint
                })
            })
            .catch((reason) => {
                this.overlayProgress(false);
                this.setState({
                    inProgressRight: false,
                });
                if (reason?.response?.status === 440) {
                    window.location.href = "/TimeoutErrorHandler";
                }
            });
    }

    getOrgRestore(event, type) {
        document.getElementById('RestoreLandingPage').style.display = "none";
        event.preventDefault();
        this.resetState(type);
    }

    blockInvalidChar = (e) => {
        if (['e', 'E', '+', '-'].includes(e.key)) {
            e.preventDefault();
        }
    };

    async getRestoreDates() {
        const authContext = this.props.authContext || this.context;
        const { setAuthContext } = authContext;
        var tokenString = await setAuthContext(new Date());
        this.setState(
            {
                errorMessage: "",
            },
            () => {
                const config = {
                    headers: {
                        Authorisation: `Bearer ` + tokenString,
                        CallDomain: window.location.origin,
                        CloudCoverToken: sessionStorage.getItem('CloudCoverToken'),
                    },
                };
                Axios.get(API_ROUTE + Routes.GET_RESTORE_DATES(this.state.orgId, this.state.username), config)
                    .then((response) => {
                        var dates = response.data;
                        let startDate = new Date(moment(dates[0]).toString());
                        let endDate = new Date(moment(dates[1].toString()));
                        //toast("Wow so easy!");
                        this.setState({
                            gotRestoreDates: true,
                            firstRestoreDate: startDate,
                            lastRestoreDate: endDate,
                            noRestoreDates: false,
                        });
                    })
                    .catch((reason) => {
                        console.log("catch");

                        //let id= toast("There are currently no restore points available for your organisation. Please wait for your first backup job to complete or contact support if you believe you have a problem.");

                        this.setState({
                            inProgressLeft: false,
                            gotRestoreDates: true,
                            noRestoreDates: false,
                        });
                        if (reason?.response?.status === 440) {
                            window.location.href = "/TimeoutErrorHandler";
                        }
                    });
            }
        );
    }

    async getOrgName() {
        
                this.setState(
                    {
                        orgName: sessionStorage.getItem('ManageTenantDomain'),
                    },
                    () => {
                        //this.getRestoreDates();                       
                    }
                );
            }
            
    

    async getIsEndUser() {
        //if (localStorage.getItem('GuardianOnlyEnabled-' + this.state.orgId) === undefined)
        //    this.CheckAzureGuardianOnly(new URLSearchParams(window.location.search).get("orgId"));
        const authContext = this.props.authContext || this.context;
        const { setAuthContext } = authContext;
        var tokenString = await setAuthContext(new Date());
        const config = {
            headers: {
                Authorisation: `Bearer ` + tokenString,
                CallDomain: window.location.origin,
                CloudCoverToken: sessionStorage.getItem('CloudCoverToken'),
            },
        };

        Axios.get(API_ROUTE + Routes.IS_END_USER, config)
            .then((response) => {
                if (response.data)
                    this.setState({ isEndUser: true });
                //let orgName = response.data;
                //this.setState(
                //    {
                //        orgName: orgName,
                //    },
                //    () => {
                //        this.getRestoreDates();
                //    }
                //);
            })
            .catch((reason) => {
                this.setState({ isEndUser: false });
                if (reason?.response?.status === 440) {
                    window.location.href = "/TimeoutErrorHandler";
                }
            });
    }
    async getOrgUsers() {

        try {

            const authContext = this.props.authContext || this.context;
            const { setAuthContext } = authContext;
            var tokenString = await setAuthContext(new Date());

            const config = {
                headers: {
                    Authorisation: `Bearer ` + tokenString,
                    CloudCoverToken: sessionStorage.getItem('CloudCoverToken'),
                },
            };
            //  url: "/v7/Organizations/" + this.state.orgId + "/Users",
            const inputData = {
                OrgId: this.state.orgId,
                ServerPath: sessionStorage.getItem("ServerPath") ? sessionStorage.getItem("ServerPath") : "",

                TenantName: sessionStorage.getItem("ManageTenantDomain") ? sessionStorage.getItem("ManageTenantDomain") : "",
                EmailAddress: sessionStorage.getItem("UserName") ? sessionStorage.getItem("UserName") : "",
            };
            await Axios.post(API_ROUTE + Routes.GET_ORG_USERS +'/'+this.state.orgId, inputData, config)
                .then((response) => {

                    if (response && response.data) {



                        this.setState({
                            usersList: response.data,
                        });

                    }

                })
                .catch((reason) => {
                    if (reason?.response?.status === 440) {
                        window.location.href = "/TimeoutErrorHandler";
                    }

                });

        }
        catch (error) { }

    }
    async getRestoreEmailType() {
        const authContext = this.props.authContext || this.context;
        const { setAuthContext } = authContext;
        var tokenString = await setAuthContext(new Date());
        const config = {
            headers: {
                Authorisation: `Bearer ` + tokenString,
                CloudCoverToken: sessionStorage.getItem('CloudCoverToken'),

            },
        };
        

        Axios.get(API_ROUTE + Routes.GET_ORG_SETTINGS + '/' + this.state.orgId, config)
            .then((response) => {
                if (response.data && response.data.restoreMailTo)
                    this.setState({ restoreMailTo: response.data.restoreMailTo });

            })
            .catch((reason) => {
                this.setState({ restoreMailTo: "0" });
                if (reason?.response?.status === 440) {
                    window.location.href = "/TimeoutErrorHandler";
                }
            });
    }
    formatDateToUTCString(date) {
    // Get the date components
    const year = date.getFullYear();
    const month = (date.getMonth() + 1).toString().padStart(2, '0'); // Month is 0-based
    const day = date.getDate().toString().padStart(2, '0');
    const hours = date.getHours().toString().padStart(2, '0');
    const minutes = date.getMinutes().toString().padStart(2, '0');
    const seconds = date.getSeconds().toString().padStart(2, '0');
    const milliseconds = date.getMilliseconds().toString().padStart(3, '0');

    // Format the string in "YYYY-MM-DDTHH:mm:ss.sssZ"
    return `${year}-${month}-${day}T${hours}:${minutes}:${seconds}.${milliseconds}Z`;
}
    async getRestorePoints(ActualDate) {
        
        const authContext = this.props.authContext || this.context;
        const { setAuthContext } = authContext;
        var tokenString = await setAuthContext(new Date());
        const config = {
            headers: {
                Authorisation: `Bearer ` + tokenString,
                CallDomain: window.location.origin,
                CloudCoverToken: sessionStorage.getItem('CloudCoverToken'),
            },
        };
        const year = ActualDate.getFullYear();
        const month = ActualDate.getMonth();
        const lastDatePrevMonth = new Date(year, month, 0);
        lastDatePrevMonth.setHours(0, 0, 0, 0);

        // First date of next month
        const firstDateNextMonth = new Date(year, month + 1, 1);
        firstDateNextMonth.setHours(23, 59, 59, 999);

        const lastDateStr = this.formatDateToUTCString(firstDateNextMonth);
        const firstDateStr = this.formatDateToUTCString(lastDatePrevMonth);
        ////let data = {
        ////    OrgId: this.state.orgId,
        ////    UserName: this.state.username,
        ////    From: firstDateStr,
        ////    To: lastDateStr
        ////};
        const filteredResults = this.state.restorePoints.filter(item => {
            return parseInt(item.localBackupTimeStr.split(' ')[0].split('-')[2]) === year && parseInt(item.localBackupTimeStr.split(' ')[0].split('-')[1]) === month + 1;
        });
        this.setState(
            {
                renderRestoreestoreCalendar: <div className="justify-content-center align-items-center d-flex h-100" style={{ minHeight: '225px' }}><img src={LoaderGif} alt="loading" style={{ height: '50px' }} /></div>,
                restore365ActiveStartDate: new Date(year, month)
            }
        );
        if (filteredResults.length === 0) {
            Axios.get(API_ROUTE + Routes.RESTORE_POINTS + this.state.orgId + "/" + encodeURIComponent(this.state.username) + "/" + encodeURIComponent(firstDateStr) + "/" + encodeURIComponent(lastDateStr), config)
                .then((response) => {
                    let result = response.data;
                    result = result.map(iResult => ({
                        ...iResult,                  
                        localBackupTimeStr: new Intl.DateTimeFormat('en-GB', {
                            day: '2-digit',
                            month: '2-digit',
                            year: 'numeric',
                            hour: '2-digit',
                            minute: '2-digit',
                            second: '2-digit',
                            hour12: false, 
                        }).format(new Date(iResult.backupTime)).replace(/\//g, '-').replace(',', '')     
                    }));
                    
                    result = result.filter(item => {
                        const [datePart] = item.localBackupTimeStr.split(" ");
                        const [Actualday, Actualmonth, Actualyear] = datePart.split("-").map(Number);

                        return Actualmonth === month +1 && Actualyear === year;
                    });
                    let currentResult = result;
                    let existingrestorePoints = this.state.restorePoints
                    result.forEach(item2 => {
                        const exists = existingrestorePoints.some(item1 => item1.id === item2.id);
                        if (!exists) {
                            existingrestorePoints.push(item2);
                        }
                    });
                    result = existingrestorePoints;

             
                    //if (result.length === 0) {
                    //    this.setState(
                    //        {
                    //            restorePoints: result,
                    //            selectedrestorePoints: result,
                    //            renderRestoreestoreCalendar: <div className="justify-content-center align-items-center d-flex h-100" style={{ minHeight: '225px' }}><span>No Restore Points available</span></div>
                    //        }
                    //    );
                    //}
                    //else {
                    this.findMaxBackupDate(result);
                        this.setState(
                            {
                                restorePoints: result,
                                selectedrestorePoints: result,
                                renderRestoreestoreCalendar: <React.Fragment> <Calendar style={{ height: 500 }}
                                    onChange={(date) => this.selectRestoreOnChange(date, currentResult)}
                                    value={this.state.date}
                                    maxDate={new Date()}
                                    tileClassName={({ date, view }) => {
                                        for (var i = 0; i < currentResult.length; i++) {
                                            var x = currentResult[i].localBackupTimeStr.split(' ')[0];
                                                if (x === moment(date).format("DD-MM-YYYY")) {

                                                    return 'highlight';
                                                }
                                            }
                                    }}
                                    activeStartDate={this.state.restore365ActiveStartDate}
                                    onActiveStartDateChange={this.onActiveStartDateChange}
                                >
                                </Calendar>
                                    <div className="m-2" style={{ display: 'flex', justifyContent: 'center' }}>
                                        <button onClick={this.getRestorePointsOnMonth} className="btn btn-primary w-100" style={{ fontFamily: 'Roboto, sans-serif', fontSize: '19px' }}>Show all restore points</button>
                                    </div></React.Fragment>
                            }
                        );
                    //}

                })
                .catch((reason) => {
                    this.setState({
                        inProgressLeft: false,
                        renderRestoreestoreCalendar: <div className="justify-content-center align-items-center d-flex h-100" style={{ minHeight: '225px' }}><span>Error getting Restore points</span></div>
                    });
                    if (reason?.response?.status === 440) {
                        window.location.href = "/TimeoutErrorHandler";
                    }
                });
        }
        else {
            //let filteredData = this.state.restorePoints.filter(item => {
            //    const backupDate = new Date(item.backupTime);
            //    return (
            //        backupDate.getMonth() === month &&
            //        backupDate.getFullYear() === year
            //    );
            //});
            let filteredData = this.state.restorePoints.filter(item => {
                const parts = item.localBackupTimeStr.split(' ')[0].split('-');

                //const itemDay = parseInt(parts[0], 10);
                const itemMonth = parseInt(parts[1], 10) - 1;
                const itemYear = parseInt(parts[2], 10);

                return (
                    itemMonth === month &&
                    itemYear === year
                );
            });
            this.findMaxBackupDate(filteredData);
            this.setState(
                {
                    restorePoints: this.state.restorePoints,
                    selectedrestorePoints: this.state.restorePoints,
                    renderRestoreestoreCalendar: <React.Fragment> <Calendar style={{ height: 500 }}
                        onChange={(date) => this.selectRestoreOnChange(date, this.state.restorePoints)}
                        value={this.state.date}
                        maxDate={new Date()}
                        tileClassName={({ date, view }) => {
                            for (var i = 0; i < filteredData.length; i++) {
                                var x = filteredData[i].localBackupTimeStr.split(' ')[0];
                                if (x === moment(date).format("DD-MM-YYYY")) {

                                    return 'highlight';
                                }
                            }
                        }}
                        activeStartDate={this.state.restore365ActiveStartDate}
                        onActiveStartDateChange={this.onActiveStartDateChange}
                    >
                    </Calendar>
                        <div className="m-2" style={{ display: 'flex', justifyContent: 'center' }}>
                            <button onClick={this.getRestorePointsOnMonth} className="btn btn-primary w-100" style={{ fontFamily: 'Roboto, sans-serif', fontSize: '19px' }}>Show all restore points</button>
                        </div></React.Fragment>
                }
            );
        }
    }

    findMaxBackupDate = (mark) => {
        if (mark.length > 0) {

            const parseLocalDate = (dateStr) => {
                const [datePart, timePart] = dateStr.split(" ");
                const [day, month, year] = datePart.split("-").map(Number);
                const [hours, minutes, seconds] = timePart.split(":").map(Number);

                // Month is 0-based in JS Date
                return new Date(year, month - 1, day, hours, minutes, seconds);
            };

            const maxBackupDate = mark.reduce((max, item) => {
                const currentDate = parseLocalDate(item.localBackupTimeStr);
                return currentDate > max ? currentDate : max;
            }, parseLocalDate(mark[0].localBackupTimeStr));

            const monthName = maxBackupDate.toLocaleString('default', { month: 'long' });
            const year = maxBackupDate.getFullYear();

            this.setState({
                restoreVisibleMonthandYear: `${monthName} ${year}`,
            });
        }
    };

    getFormattedDateTime() {
        let restoreDate = moment.utc(this.state.restoreDate);
        let year = restoreDate.format("YYYY");
        let month = restoreDate.format("MM");
        let day = restoreDate.format("DD");
        return `${year}-${month}-${day} ${this.state.restoreTime}`;
       
    }

    async getRestore() {
        const authContext = this.props.authContext || this.context;
        const { setAuthContext } = authContext;
        var tokenString = await setAuthContext(new Date());
        if (!this.state.inProgressLeft) {
            this.setState(
                {
                    inProgressLeft: true,
                    restore: null,
                    siteURL: "",
                    destinationOneDriveId: "",
                    type: "",
                    destinationOneDriveUserName: "",
                    destinationOneDriveUrl: "",
                    destinationFolder: "",
                    openSharepointModal: false,
                    showoneDriveModal: false,
                    treeItems: [],
                    viewItems: [],
                    gridViewItems: [],
                    oldItems: null,
                    noResults: false,
                },
                () => {
                    const config = {
                        headers: {
                            Authorisation: `Bearer ` + tokenString,
                            CallDomain: window.location.origin,
                            CloudCoverToken: sessionStorage.getItem('CloudCoverToken'),
                        },
                    };
                    let fullRestoreTime = this.getFormattedDateTime();
                    let data = {
                        RestoreType: this.state.restoreType,
                        OrgId: this.state.orgId,
                        RestoreDateStr: fullRestoreTime,
                        UserName: this.state.username,
                    };
                    if (this.state.restoreType === 'aad') {
                        Axios.get(API_ROUTE + Routes.ENTRA_RESTORE_POINTS(this.state.orgId, this.state.orgName) , config)
                            .then((response) => {
                                var jsonData;
                                if (response.data === "") {
                                    jsonData = []
                                }
                                else {
                                    jsonData = JSON.parse(response.data)
                                }
                                //if (jsonData.length === 0) {
                                //    this.setState(
                                //        {
                                //            inProgressLeft: false,
                                //            mark: jsonData,
                                //            renderAzureRestoreestoreCalendar: <div className="justify-content-center align-items-center d-flex h-100" style={{ minHeight: '225px' }}><span>No Restore Points available</span></div>,
                                //            selectItems: []
                                //        }
                                //    );
                                //}
                                //else {
                                    this.setState(
                                        {
                                            inProgressLeft: false,
                                            mark: jsonData,
                                            renderAzureRestoreestoreCalendar: <Calendar style={{ height: 500 }}
                                                onChange={this.onChange}
                                                value={this.state.date}
                                                tileClassName={({ date, view }) => {
                                                    // Format the date to match the format used in jsonData
                                                    const formattedDate = moment(date).format("DD-MM-YYYY");

                                                    // Get all entries that match the formatted date
                                                    const entriesForDate = jsonData.filter(item => item.restoreDate.split(' ')[0] === formattedDate);

                                                    // If there are entries for this date
                                                    if (entriesForDate.length > 0) {
                                                        // Check if all diffCount values are "0"
                                                        const allZeroCount = entriesForDate.every(item => item.diffCount === "0");

                                                        // Return 'zeroCount' if all diffCount are "0", otherwise return 'highlight'
                                                        return allZeroCount ? 'zeroCount' : 'highlight';
                                                    }

                                                    // If no matching entry, return undefined (no class)
                                                    return undefined;
                                                }}
                                            >
                                            </Calendar>,
                                            selectItems: jsonData,
                                            
                                        }
                                    );
                                //}
                                
                            })
                            .catch((reason) => {
                                console.log(reason);
                                this.setState({
                                    inProgressLeft: false,
                                    errorMessage: reason?.response?.data,
                                    renderAzureRestoreestoreCalendar: <div className="justify-content-center align-items-center d-flex h-100" style={{ minHeight: '225px' }}><span>Error getting Restore points</span></div>
                                });
                                if (reason?.response?.status === 440) {
                                    window.location.href = "/TimeoutErrorHandler";
                                }
                            });
                        return;
                    }
                    let timeoutTriggered = false;
                    const timeout = setTimeout(() => {
                        timeoutTriggered = true;
                        this.setState({ timeoutError: true });
                    }, 120000);

                    Axios.post(API_ROUTE + Routes.GET_RESTORE(this.state.orgId), data, config)
                        .then((response) => {
                           
                            clearTimeout(timeout);
                            if (!timeoutTriggered) {
                                this.setState({
                                    inProgressLeft: false,
                                    restore: response.data,
                                    serverPath: response.data.serverPath,
                                    isMFA: response.data.isMFA,
                                    searchFilters: response.data.fields,
                                    sessionid: response.data.links.self.href,
                                }, () => {
                                    this.getSelectItems();
                                   // this.getRestoreSession(tokenString);
                                });
                            }
                        })
                        .catch((reason) => {
                            clearTimeout(timeout)
                            this.setState({
                                inProgressLeft: false,
                                timeoutError: true,
                                errorMessage: reason?.response?.data,
                            });
                            if (reason?.response?.status === 440) {
                                window.location.href = "/TimeoutErrorHandler";
                            }
                        });
                }
            );
        }
    }

    async CheckForEntraBackup(orgName, orgId) {
        const authContext = this.props.authContext || this.context;
        const { setAuthContext } = authContext;
        var tokenString = await setAuthContext(new Date());
        const config = {
            headers: {
                Authorisation: `Bearer ` + tokenString,
                CloudCoverToken: sessionStorage.getItem('CloudCoverToken'),
            },
        };
        var _orgId = orgId ? orgId : this.state.orgId;
        //Axios.get(API_ROUTE + Routes.CHECK_ENTRA_JOB + "/" + _orgName, config)
        //    .then((response) => {
        //        if (response.data !== "" && response.data !== "Failed") {
        //            this.setState({
        //                isEntraButtonEnabled: true
        //            });
        //        }
        //    })
        //    .catch((reason) => {
        //    });
        let ModelUserName = "NA";
        if (sessionStorage.UserName) {
            ModelUserName = sessionStorage.UserName;
        }
        Axios.get(API_ROUTE + Routes.PRICING_MODEL_ID + "/" + _orgId + "/" + ModelUserName, config)
            .then((response) => {
                if (response.data !== "" && response.data !== "Failed") {
                    let selectItems = JSON.parse(response.data);
                    const isLHoldTrue = !!(selectItems?.features?.find(feature => feature.featureType === "LHOLD")?.featureValue?.toLowerCase() === "true");
                    
                    this.setState({
                        priceModel: selectItems,
                        guardianStatusLoaded: true,
                        IsLitigationHoldApplicable: isLHoldTrue
                    });

                }
            })
            .catch((reason) => {
                if (reason?.response?.status === 440) {
                    window.location.href = "/TimeoutErrorHandler";
                }
            });
    }

    async getSelectItems() {

        const authContext = this.props.authContext || this.context;
        const { setAuthContext } = authContext;
        var tokenString = await setAuthContext(new Date());
        if (!this.state.inProgressLeft) {
            this.setState(
                {
                    inProgressLeft: true,
                    gotSelectItems: false,
                    showDropdown: false,
                    items: null,
                },
                () => {
                    const config = {
                        headers: {
                            Authorisation: `Bearer ` + tokenString,
                            CallDomain: window.location.origin,
                            CloudCoverToken: sessionStorage.getItem('CloudCoverToken'),
                        },
                    };
                    let href = this.state.serverPath;
                    let data = {
                        RestoreId: this.state.restore.id,
                        Href: href,
                        RestoreType: this.state.restoreType,
                        clearCache: this.state.clearCacheChecked,
                        orgId: this.state.orgId,
                    };
                    let timeoutTriggered = false;
                    const timeout = setTimeout(() => {
                        timeoutTriggered = true;
                        this.setState({ timeoutError: true });
                    }, 60000);
                    Axios.post(API_ROUTE + Routes.GET_RESTORE_ITEMS(this.state.orgId) , data, config)
                        .then((response) => {
                            clearTimeout(timeout);
                            if (!timeoutTriggered) {
                                this.setState({
                                    inProgressLeft: false,
                                    selectItems: response.data,
                                    gotSelectItems: true,
                                    showDropdown: true,
                                    clearLeftSection: false,
                                    timeoutError: false,
                                });
                            }
                            try {
                                document.getElementById('searchTermDate').style.display = 'none';
                                document.getElementById('lblsearchTermDate').style.display = 'none';
                            } catch (e) {

                            }
                        })
                        .catch((reason) => {
                            clearTimeout(timeout)
                            this.setState({
                                inProgressLeft: false,
                                timeoutError: true,
                            });
                            if (reason?.response?.status === 440) {
                                window.location.href = "/TimeoutErrorHandler";
                            }
                        });
                }
            );
        }
    }

    getSiteTreeItems(folder) {
        let treeItems = [];
        let subsitesTreeItem = {
            id: folder.id + "subsites",
            title: "Subsites",
            getChildren: folder.sites,
            isSharepointTopLevel: true,
            getItems: null,
        };
        let librariesTreeItem = {
            id: folder.id + "libraries",
            title: "Libraries",
            getChildren: folder.libraries,
            isSharepointTopLevel: true,
            getItems: null,
        };
        let listsTreeItem = {
            id: folder.id + "lists",
            title: "Lists",
            getChildren: folder.lists,
            isSharepointTopLevel: true,
            getItems: null,
        };
        treeItems.push(subsitesTreeItem);
        treeItems.push(librariesTreeItem);
        treeItems.push(listsTreeItem);
        return treeItems;
    }

    getTeamsTreeItems(folder) {
        let treeItems = [];
        if (folder.posts) {
            let postsTreeItem = {
                id: folder.id + "posts",
                title: "Posts",
                getItems: folder.posts,
                getChildren: null,
            };
            treeItems.push(postsTreeItem);
        }
        if (folder.files) {
            let filesTreeItem = {
                id: folder.id + "files",
                title: "Files",
                isChannelTopLevel: true,
                getItems: folder.files,
                getChildren: folder.files,
            };
            treeItems.push(filesTreeItem);
        }
        if (folder.tabs) {
            let tabsTreeItem = {
                id: folder.id + "tabs",
                title: "Tabs",
                getItems: folder.tabs,
                getChildren: null,
            };
            treeItems.push(tabsTreeItem);
        }
        return treeItems;
    }

    getOdRoot(folder) {
        let treeItems = [];
        let rootTreeItem = {
            id: folder.id + "root",
            title: "Root",
            getChildren: folder.getFolders,
            getItems: folder.getItems,
            isOnedriveTopLevel: true,
        };
        treeItems.push(rootTreeItem);
        return treeItems;
    }

    async getTreeItems() {
        this.setState(
            {

                loadedCurrentConfig: false,

            });
        const authContext = this.props.authContext || this.context;
        const { setAuthContext } = authContext;
        var tokenString = await setAuthContext(new Date());
        if (this.state.restoreType === "vesp") {
            let treeItems = this.getSiteTreeItems(this.state.selectItem);
           

            this.setState({
                inProgressLeft: false,
                treeItems: treeItems,
            });
        } else if (this.state.restoreType === "veod") {
            let treeItems = this.getOdRoot(this.state.selectItem);
          

            this.setState({
                inProgressLeft: false,
                treeItems: treeItems,
            });
        } else {
            if (!this.state.inProgressLeft) {
                this.setState(
                    {
                        inProgressLeft: true,
                        treeItems: [],
                    },
                    () => {
                        const config = {
                            headers: {
                                Authorisation: `Bearer ` + tokenString,
                                CallDomain: window.location.origin,
                                CloudCoverToken: sessionStorage.getItem('CloudCoverToken'),
                            },
                        };
                        let href = this.state.selectItem.getFolders.replace("https://127.0.0.1:4443/", this.state.serverPath)
                        const urlParams = new URLSearchParams(window.location.search);
                        let orgId = urlParams.get("orgId") ? urlParams.get("orgId") : sessionStorage.getItem("ManageOrgId");
                        let data = {
                            Href: href,
                            Operation: "GET",
                            RestoreType: this.state.restoreType,
                            Parent: this.state.selectItem.id,
                        };
                        
                        Axios.post(API_ROUTE + Routes.GET_RESTORE_FOLDERS(orgId), data, config)
                            .then((response) => {
                                var results = response.data;
                                this.setState({
                                    inProgressLeft: false,
                                    treeItems: results,
                                });
                            })
                            .catch((reason) => {
                                this.setState({
                                    inProgressLeft: false,
                                });
                                if (reason?.response?.status === 440) {
                                    window.location.href = "/TimeoutErrorHandler";
                                }
                            });
                    }
                );
            }
        }
    }

    async getChildren(link) {

        const authContext = this.props.authContext || this.context;
        const { setAuthContext } = authContext;
        var tokenString = await setAuthContext(new Date());
        if (!this.state.inProgressLeft) {
            this.setState(
                {
                    inProgressLeft: true,
                },
                () => {
                    const config = {
                        headers: {
                            Authorisation: `Bearer ` + tokenString,
                            CallDomain: window.location.origin,
                            CloudCoverToken: sessionStorage.getItem('CloudCoverToken'),
                        },
                    };
                    link = link.replace("https://127.0.0.1:4443/", this.state.serverPath);
                    let data = {
                        Href: link,
                        Operation: "GET",
                        RestoreType: this.state.restoreType,
                    };
                    Axios.post(API_ROUTE + Routes.EXPAND_RESTORE_FOLDER(this.state.orgId), data, config)
                        .then((response) => {
                            this.setState(
                                {
                                    inProgressLeft: false,
                                },
                                () => {
                                    return response.data;
                                }
                            );
                        })
                        .catch((reason) => {
                            this.setState(
                                {
                                    inProgressLeft: false,
                                },
                                () => {
                                    return null;
                                }
                            );
                            if (reason?.response?.status === 440) {
                                window.location.href = "/TimeoutErrorHandler";
                            }
                        });
                }
            );
        }
    }
    goToPageFromInput = async (targetGridPage) => {

        const batchDataString = await getItem(`RestorePage_${targetGridPage}`);
        if (batchDataString) {
            const batchData = JSON.parse(batchDataString);
            const currentItems = batchData.pages[targetGridPage] || [];
            if (currentItems) {
                this.setState({
                    gridPage: targetGridPage,
                    //viewItems: currentItems,
                    gridViewItems: currentItems,
                    nextBlocked: currentItems.length < this.state.pageSize,
                    noResults: currentItems.length === 0,
                    inProgressRight: false,
                    isLoading: false
                });

                if (currentItems.length > 0) {
                    this.renderAgGrid(currentItems);
                }
            }
        }
    };

    async getView(link, direction) {
        const authContext = this.props.authContext || this.context;
        const { setAuthContext } = authContext;
        var tokenString = await setAuthContext(new Date());
        const config = {
            headers: {
                Authorisation: `Bearer ` + tokenString,
                CallDomain: window.location.origin,
                CloudCoverToken: sessionStorage.getItem('CloudCoverToken'),
            },
        };
        let page = this.state.displayPage;
        if (direction === "previous") {
            page = page - 1;
        } else if (direction === "next") {
            page = page + 1;
        }
        link = link.replace("https://127.0.0.1:4443/", this.state.serverPath);
        let data = {
            Href: link,
            Operation: "GET",
            RestoreType: this.state.restoreType,
            Page: page,
        };
        let route = Routes.GET_RESTORE_FOLDER_ITEMS(this.state.orgId);
        Axios.post(API_ROUTE + route, data, config)
            .then((response) => {
                this.overlayProgress(false);
                let results = response.data.results;
                let number = this.state.displayPage;
                if (results.length > 0) {
                    this.renderAgGrid(results);
                }
                if (results.length === 0) {
                    this.setState({
                        viewItems: number,
                        noResults: true,
                        ResultsFlag: false,
                        displayPage: this.state.displayPage,
                        nextBlocked: true,
                        loadedCurrentConfig: true,
                        inProgressRight: false,
                    });
                } else {
                    let nextBlocked = this.state.nextBlocked;
                    if (results.length < 30) {
                        nextBlocked = true;
                    }
                    if (direction === "next") {
                        number = number + 1;
                    } else if (direction === "previous") {
                        number = number - 1;
                    }
                    this.setState({
                        displayPage: number,
                        nextBlocked: nextBlocked,
                        viewItems: results,
                        noResults: !(results.length > 0),
                        searchResultsFlag: false,
                        loadedCurrentConfig: true,
                        inProgressRight: false,
                    });
                }
            })
            .catch((reason) => {
                this.overlayProgress(false);
                this.setState({
                    inProgressRight: false,
                });
                if (reason?.response?.status === 440) {
                    window.location.href = "/TimeoutErrorHandler";
                }
            });
    }

    async FetchExchangeSharePointData(link, direction) {

        const authContext = this.props.authContext || this.context;
        const { setAuthContext } = authContext;
        var tokenString = await setAuthContext(new Date());
        const config = {
            headers: {
                Authorisation: "Bearer " + tokenString,
                CallDomain: window.location.origin,
                CloudCoverToken: sessionStorage.getItem('CloudCoverToken'),
            },
        };

        let page = this.state.gridPage;
        //if (direction === "previous") page -= 1;
        //else if (direction === "next") page += 1;
       /* else if (direction === "initial") page = 0;*/

        //let backendPage = Math.floor(page / 2); 

        // Check IndexedDB first
        const batchDataString = await getItem(`RestorePage_${page}`);
        const ExbatchDataString = await getItem(`RestorePage_${page+1}`);
        if (batchDataString) {
            const batchData = JSON.parse(batchDataString);
            const currentItems = batchData.pages[page];
            if (currentItems?.length > 0) {
                this.setState({
                    //gridPage: page,
                    //viewItems: currentItems,
                    gridViewItems: currentItems,
                    nextBlocked: (!currentItems || currentItems.length < this.state.pageSize),
                    noResults: (currentItems.length === 0),
                    loadedCurrentConfig: true,
                    inProgressRight: false,
                    isLoading: false
                });
                if (!ExbatchDataString && currentItems.length ===100 && !this.state.hasLoadedAllData) {
                    this.setState({ dataCount: this.state.dataCount + 1})
                }
                if (currentItems.length > 0) {
                    this.renderAgGrid(currentItems);
                }
                if (currentItems.length < 100) {
                    if (!this.state.hasLoadedAllData) {
                        this.setState({ dataCount: this.state.dataCount + 1, hasLoadedAllData :true})
                    }
                    
                    return;
                }
                if (this.state.hasLoadedAllData) {
                    return;
                }
            }
        }
        this.setState({ isLoading: true, nextBlocked :true});

        link = link.replace("https://127.0.0.1:4443/", this.state.serverPath);
        let data = {
            Href: link,
            Operation: "GET",
            RestoreType: this.state.restoreType,
            Page: page===0?page:page+1,
        };
        let route = Routes.GET_RESTORE_FOLDER_ITEMS(this.state.orgId);

        try {
            const response = await Axios.post(API_ROUTE + route, data, config);
            this.overlayProgress(false);

            let results = response.data.results;
            if (results.length === 0) {
                this.setState({
                    viewItems: [],
                    gridViewItems: [],
                    noResults: true,
                    ResultsFlag: false,
                    gridPage: 0,
                    nextBlocked: true,
                    loadedCurrentConfig: true,
                    inProgressRight: false,
                    isLoading: false,
                    dataCount:1
                });
                return;
            }
            let currentGridItems = [];
            // Split 200 into two pages
            if (page === 0) {
                let pageSize = this.state.pageSize;
                let firstPageItems = results.slice(0, pageSize);
                let secondPageItems = results.slice(pageSize, 2 * pageSize);

                // Store batch into IndexedDB
                await setItem(`RestorePage_${page}`, JSON.stringify({
                    backendPage: page,
                    pages: {
                        [page]: firstPageItems,
                    }
                }));
                await setItem(`RestorePage_1`, JSON.stringify({
                    backendPage: 1,
                    pages: {
                        1: secondPageItems
                    }
                }));
                this.setState({
                    dataCount: 1
                });  
                currentGridItems = firstPageItems ? firstPageItems : [];
            }
            else {
                const pagenumber = page+1

                await setItem(`RestorePage_${pagenumber}`, JSON.stringify({
                    backendPage: pagenumber,
                    pages: {
                        [pagenumber]: results
                    }
                }));
                const batchDataString = await getItem(`RestorePage_${page}`);
                if (batchDataString) {
                    const batchData = JSON.parse(batchDataString);
                    currentGridItems = batchData.pages[page];
                }
            }
            

            this.setState({
                //gridPage: page,
                //viewItems: currentItems,
                gridViewItems: currentGridItems,
                //preFetchedItems: preFetched,
                nextBlocked: (currentGridItems.length < this.state.pageSize),
                noResults: !(results.length > 0),
                searchResultsFlag: false,
                loadedCurrentConfig: true,
                inProgressRight: false,                
                isLoading: false
            });

            if (currentGridItems.length > 0) {
                this.renderAgGrid(currentGridItems);
            }
        }
        catch (reason) {
            this.overlayProgress(false);
            this.setState({
                inProgressRight: false,
                isLoading: false,
            });
            if (reason?.response?.status === 440) {
                window.location.href = "/TimeoutErrorHandler";
            }
        }
    }
    async folderClick(event, folder, coordinates, isUnclickable) {
        if (isUnclickable !== true && !this.state.inProgressLeft && !this.state.inProgressRight) {
            event.preventDefault();
            if (folder.url && folder.url !== "") {
                this.setState({
                    listName: folder.title
                })
            }
            const authContext = this.props.authContext || this.context;
            const { setAuthContext } = authContext;
            var tokenString = await setAuthContext(new Date());
            let lastClicked = this.state.lastClicked;
            let viewItems = this.state.viewItems;
            let gridViewItems = this.state.gridViewItems;
            let expandedFolders = this.state.expandedFolders;
            if (!expandedFolders.includes(folder.id)) {
                expandedFolders.push(folder.id);
            } else {
                var index = expandedFolders.indexOf(folder.id);
                expandedFolders.splice(index);
            }
            if (folder.isTeamsTopLevel || folder.isSharepointTopLevel) {
                viewItems = [];
                gridViewItems = [];
            }
            if (this.state.restoreType === "vesp" && folder.self) {
                let subStr = folder.self.split("/sites/");
                let siteId = subStr[1].split("/");
                let rstPath = subStr[0] + "/sites/" + siteId[0];
                this.setState({ restorePath: rstPath, siteId: siteId[0] });
            }
            if (this.state.restoreType === "vesp" || this.state.restoreType === "vet") {
                if (

                    (folder.isSharepointTopLevel &&
                        (folder.title === "Lists" ||
                            folder.title === "Libraries" ||
                            folder.title === "Subsites")) ||
                    (folder.isTeamsTopLevel &&
                        folder.title !== "Posts" &&
                        folder.title !== "Files" &&
                        folder.title !== "Tabs")
                ) {
                    if (folder.isTeamsTopLevel) {
                        lastClicked = folder.id;
                    } else {
                        lastClicked = folder.title;
                    }
                }
            }
            if (!this.state.inProgressRight) {
                if (folder.isTeamsTopLevel) {
                    let folders = this.state.treeItems;
                    let teamsTreeItems = this.getTeamsTreeItems(folder);
                    folders = this.addChildren(teamsTreeItems, coordinates);
                    this.setState({
                        treeItems: folders,
                        selectedFolder: folder,
                        selectedItems: [],
                        lastClicked: lastClicked,
                        viewItems: viewItems,
                        gridViewItems: gridViewItems,
                        noResults: !(viewItems.length > 0),
                        searchResultsFlag: false,
                        inProgressLeft: false,
                        expandedFolders: expandedFolders,
                    });
                } else {
                    let folderId = folder.id;
                    let loadedCurrentConfig = this.state.loadedCurrentConfig;
                    if (this.state.selectedFolder) {
                        if (folderId !== this.state.selectedFolder.id) {
                            loadedCurrentConfig = false;
                        }
                    }
                    this.setState(
                        {
                            selectedFolder: folder,
                            lastClicked: lastClicked,
                            selectedItems: [],
                            viewItems: viewItems,
                            gridViewItems: gridViewItems,
                            noResults: !(viewItems.length > 0),
                            searchResultsFlag: false,
                            loadedCurrentConfig: loadedCurrentConfig,
                            expandedFolders: expandedFolders,
                        },
                        async () => {
                            if (!this.state.loadedCurrentConfig) {
                                if (folder.getItems) {
                                    this.overlayProgress(true);
                                    await clearAllRestoreIndexedDB()
                                    this.setState(
                                        {
                                            inProgressRight: true,
                                            lastClicked: lastClicked,
                                            selectedItems: [],
                                            viewItems: viewItems,
                                            gridViewItems: [],
                                            pageInputValue: 1,
                                            noResults: !(viewItems.length > 0),
                                            searchResultsFlag: false,
                                            displayPage: 0,
                                            gridPage: 0,
                                            hasLoadedAllData: false,
                                            pageSize: 100,
                                            expandedFolders: expandedFolders,
                                        },
                                        () => {
                                            if (this.state.restoreType === "vex" || this.state.restoreType === "vesp") {

                                                this.FetchExchangeSharePointData(folder.getItems, "initial");
                                            }
                                            else if (this.state.restoreType === "veod" || this.state.restoreType === "vet") {

                                                this.getView(folder.getItems, "initial");
                                            }
                                        }
                                    );
                                }
                            }
                            if (!folder.children) {
                                if (!this.state.inProgressLeft) {
                                    if (!folder.getChildren || (!folder.isChannelTopLevel && !folder.title === "Files")) {
                                        if (this.state.restoreType === "vesp") {
                                            let folders = this.state.treeItems;
                                            let siteTreeItems = this.getSiteTreeItems(folder);
                                            folders = this.addChildren(siteTreeItems, coordinates);
                                            this.setState({
                                                treeItems: folders,
                                                nextBlocked: false,
                                                inProgressLeft: false,
                                                selectedItems: [],
                                                lastClicked: lastClicked,
                                                viewItems: viewItems,
                                                gridViewItems: [],
                                                pageInputValue: 1,
                                                noResults: !(viewItems.length > 0),
                                                searchResultsFlag: false,
                                                expandedFolders: expandedFolders,
                                            });
                                        } else {
                                            this.overlayProgress(true);
                                            this.setState(
                                                {
                                                    inProgressRight: true,
                                                    nextBlocked: false,
                                                    lastClicked: lastClicked,
                                                    selectedItems: [],
                                                    searchResultsFlag: false,
                                                    viewItems: viewItems,
                                                    gridViewItems: [],
                                                    pageInputValue: 1,
                                                    noResults: !(viewItems.length > 0),
                                                    displayPage: 0,
                                                    gridPage: 0,
                                                    hasLoadedAllData: false,
                                                    expandedFolders: expandedFolders,
                                                },
                                                () => {
                                                    if (this.state.restoreType === "vex" || this.state.restoreType === "vespz") {

                                                        this.FetchExchangeSharePointData(folder.getItems, "initial");
                                                    }
                                                    else if (this.state.restoreType === "veod" || this.state.restoreType === "vet") {

                                                        this.getView(folder.getItems, "initial");
                                                    }                                                }
                                            );
                                        }
                                    } else {
                                        this.setState(
                                            {
                                                inProgressLeft: true,
                                                nextBlocked: false,
                                                selectedItems: [],
                                                displayPage: 0,
                                                gridPage: 0,
                                                lastClicked: lastClicked,
                                                viewItems: viewItems,
                                                gridViewItems: [],
                                                pageInputValue: 1,
                                                noResults: !(viewItems.length > 0),
                                                searchResultsFlag: false,
                                                expandedFolders: expandedFolders,
                                            },
                                            () => {
                                                const config = {
                                                    headers: {
                                                        Authorisation: `Bearer ` + tokenString,
                                                        CallDomain: window.location.origin,
                                                        CloudCoverToken: sessionStorage.getItem('CloudCoverToken'),
                                                    },
                                                };
                                                let href = folder.getChildren.replace("https://127.0.0.1:4443/", this.state.serverPath);
                                                let data = {
                                                    Href: href,
                                                    Operation: "GET",
                                                    RestoreType: this.state.restoreType,
                                                };

                                                Axios.post(
                                                    API_ROUTE + Routes.EXPAND_RESTORE_FOLDER(this.state.orgId),
                                                    data,
                                                    config
                                                )
                                                    .then((response) => {
                                                        let folders = this.state.treeItems;
                                                        let expandedData = (folder.title === "Libraries" || folder.title === "Lists") && Array.isArray(response.data)
                                                            ? response.data.map((item) => ({ ...item, isContainerRoot: true }))
                                                            : response.data;
                                                        folders = this.addChildren(
                                                            expandedData,
                                                            coordinates
                                                        );
                                                        this.setState({
                                                            treeItems: folders,
                                                            selectedItems: [],
                                                            inProgressLeft: false,
                                                            lastClicked: lastClicked,
                                                            viewItems: viewItems,
                                                            gridViewItems: [],
                                                            pageInputValue: 1,
                                                            //noResults: !(viewItems.length > 0),
                                                            searchResultsFlag: false,
                                                            expandedFolders: expandedFolders,
                                                        });

                                                    })
                                                    .catch((reason) => {
                                                        this.setState(
                                                            {
                                                                inProgressLeft: false,
                                                                lastClicked: lastClicked,
                                                                viewItems: viewItems,
                                                                gridViewItems: [],
                                                                pageInputValue: 1,
                                                                //noResults: viewItems.length > 0,
                                                                searchResultsFlag: false,
                                                                selectedItems: [],
                                                                expandedFolders: expandedFolders,
                                                            },
                                                            () => {
                                                                return null;
                                                            }
                                                        );
                                                        if (reason?.response?.status === 440) {
                                                            window.location.href = "/TimeoutErrorHandler";
                                                        }
                                                    });
                                            }
                                        );
                                    }
                                }
                            }
                        }
                    );
                }
            }
        }
    }

    addChildren(children, coordinates) {
        let folders = this.state.treeItems;
        let returnFolders = this.coordinateRecursion(
            coordinates,
            children,
            folders
        );
        return returnFolders;
    }

    coordinateRecursion(coordinates, content, folders) {
        let newFolders = [];
        if (coordinates.length === 0) {
            return null;
        }
        const coordinate = coordinates[0];
        if (coordinates.length === 1) {
            for (var i = 0; i < folders.length; i++) {
                const folder = folders[i];
                if (i === coordinate) {
                    folder.children = content;
                }
                newFolders.push(folder);
            }
            return newFolders;
        } else if (coordinates.length > 1) {
            for (var j = 0; j < folders.length; j++) {
                const folder = folders[j];
                if (j === coordinate) {
                    let newCoordinates = this.copyArray(coordinates);
                    newCoordinates.shift();
                    folder.children = this.coordinateRecursion(
                        newCoordinates,
                        content,
                        folder.children
                    );
                }
                newFolders.push(folder);
            }
            return newFolders;
        }
    }

    copyArray(array) {
        let newArray = [];
        array.forEach((e) => newArray.push(e));
        return newArray;
    }

    createTreeItem(item, i, coordinates) {
        const folder = item;
        if (!coordinates) {
            coordinates = [];
        }
        coordinates.push(i);
        let children = [];
        if (folder.children) {
            for (var j = 0; j < folder.children.length; j++) {
                const child = folder.children[j];
                let childCoordinates = this.copyArray(coordinates);
                var childItem = this.createTreeItem(child, j, childCoordinates);
                children.push(childItem);
            }
        }
        let icon = <i className="fas fa-folder" />;
        if (this.state.restoreType === "vex") {
            switch (folder.title) {
                case "Inbox":
                    icon = <i className="fas fa-inbox" />;
                    break;
                case "Calendar":
                    icon = <i className="fas fa-calendar-alt" />;
                    break;
                case "Deleted Items":
                    icon = <i className="fas fa-trash-alt" />;
                    break;
                case "Contacts":
                    icon = <i className="fas fa-id-card" />;
                    break;
                case "Notes":
                    icon = <i className="fas fa-sticky-note" />;
                    break;
                case "Tasks":
                    icon = <i className="fas fa-tasks" />;
                    break;
                case "Journal":
                    icon = <i className="fas fa-newspaper" />;
                    break;
                default:
                    break;
            }
        } else if (this.state.restoreType === "vesp") {
            switch (folder.title) {
                case "Subsites":
                    icon = <i className="fas fa-sitemap" />;
                    break;
                case "Libraries":
                    icon = <svg aria-hidden="true" focusable="false"  data-prefix="fas" data-icon="books" role="img" viewBox="0 0 576 512"  className="svg-inline--fa fa-books fa-w-18"><path fill="currentColor"  d="M575.11 443.25L461.51 19.06C458.2 6.7 445.61-3.18 430.15.96L414.7 5.1c-6.18 1.66-11.53 6.4-16.06 14.24-14.03 6.94-52.3 17.21-68 18.22-7.84-4.53-14.85-5.96-21.03-4.3l-15.46 4.14c-2.42.65-4.2 1.95-6.15 3.08V32c0-17.67-14.33-32-32-32h-64c-17.67 0-32 14.33-32 32v64h128l101.66 396.94c3.31 12.36 15.9 22.24 31.36 18.1l15.45-4.14c6.18-1.66 11.53-6.4 16.06-14.24 13.91-6.88 52.18-17.2 68-18.22 7.84 4.53 14.85 5.96 21.03 4.3l15.46-4.14c15.45-4.14 21.41-18.99 18.09-31.35zm-134.4-7.06L348.64 92.37l61.82-16.56 92.07 343.82-61.82 16.56zM0 384h128V128H0v256zM96 0H32C14.33 0 0 14.33 0 32v64h128V32c0-17.67-14.33-32-32-32zM0 480c0 17.67 14.33 32 32 32h64c17.67 0 32-14.33 32-32v-64H0v64zm160-96h128V128H160v256zm0 96c0 17.67 14.33 32 32 32h64c17.67 0 32-14.33 32-32v-64H160v64z"/> </svg>;
                    break;
                case "Lists":
                    icon = <i className="fas fa-list" />;
                    break;
                default:
                    break;
            }
        } else if (this.state.restoreType === "vet") {
            switch (folder.title) {
                case "Posts":
                    icon = <i className="fas fa-map-pin" />;
                    break;
                case "Files":
                    icon = <i className="fas fa-file" />;
                    break;
                default:
                    break;
            }
        }
        let buttonDisabled =
            this.state.inProgressLeft ||
            this.state.inProgressRight ||
            this.state.inProgressRestore;
        let treeItem = (
            <TreeItem
                key={folder.id}
                nodeId={folder.id}
                label={folder.title}
                icon={icon}
                onClick={(e) => this.folderClick(e, folder, coordinates)}
                disabled={buttonDisabled}
            >
                {children}
            </TreeItem>
        );
        return treeItem;
    }

    async onClickAADRestore(event) {

        var _resources = [];
        var filteredAADData = this.state.aadData.resources.filter((a) => {
            return this.state.selectedItems.find((p) => p.ConfigItem === a.resourceInstanceName);
        });

        for (var i = 0; i < filteredAADData.length; i++) {
            var _aadData = filteredAADData[i];
            _resources.push({
                ResourceName: _aadData.resourceName,
                Key: _aadData.key,
                KeyValue: _aadData.keyValue,
                ResourceInstanceName: _aadData.resourceInstanceName,
                Properties: [
                    {
                        ValueInDestination: _aadData.properties[0].valueInDestination,
                        ParameterName: _aadData.properties[0].parameterName,
                        ValueInSource: _aadData.properties[0].valueInSource
                    }
                ]
            })
        }
        let mailid = sessionStorage.getItem('UserEmailID') ? sessionStorage.getItem('UserEmailID') : "";
        var payLoaddata = {
            Resources: _resources,
            //orgName: this.state.aadData.orgName,
            orgName: this.state.orgName,
            mailId: mailid,
            restorePoint: {
                fileName: this.state.rp.diffFile,
                restoreDate: this.state.rp.startTime,
                currFileName: this.state.rp.currFile,
                prevFileName: this.state.rp.prevFile,
                jobId: this.state.rp.jobID
            }
        }
        const authContext = this.props.authContext || this.context;
        const { setAuthContext } = authContext;
        var tokenString = await setAuthContext(new Date());
        const config = {
            headers: {
                Authorisation: `Bearer ` + tokenString,
                CloudCoverToken: sessionStorage.getItem('CloudCoverToken'),
            }
        };

        Axios.post(API_ROUTE + Routes.RESTORE_ENTRA_CHANGES(this.state.orgId), payLoaddata, config)
            .then((response) => {
                let deviceCode = response.data;

                this.setState({
                    deviceCode: deviceCode,
                    inProgressRight: false,
                    ingettingDeviceCode: false,
                    disableBtn: true,
                    entraModalOpen: true,
                    entraRestoreMessage: response.data === 'fail' ?
                        'Your restore has failed, Please contact support.' :
                        (response.data.includes("Failed -") ?
                            response.data.split("Failed -")[1] :
                            'Your restore has been requested. You will be informed when it is completed.'),
                    downloading: false,
                    litigation: {
                        state: false,
                        popUp: false,
                        description: "",
                        action: "",
                        type: ""
                    },
                     /*litigation: false,*/
                });
                // this.deviceTokenCheck(tokenString);
            })
            .catch((reason) => {
                console.log(reason);
                this.setState({
                    ingettingDeviceCode: false,
                    inProgressRight: false,
                });
                if (reason?.response?.status === 440) {
                    window.location.href = "/TimeoutErrorHandler";
                }
            });
    }

    closeDownloadModal(event) {
        event.preventDefault();
        this.setState({
            restoreAction: "",
            entraModalOpen: false,
            downloading: false,
            litigation: {
                state: false,
                popUp: false,
                description: "",
                action: "",
                type: ""
            },
            /*litigation: false,*/
            downloadModalOpen: false,
            verificationModalOpen: false,
            mailModalOpen: false,
            restoreModalOpen: false,
            restoreSuccess: null,
            restoring: false,
            selectedItems: []
        });
        if (this.state.gridApi) {
            this.state.gridApi.setGridOption('rowData', []);
            this.state.gridApi.refreshCells();
            if (this.state.restoreType === "veod" || this.state.restoreType === "vet") {
                this.state.gridApi.setGridOption('rowData', this.state.viewItems);
            }
            else if (this.state.restoreType === "vex" || this.state.restoreType === "vesp") {
                this.state.gridApi.setGridOption('rowData', this.state.gridViewItems);
            }
            this.state.gridApi.refreshCells();
            this.resetCheckbox();
        }
    //    this.resetCheckbox();
    }

    closeRestoreModal(event) {
        event.preventDefault();
        this.setState({
            verificationModalOpen: false,
            gettingDeviceCode: false,
            mailModalOpen: false,
            restoreModalOpen: false,
            entraModalOpen: false,
            downloadModalOpen: false,
            restoreSuccess: null,
            restoring: false,
        });
        if (this.state.gridApi != null) {
            this.state.gridApi.setGridOption('rowData', []);
            this.state.gridApi.refreshCells();
            if (this.state.restoreType === "veod" || this.state.restoreType === "vet") {
                this.state.gridApi.setGridOption('rowData', this.state.viewItems);
            }
            else if (this.state.restoreType === "vex" || this.state.restoreType === "vesp") {
                this.state.gridApi.setGridOption('rowData', this.state.gridViewItems);
            } 
            this.state.gridApi.refreshCells();
            this.resetCheckbox();
        }
    }
    resetCheckbox() {
        const deselected = [];
        this.state.gridApi.forEachNode(function (node) {
            if (node.isSelected()) {
                deselected.push(node);
            }
        });
        // this.state.gridApi.setNodesSelected({ nodes: deselected, newValue: false });
    }

    selectItem(selectedItems) {
        //event.preventDefault();
        const itemIds = selectedItems.map(item => item.value);

        var item = null;
        var items = [];
        for (var i = 0; i < this.state.selectItems.length; i++) {
            const selectItem = this.state.selectItems[i];
            if (!item) {
                if (itemIds.includes(selectItem.id)) {
                    item = selectItem;
                }
            }
            if (itemIds.includes(selectItem.id)) {
                items.push(selectItem);
            }
        }
        if (item) {
            this.setState(
                {
                    selectItem: item,
                    multiSelectItemsIds: itemIds,
                    multiSelectItems: items,
                    selectedFolder: null,
                    selectedItems: [],
                    viewItems: [],
                    gridViewItems: [],
                    oldItems: [],
                    noResults: false,
                    displayPage: 0,
                    gridPage: 0,
                    itemClicked: "root",
                    restorePath: item.libraries ? item.libraries.split("/libraries")[0] : ""
                },
                () => {

                    this.getTreeItems();
                }
            );
        } else {
            this.resetState(this.state.restoreType);
        }
    }
    singleSelectItem(event) {
        //event.preventDefault();
        var itemId = event.value;

        var item = null;
        for (var i = 0; i < this.state.selectItems.length; i++) {
            if (!item) {
                const selectItem = this.state.selectItems[i];
                if (selectItem.id === itemId) {
                    item = selectItem;
                }
            }
        }
        if (item) {
            this.setState(
                {
                    selectItem: item,
                    selectedFolder: null,
                    selectedItems: [],
                    viewItems: [],
                    gridViewItems: [],
                    oldItems: [],
                    siteId: item.id,
                    noResults: false,
                    displayPage: 0,
                    gridPage: 0,
                    itemClicked: "root",
                    restorePath: item.libraries ? item.libraries.split("/libraries")[0] : ""
                },
                () => {

                    this.getTreeItems();
                }
            );
        } else {
            this.resetState(this.state.restoreType);
        }
    }
    convertHeading(text) {
        let finalResult = lodash.startCase(text);
        return finalResult;
    }

    selectRestoreItem(event, item) {
        try {

            event.preventDefault();

        } catch (e) {

        }
        if (item) {
            var selectedItems = this.state.selectedItems;
            if (selectedItems.includes(item)) {
                var index = selectedItems.indexOf(item);
                if (selectedItems !== -1) {
                    selectedItems.splice(index, 1);
                }
            } else {
                selectedItems.push(item);
            }
            this.setState({
                selectedItems: selectedItems,
            });
        }
    }


    /**
     New Methd for migrating table to AG grid
     */
    overlayProgress = (show) => {
        if (show) {
            try {
                this.state.gridApi.setGridOption('rowData', []);
            } catch (e) {

            }
        }
        try {
            if (show) {
                document.getElementById('restore-grid').style.display = 'none';
                this.state.showOverlay()
            }
            else {
                document.getElementById('restore-grid').style.display = 'block';
                this.state.setGridOption("loading", false);
            }
        } catch (e) {

        }
        // if (show)
        //     document.getElementById('main-div-form-elements').style.display = 'block';
        // else
        //     document.getElementById('main-div-form-elements').style.display = 'none';
    }

    OnselectionChanged = (e) => {

    }
    OnItemSelected = (e) => {

        this.selectRestoreItem(e, e.data);
    }

    onGridReady = (p) => {
        this.setState({
            gridApi: p.api
        });

        var _colDef = this.setDynamicColumnDefinition(this.state.viewItems);
        p.api.setGridOption('columnDefs', _colDef)
        p.api.setGridOption('rowSelection', this.state.rowSelection);

        p.api.setGridOption('selectionColumnDef', this.state.selectionColumnDef);
        p.api.setGridOption('rowData', this.state.viewItems);

    }
    restoreOnGridReady = (params) => {
        this.setState({ gridApi: params.api });

        const _colDef = this.setDynamicColumnDefinition(this.state.gridViewItems);
        params.api.setGridOption('columnDefs', _colDef);
        params.api.setGridOption('rowSelection', this.state.rowSelection);

        params.api.setGridOption('selectionColumnDef', this.state.selectionColumnDef);
        if (this.state.gridApi != null) {
            params.api.setGridOption('rowData', this.state.gridViewItems);
        }
    }

    sessionEventOnGridReady = (params) => {        
        this.setState({
            restoreSessionGridApi: params.api
        });
        params.api.setGridOption('rowData', this.state.selectedSessionEvents);
    };

    getRowStyle = params => {
        return { fontSize: "Small" };
    };

    renderAgGrid = (items) => {
        if (this.state.gridApi) {
            var _colDef = this.setDynamicColumnDefinition(items);

            this.state.gridApi.setGridOption('columnDefs', _colDef)
            this.state.gridApi.setGridOption('rowSelection', this.state.rowSelection);

            this.state.gridApi.setGridOption('selectionColumnDef', this.state.selectionColumnDef);
            if (items.length > 0) {
                this.state.gridApi.setGridOption('rowData', items);
            }
            else {
                this.state.gridApi.setGridOption('rowData', [])
            }
                
        }
    }

    formatDateColumn = (p) => {
        let value = p.value;

        let property = p.column.colId;

        if (
            property === "startTime" ||
            property === "endTime" ||
            property === "sent" ||
            property === "received" ||
            property === "startDate" ||
            property === "dueDate" ||
            property === "modificationTime" ||
            property === "modified" ||
            property === "creationTime"
            ||
            property.indexOf("Time") > -1 ||
            property.indexOf("Date") > -1
        ) {
            let _dateValue = moment(value).format("hh:mm DD-MM-YYYY").toString();
            return _dateValue;
        }
        return value;
    }
    AADReporthandleClose = () => {
        this.setState({
            AADReportshow: false,
        });
    }
    PreviewAADdiff = (params) => {
        //'Previous' || heading == 'Current'
        let AADPopup =<></>
        try {
            let previewResult = <></>
            let currentResult = <></>
            let trResult=[]
            if (params.data.Previous.split('<>').length === 1 || params.data.Current.split('<>').length === 1) {
                let Previous = JSON.parse(params.data.Previous);
                let Current = JSON.parse(params.data.Current);

                if ( (Array.isArray(Previous) || Array.isArray(Current)) && (Previous.length === 0 || typeof Previous[0] !== 'object' || Previous[0] === null) && (Current.length === 0 || typeof Current[0] !== 'object' || Current[0] === null) ) {
                    const prevSet = new Set(Previous);
                    const currSet = new Set(Current);
                    const notInCurrent = Previous.filter(item => !currSet.has(item));

                    const notInPrevious = Current.filter(item => !prevSet.has(item));

                    previewResult = <>[{Previous.map((item, index) => (
                        <>
                            <span
                                key={index}
                                style={{
                                    color: notInCurrent.includes(item) ? 'red' : 'black',
                                    textDecoration: item && item.length > 0 && notInCurrent.includes(item) ? 'underline' : 'none',
                                }}>
                                "{item}"
                            </span>
                            {index < Previous.length - 1 ? ", " : ""}
                        </>
                    ))}]</>

                    currentResult = <>[{Current.map((item, index) => (
                        <><span
                            key={index}
                            style={{
                                color: notInPrevious.includes(item) ? 'green' : 'black',
                                fontWeight: notInPrevious.includes(item) ? 'bold' : 'normal',
                            }}>
                            "{item}"
                        </span>
                            {index < Current.length - 1 ? ", " : ""}
                        </>

                    ))}]</>
                    trResult.push(<tr>
                        <td>{previewResult}</td>
                        <td>{currentResult}</td>
                    </tr>);
                }
                else if (typeof Previous[0] === 'object' || typeof Current[0] === 'object') {
                    const newOutput = {};
                    const oldOutput = {};

                    Current.forEach((currentItem, index) => {
                        const previousItem = Previous[index];

                        // Compare by key-value pairs inside the objects
                        Object.keys(currentItem).forEach((key) => {
                            if (!previousItem || !previousItem.hasOwnProperty(key)) {
                                // Key is new in Current
                                newOutput[`${index}-${key}`] = { value: currentItem[key], keyColor: 'green', valueColor: 'green', fontWeight: 'bold' };
                            } else if (currentItem[key] !== previousItem[key]) {
                                // Key exists in both, but values are different
                                newOutput[`${index}-${key}`] = { value: currentItem[key], keyColor: 'black', valueColor: 'green', fontWeight: 'bold' };
                                oldOutput[`${index}-${key}`] = { value: previousItem[key], keyColor: 'black', valueColor: 'red', textDecoration: 'underline' };
                            } else {
                                // Key and value are the same
                                newOutput[`${index}-${key}`] = { value: currentItem[key], keyColor: 'black', valueColor: 'black' };
                                oldOutput[`${index}-${key}`] = { value: previousItem[key], keyColor: 'black', valueColor: 'black' };
                            }
                        });

                        // Handle keys that exist in Previous but not in Current
                        if (previousItem) {
                            Object.keys(previousItem).forEach((key) => {
                                if (!currentItem.hasOwnProperty(key)) {
                                    oldOutput[`${index}-${key}`] = { value: previousItem[key], keyColor: 'red', valueColor: 'red', textDecoration: 'underline' };
                                }
                            });
                        }
                    });
                    if (Previous.length > Current.length) {
                        for (let i = Current.length; i < Previous.length; i++) {
                            const previousItem = Previous[i];
                            Object.keys(previousItem).forEach((key) => {
                                oldOutput[`${i}-${key}`] = { value: previousItem[key], keyColor: 'red', valueColor: 'red', textDecoration: 'underline' };
                            });
                        }
                    }
                    // Preview of old object
                    const groupByIndex = (output) => {
                        const grouped = {};
                        Object.entries(output).forEach(([key, value]) => {
                            const index = key.split('-')[0]; // Extract index from key
                            if (!grouped[index]) {
                                grouped[index] = [];
                            }
                            grouped[index].push({ key: key.split('-')[1], ...value });
                        });
                        return grouped;
                    };

                    const groupedOldOutput = groupByIndex(oldOutput);
                    const groupedNewOutput = groupByIndex(newOutput);

                    // Preview of old object
                    previewResult = (
                        <div>
                            {'['}
                            {Object.entries(groupedOldOutput).map(([index, entries], idx, arr) => (
                                <div key={index} style={{ marginLeft: '20px', color: 'black' }}>
                                    {'{'}
                                    {entries.map(({ key, value, keyColor, valueColor }) => (
                                        <div key={key} style={{ color: keyColor, marginLeft: '40px' }}>
                                            {key}: <span style={{ color: valueColor, fontSize: '1rem' }}>{value.toString()}</span>
                                        </div>
                                    ))}
                                    <div style={{ marginLeft: '20px' }}>{'}'}{idx < arr.length - 1 && ','}</div>
                                    {/* Add a comma if this is not the last object */}
                                    
                                </div>
                            ))}
                            {']'}
                        </div>
                    );

                    // Current result rendering
                    currentResult = (
                        <div>
                            {'['}
                            {Object.entries(groupedNewOutput).map(([index, entries], idx, arr) => (
                                <div key={index} style={{ marginLeft: '20px', color: 'black' }}>
                                    {'{'}
                                    {entries.map(({ key, value, keyColor, valueColor }) => (
                                        <div key={key} style={{ color: keyColor, marginLeft: '40px' }}>
                                            {key}: <span style={{ color: valueColor, fontSize: '1rem' }}>{value.toString()}</span>
                                        </div>
                                    ))}
                                    <div style={{ marginLeft: '20px' }}>{'}'}{idx < arr.length - 1 && ','}</div>
                                    {/* Add a comma if this is not the last object */}
                                    
                                </div>
                            ))}
                            {']'}
                        </div>
                    );

                    trResult.push(<tr>
                        <td>{previewResult}</td>
                        <td>{currentResult}</td>
                    </tr>);
                }
                else if (typeof Previous === 'object' || typeof Current === 'object') {
                    const newOutput = {};
                    const oldOutput = {};

                    Object.keys(Current).forEach((key) => {
                        if (!Previous.hasOwnProperty(key)) {
                            newOutput[key] = { value: Current[key], keyColor: 'green', valueColor: 'green', fontWeight:'bold' }; // New key and value
                        } else if (Current[key] !== Previous[key]) {
                            newOutput[key] = { value: Current[key], keyColor: 'black', valueColor: 'green', fontWeight: 'bold' }; // Same key, different value
                            oldOutput[key] = { value: Previous[key], keyColor: 'black', valueColor: 'red', textDecoration: 'underline' };
                        } else {
                            newOutput[key] = { value: Current[key], keyColor: 'black', valueColor: 'black' }; // Same key, same value
                            oldOutput[key] = { value: Previous[key], keyColor: 'black', valueColor: 'black' };
                        }
                    });

                    Object.keys(Previous).forEach((key) => {
                        if (!Current.hasOwnProperty(key)) {
                            oldOutput[key] = { value: Previous[key], keyColor: 'red', valueColor: 'red', textDecoration: 'underline' }; // Old key and value
                        }
                    });

                    previewResult = (
                        <div>
                            {'{'}
                            {Object.entries(oldOutput).map(([key, { value, keyColor, valueColor }]) => (
                                <div key={key} style={{ color: keyColor }}>
                                    {key}: <span style={{ color: valueColor, fontSize: '1rem' }}>{value.toString()}</span>
                                </div>
                            ))}
                            {'}'}
                        </div>
                    );

                    currentResult = (
                        <div>
                            {'{'}
                            {Object.entries(newOutput).map(([key, { value, keyColor, valueColor }]) => (
                                <div key={key} style={{ color: keyColor }}>
                                    {key}: <span style={{ color: valueColor, fontSize: '1rem' }}>{value.toString()}</span>
                                </div>
                            ))
                            }
                            {'}'}
                        </div >
                    );
                    trResult.push(<tr>
                        <td>{previewResult}</td>
                        <td>{currentResult}</td>
                    </tr>);
                }
                else {
                    throw new Error("Not an array or object.");
                }

                AADPopup = <table className="table table-bordered table-responsive">
                    <thead>
                        <tr>
                            <th scope="col" style={{ backgroundColor: '#5191ce', color: 'white' }}>Previous backup</th>
                            <th scope="col" style={{ backgroundColor: '#5191ce', color: 'white' }}>Selected backup</th>
                        </tr>
                    </thead>
                    <tbody>
                        {trResult}
                    </tbody>
                </table>
            }
            else {
                let listofPrevious = params.data.Previous.split('<>');
                let listofCurrent = params.data.Current.split('<>');
                let tr = [];
                listofPrevious.forEach((item, index) => {
                    let Previous = JSON.parse(item);
                    let Current = JSON.parse(listofCurrent[index]);
                    
                    if (Array.isArray(Previous) || Array.isArray(Current)) {
                        const prevSet = new Set(Previous);
                        const currSet = new Set(Current);
                        const notInCurrent = Previous.filter(item => !currSet.has(item));

                        const notInPrevious = Current.filter(item => !prevSet.has(item));

                        previewResult = <>[{Previous.map((items, indexs) => (
                            <>

                                <span
                                    key={indexs}
                                    style={{
                                        color: notInCurrent.includes(items) ? 'red' : 'black',
                                        textDecoration: items && items.length > 0 && notInCurrent.includes(items) ? 'underline' : 'none',
                                    }}>
                                    "{items}"
                                </span>
                                {index < Previous.length - 1 ? ", " : ""}
                            </>
                        ))}]</>

                        currentResult = <>[{Current.map((items, indexs) => (
                            <><span
                                key={indexs}
                                style={{
                                    color: notInPrevious.includes(items) ? 'green' : 'black',
                                    fontWeight: notInPrevious.includes(items) ? 'bold' : 'normal',
                                }}>
                                "{items}"
                            </span>
                                {indexs < Current.length - 1 ? ", " : ""}
                            </>

                        ))}]</>

                        tr.push(<tr>
                            <td>
                                <span className="fw-bold">
                                    {params.data.Property.split('<>')[index]}
                                </span>
                                <div>{previewResult}</div>
                            </td>
                            <td><span className="fw-bold" style={{ height: '24px', display: 'block' }}>
                            </span>
                                <div>{currentResult}</div></td>
                        </tr>)

                    }
                    else {
                        throw new Error("Not an array or object.");
                    }
                });
                
                AADPopup = <table className="table table-bordered table-responsive">
                    <thead>
                        <tr>
                            <th scope="col" style={{ backgroundColor: '#5191ce', color: 'white' }}>Previous backup</th>
                            <th scope="col" style={{ backgroundColor: '#5191ce', color: 'white' }}>Selected backup</th>
                        </tr>
                    </thead>
                    <tbody>
                        {tr }
                    </tbody>
                </table>
            }

            

            this.setState({
                AADReportshow: true,
                AADPreviousCurrent: AADPopup,
                AADPreviousCConfigHeadar: params.data.ConfigItem
            }); 
        } 
        catch (e) {
            let AADPopup = <table className="table table-bordered table-responsive">
                <thead>
                    <tr>
                        <th scope="col" style={{ backgroundColor: '#5191ce', color: 'white' }}>Previous backup</th>
                        <th scope="col" style={{ backgroundColor: '#5191ce', color: 'white' }}>Selected backup</th>
                    </tr>
                </thead>
                <tbody>
                    <tr>
                        <td>{params.data.Previous}</td>
                        <td>{params.data.Current}</td>
                    </tr>
                </tbody>
            </table>
            this.setState({
                AADReportshow: true,
                AADPreviousCurrent: AADPopup,
                AADPreviousCConfigHeadar: params.data.ConfigItem
            }); 
        }
        
    }
    setDynamicColumnDefinition = (items) => {

        var colDefnition = [];
        let columnHeadings = [];
        columnHeadings.push("select");
        items.forEach((item) => {
            for (const property in item) {
                if (
                    property !== "id" &&
                    property !== "links" &&
                    property !== "itemClass" &&
                    property !== "actions" &&
                    property !== "recurring" &&
                    property !== "attachments" &&
                    property !== "reminder" &&
                    property !== "isContainerRoot"
                ) {
                    if (
                        property === "startTime" ||
                        property === "endTime" ||
                        property === "sent" ||
                        property === "received" ||
                        property === "startDate" ||
                        property === "dueDate" ||
                        property === "modificationTime" ||
                        property === "modified" ||
                        property === "creationTime" ||
                        property.includes("Time") ||
                        property.includes("Date")
                    ) {
                        var itemTime = moment(item[property]);
                        if (itemTime.format("YYYY") > 1970) {
                            if (item[property] && !columnHeadings.includes(property)) {
                                columnHeadings.push(property);
                            }
                        }
                    } else {
                        if (item[property] && !columnHeadings.includes(property)) {
                            columnHeadings.push(property);
                        }
                    }
                }
            }
        });

        columnHeadings = columnHeadings.sort();
        // ORDER HEADERS HERE
        let newHeadings = [];
        if (columnHeadings.includes("select")) {
            newHeadings.push("select");
        }
        if (columnHeadings.includes("name")) {
            newHeadings.push("name");
        }
        if (columnHeadings.includes("creationTime")) {
            newHeadings.push("creationTime");
        }
        if (columnHeadings.includes("modificationTime")) {
            newHeadings.push("modificationTime");
        }
        if (columnHeadings.includes("createdBy")) {
            newHeadings.push("createdBy");
        }
        if (columnHeadings.includes("modifiedBy")) {
            newHeadings.push("modifiedBy");
        }
        if (columnHeadings.includes("fullName")) {
            newHeadings.push("fullName");
        }
        if (columnHeadings.includes("email")) {
            newHeadings.push("email");
        }
        if (columnHeadings.includes("displayAs")) {
            newHeadings.push("displayAs");
        }
        if (columnHeadings.includes("mobile")) {
            newHeadings.push("mobile");
        }
        if (columnHeadings.includes("from")) {
            newHeadings.push("from");
        }
        if (columnHeadings.includes("to")) {
            newHeadings.push("to");
        }
        if (columnHeadings.includes("subject")) {
            newHeadings.push("subject");
        }
        if (columnHeadings.includes("sent")) {
            newHeadings.push("sent");
        }
        if (columnHeadings.includes("received")) {
            newHeadings.push("received");
        }
        if (columnHeadings.includes("startTime")) {
            newHeadings.push("startTime");
        }
        if (columnHeadings.includes("endTime")) {
            newHeadings.push("endTime");
        }
        if (columnHeadings.includes("location")) {
            newHeadings.push("location");
        }
        if (columnHeadings.includes("ConfigItem")) {
            newHeadings.push("ConfigItem");
        }
        if (columnHeadings.includes("Property")) {
            newHeadings.push("Property");
        }
        if (columnHeadings.includes("Previous")) {
            newHeadings.push("Previous");
        }
        if (columnHeadings.includes("Current")) {
            newHeadings.push("Current");
        }
        columnHeadings.forEach((heading) => {
            if (!newHeadings.includes(heading)) {
                newHeadings.push(heading);
            }
        });
        columnHeadings = newHeadings;
        columnHeadings.forEach((heading) => {
            // items.forEach((item) => {
            let headingContent = this.convertHeading(heading);
            if (headingContent === 'Size Bytes')
                headingContent = 'Size(MB)';
            var _tempColDef;
            if (heading === 'select') {
                ////_tempColDef = {
                ////    field: '',
                ////    headerName: headingContent,
                ////    tooltipField: heading,
                ////    ////checkboxSelection: true,
                ////    ////headerCheckboxSelection: true,
                ////    filter: false,
                ////    maxWidth: 50
                ////}
                ////colDefnition.push(_tempColDef);
                this.setState({
                    rowSelection: {
                        mode: 'multiRow',
                        checkboxes: true,
                        headerCheckbox: true,
                    }, selectionColumnDef: {
                        headerName: "Select",
                        maxWidth: 50,
                    } })
            }
            else if (heading === 'Property') {
                _tempColDef = {
                    field: 'Property',
                    headerName: headingContent,
                    cellStyle: { display: 'flex', alignItems: 'center', height: '100%' },
                    cellRenderer: (params) => {
                        if (params.data.Property.split('<>').length > 1) {
                            let spans =<></>
                            let result = []
                            let array = params.data.Property.split('<>')
                            array.forEach((item, index) => {
                                if (index !== 0 && index < array.length ) {
                                    result.push(<hr key="divider" />);
                                }
                                    result.push(
                                        <div key={`azure-property-${index}`}>
                                            {item}
                                        </div>
                                    );
                                    
                                });
                            //result.push(<hr key="divider" />);
                            spans = <div>{result}</div>;
                            return spans;
                            }
                            else {
                                return params.data.Property
                            }
                        }
                }
                colDefnition.push(_tempColDef);
            }
            else if (heading === 'Change') {
                _tempColDef = {
                    field: 'Change',
                    headerName: headingContent,
                    //tooltipField: heading,
                    minWidth: 50,
                    cellRenderer: (params) => {
                        let spans = <></>
                        try {
                            //JSON.parse(params.data.Added);
                            if (params.data.Previous.split('<>').length === 1 || params.data.Current.split('<>').length === 1) {
                                if (Array.isArray(params.data.Added[0]) || Array.isArray(params.data.Removed[0])) {
                                    //console.log('The value is an array.');
                                    spans = <div>
                                        {params.data.Added.map((item, index) => (
                                            <span key={index} style={{ color: 'green', fontWeight:'bold' }}>
                                                {item}
                                                {index < params.data.Added.length - 1 ? ', ' : ''}
                                            </span>
                                        ))}
                                        {params.data.Removed.map((item, index) => (
                                            <span key={index} style={{ color: 'red', textDecoration: 'underline' }}>
                                                {item}
                                                {index < params.data.Removed.length - 1 ? ', ' : ''}
                                            </span>
                                        ))}
                                    </div>
                                }
                                else if ((typeof params.data.Added[0] === 'object' && params.data.Added[0] !== null) || (typeof params.data.Removed[0] === 'object' && params.data.Removed[0] !== null)) {
                                    //console.log('The value is a JSON object.');
                                    const result = [];
                                    // Get the maximum length of both arrays to handle cases where one is longer
                                    const maxLength = Math.max(params.data.Added.length, params.data.Removed.length);

                                    // Iterate over the arrays of objects
                                    for (let i = 0; i < maxLength; i++) {
                                        const addedObj = params.data.Added[i] || {};  // Handle cases where one array is shorter
                                        const removedObj = params.data.Removed[i] || {};

                                        // Get all keys from both objects in the current index
                                        const allKeys = new Set([
                                            ...Object.keys(removedObj),
                                            ...Object.keys(addedObj)
                                        ]);

                                        // Compare the individual objects at this index
                                        allKeys.forEach((key) => {
                                            const oldValue = removedObj[key];
                                            const newValue = addedObj[key];

                                            if (oldValue === undefined && newValue !== undefined) {
                                                result.push({ key, value: newValue, keyColor: "green", valueColor: "green", index: i, fontWeight:'bold' });
                                            } else if (newValue === undefined && oldValue !== undefined) {
                                                result.push({ key, value: oldValue, keyColor: "red", valueColor: "red", index: i, textDecoration:'underline' });
                                            } else if (oldValue !== newValue) {
                                                result.push({ key, value: newValue, keyColor: "black", valueColor: "green", index: i, fontWeight: 'bold' });
                                            }
                                        });
                                    }

                                    // Display the result
                                    spans = (
                                        <div>
                                            {result.map(({ key, value, keyColor, valueColor, index }) => (
                                                <>
                                                    {index > 0 && <hr style={{ margin: '0' }}></hr>}
                                                <div key={`${index}-${key}`}>
                                                    {/*<span style={{ color: keyColor }}>"{key}" (Object {index + 1}): </span>*/}
                                                    <span style={{ color: keyColor }}>"{key}": </span>
                                                    <span style={{ color: valueColor }}>{JSON.stringify(value)}</span>,
                                                    </div>
                                                    
                                                </>
                                            ))}
                                        </div>
                                    );
                                }
                                else {
                                    //console.log('The value is of a different type.');
                                    throw new Error("Not an array or object.");
                                }
                            }
                            else {
                                let listofAdded = params.data.Added;
                                let listofRemoved = params.data.Removed;
                                let actualSpans = [];
                                listofAdded.forEach((item, index) => {
                                    //item = JSON.parse(item)
                                    var removed = listofRemoved[index]
                                    if (Array.isArray(item) || Array.isArray(removed)) {
                                        //console.log('The value is an array.');
                                        if (actualSpans.length > 0) {
                                            actualSpans.push(<hr></hr>);
                                        }
                                        actualSpans.push(<div style={{ minHeight:'22px' }} >
                                            {item.map((items, indexs) => (
                                                <span key={indexs} style={{ color: 'green', display: 'block', fontWeight: "bold" }}>
                                                    {items}
                                                    {indexs < item.length - 1 ? ', ' : ''}
                                                </span>
                                            ))}
                                            {removed.map((items, indexs) => (
                                                <span key={indexs} style={{ color: 'red', display: 'block', textDecoration: 'underline' }}>
                                                    {items}
                                                    {indexs < removed.length - 1 ? ', ' : ''}
                                                </span>
                                            ))}
                                        </div>)
                                    }
                                })
                                return actualSpans;
                            }
                            

                            return spans;
                        } catch (e) {
                            let spans = <div></div>
                            if (params.data.Current === "Present") {
                                spans = <div>
                                    <span style={{ color: 'green', display: 'block', fontWeight: "bold" }}>
                                        Created
                                    </span>
                                </div>
                            }
                            else if (params.data.Current === "Absent") {
                                spans = <div>
                                    <span style={{ color: 'red', display: 'block', textDecoration: 'underline' }}>
                                        Deleted
                                    </span>
                                </div>
                            }
                            else {
                                spans = <div>
                                    <span style={{ color: 'green', display: 'block', fontWeight: "bold" }}>
                                        {params.data.Added.join(', ')}
                                    </span>
                                    <span style={{ color: 'red', display: 'block', textDecoration: 'underline' }}>
                                        {params.data.Removed.join(', ')}
                                    </span>
                                </div>
                            }

                            return spans;
                        }
                    }
                }
                colDefnition.push(_tempColDef);
                var _tempColDefClick = {
                    field: '',
                    headerName: 'Preview',
                    maxWidth: 100,
                    filter: false, 
                    cellStyle: { display: 'flex', alignItems: 'center', height: '100%' },
                    cellRenderer: (params) => {
                        return (
                            <div className="justify-content-between d-flex align-items-center">
                                <button className="link-button" onClick={() => this.PreviewAADdiff(params)} >
                                    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" className="bi bi-eye" viewBox="0 0 16 16">
                                        <path d="M16 8s-3-5.5-8-5.5S0 8 0 8s3 5.5 8 5.5S16 8 16 8M1.173 8a13 13 0 0 1 1.66-2.043C4.12 4.668 5.88 3.5 8 3.5s3.879 1.168 5.168 2.457A13 13 0 0 1 14.828 8q-.086.13-.195.288c-.335.48-.83 1.12-1.465 1.755C11.879 11.332 10.119 12.5 8 12.5s-3.879-1.168-5.168-2.457A13 13 0 0 1 1.172 8z" />
                                        <path d="M8 5.5a2.5 2.5 0 1 0 0 5 2.5 2.5 0 0 0 0-5M4.5 8a3.5 3.5 0 1 1 7 0 3.5 3.5 0 0 1-7 0" />
                                    </svg>
                                </button>
                            </div>
                        );
                    }
                }
                colDefnition.push(_tempColDefClick);
            }
            else if (heading === 'Previous' || heading === 'Current' || heading === 'Added' || heading === 'Removed') {

            } else if (heading === 'contentUrl') {
                _tempColDef = {
                    field: heading,
                    headerName: headingContent,
                    tooltipField: heading,
                    valueFormatter: this.formatDateColumn,
                    filter: heading !== 'select' ? true : false,
                    cellStyle: { whiteSpace:'nowrap' },
                }
                colDefnition.push(_tempColDef);
            }
            else if (heading === 'inheritedPermissions') {
                _tempColDef = {
                    field: heading,
                    headerName: headingContent,
                    tooltipField: heading,
                    cellDataType: false,
                    filter: heading !== 'select' ? true : false
                }
                colDefnition.push(_tempColDef);
            }
            else {
                _tempColDef = {
                    field: heading,
                    headerName: headingContent,
                    tooltipField: heading,
                    valueFormatter: this.formatDateColumn,
                    filter: heading !== 'select' ? true : false
                }
                colDefnition.push(_tempColDef);
            }
            // });

        });

        return colDefnition;
    }

    setColumnDefinition = () => {
        let m = this.state.selectedFolder.title;
        let _colDef = [];
        if (m === 'Inbox') {
            _colDef = [{ field: '', headerName: 'Select', toolTip: '', checkboxSelection: true },
            { field: 'from', headerName: 'From', toolTip: '' },
            { field: 'to', headerName: 'To', toolTip: '' },
            { field: 'subject', headerName: 'Subject', toolTip: '' },
            { field: 'sent', headerName: 'Sent', toolTip: '', valueFormatter: this.formatDateColumn },
            { field: 'received', headerName: 'Received', toolTip: '', valueFormatter: this.formatDateColumn }
            ];
        }

        return _colDef;
    }

    /**
     * End of migrations
     */

    getTable(items) {

        if (this.state.inProgressRight) {
            return (
                <React.Fragment>
                    <tbody>
                        <tr>
                            <td></td>
                        </tr>
                    </tbody>
                </React.Fragment>
            );
        }
        //this.renderAgGrid(items);
        let columns = [];
        let columnHeadings = [];
        columnHeadings.push("select");
        let styleObject = null;
        items.forEach((item) => {
            for (const property in item) {
                if (
                    property !== "id" &&
                    property !== "links" &&
                    property !== "itemClass" &&
                    property !== "actions" &&
                    property !== "recurring" &&
                    property !== "attachments" &&
                    property !== "reminder" &&
                    property !== "isContainerRoot"
                ) {
                    if (
                        property === "startTime" ||
                        property === "endTime" ||
                        property === "sent" ||
                        property === "received" ||
                        property === "startDate" ||
                        property === "dueDate" ||
                        property === "modificationTime" ||
                        property === "modified" ||
                        property === "creationTime" ||
                        property.includes("Time") ||
                        property.includes("Date")
                    ) {
                        var itemTime = moment(item[property]);
                        if (itemTime.format("YYYY") > 1970) {
                            if (item[property] && !columnHeadings.includes(property)) {
                                columnHeadings.push(property);
                            }
                        }
                    } else {
                        if (item[property] && !columnHeadings.includes(property)) {
                            columnHeadings.push(property);
                        }
                    }
                }
            }
        });
        columnHeadings = columnHeadings.sort();
        // ORDER HEADERS HERE
        let newHeadings = [];
        if (columnHeadings.includes("select")) {
            newHeadings.push("select");
        }
        if (columnHeadings.includes("name")) {
            newHeadings.push("name");
        }
        if (columnHeadings.includes("creationTime")) {
            newHeadings.push("creationTime");
        }
        if (columnHeadings.includes("modificationTime")) {
            newHeadings.push("modificationTime");
        }
        if (columnHeadings.includes("createdBy")) {
            newHeadings.push("createdBy");
        }
        if (columnHeadings.includes("modifiedBy")) {
            newHeadings.push("modifiedBy");
        }
        if (columnHeadings.includes("fullName")) {
            newHeadings.push("fullName");
        }
        if (columnHeadings.includes("email")) {
            newHeadings.push("email");
        }
        if (columnHeadings.includes("displayAs")) {
            newHeadings.push("displayAs");
        }
        if (columnHeadings.includes("mobile")) {
            newHeadings.push("mobile");
        }
        if (columnHeadings.includes("from")) {
            newHeadings.push("from");
        }
        if (columnHeadings.includes("to")) {
            newHeadings.push("to");
        }
        if (columnHeadings.includes("subject")) {
            newHeadings.push("subject");
        }
        if (columnHeadings.includes("sent")) {
            newHeadings.push("sent");
        }
        if (columnHeadings.includes("received")) {
            newHeadings.push("received");
        }
        if (columnHeadings.includes("startTime")) {
            newHeadings.push("startTime");
        }
        if (columnHeadings.includes("endTime")) {
            newHeadings.push("endTime");
        }
        if (columnHeadings.includes("location")) {
            newHeadings.push("location");
        }
        columnHeadings.forEach((heading) => {
            if (!newHeadings.includes(heading)) {
                newHeadings.push(heading);
            }
        });
        columnHeadings = newHeadings;
        columnHeadings.forEach((heading) => {
            let headingContent = this.convertHeading(heading);
            let header = (
                <th style={styleObject} key={heading}>
                    {headingContent}
                </th>
            );
            columns.push(header);
        });
        items.forEach((item) => {
            for (const property in item) {
                if (
                    property !== "id" &&
                    property !== "links" &&
                    property !== "itemClass" &&
                    property !== "actions" &&
                    property !== "recurring" &&
                    property !== "attachments" &&
                    property !== "reminder"
                ) {
                    let headingContent = this.convertHeading(property);
                    if (
                        property === "startTime" ||
                        property === "endTime" ||
                        property === "sent" ||
                        property === "received" ||
                        property === "startDate" ||
                        property === "dueDate" ||
                        property === "modificationTime" ||
                        property === "creationTime" ||
                        property === "modified" ||
                        property.includes("Time") ||
                        property.includes("Date")
                    ) {
                        var itemTime = moment(item[property]);
                        if (itemTime.format("YYYY") > 1970) {
                            if (item[property] && !columnHeadings.includes(property)) {
                                let header = (
                                    <th style={styleObject} key={property}>
                                        {headingContent}
                                    </th>
                                );
                                columnHeadings.push(property);
                                columns.push(header);
                            }
                        }
                    } else {
                        if (item[property] && !columnHeadings.includes(property)) {
                            let header = (
                                <th style={styleObject} key={property}>
                                    {headingContent}
                                </th>
                            );
                            columnHeadings.push(property);
                            columns.push(header);
                        }
                    }
                }
            }
        });
        let headerRow = (
            <thead>
                <tr>{columns}</tr>
            </thead>
        );
        let rows = [];
        for (var i = 0; i < items.length; i++) {
            const item = items[i];
            let columns = [];
            let styleObject = null;
            for (var j = 0; j < columnHeadings.length; j++) {
                const heading = columnHeadings[j];
                if (heading === "select") {
                    let isSelected = this.state.selectedItems.includes(item);
                    let column = (
                        <td style={styleObject} key={heading + j.toString()}>
                            <Checkbox color="primary" checked={isSelected} />
                        </td>
                    );
                    columns.push(column);
                }
                if (item[heading]) {
                    let content = item[heading].toString();
                    if (heading === "to" || heading === "attendees") {
                        content = content.substring(0, 45);
                        if (content.length === 45) {
                            content += "...";
                        }
                    }
                    if (item.itemClass && item.itemClass.includes("appointement")) {
                        content = moment(item[heading])
                            .format("hh:mm DD-MM-YYYY")
                            .toString();
                    } else {
                        if (
                            heading === "startTime" ||
                            heading === "endTime" ||
                            heading === "sent" ||
                            heading === "received" ||
                            heading === "startDate" ||
                            heading === "dueDate" ||
                            heading === "creationTime" ||
                            heading === "modificationTime" ||
                            heading === "modified" ||
                            heading.includes("Time") ||
                            heading.includes("Date")
                        ) {
                            content = moment(item[heading])
                                .format("hh:mm DD-MM-YYYY")
                                .toString();
                        }
                    }
                    let column = (
                        <td style={styleObject} key={heading}>
                            {content}
                        </td>
                    );
                    columns.push(column);
                } else {
                    if (heading !== "select") {
                        let column = <td style={styleObject} key={heading}></td>;
                        columns.push(column);
                    }
                }
            }
            let row = (
                <tr onClick={(e) => this.selectRestoreItem(e, item)} key={i}>
                    {columns}
                </tr>
            );
            rows.push(row);
        }
        let displayRows = <tbody>{rows}</tbody>;
        return (
            <React.Fragment>
                {headerRow}
                {displayRows}
            </React.Fragment>
        );
    }


    async paginationPreviousPage(event, isSearch) {
        //event.preventDefault();

        if ((this.state.gridPage > 0) && !this.state.inProgressRight) {
            //this.overlayProgress(true);
            this.setState(prev => ({
                gridPage: prev.gridPage - 1,
                nextBlocked: false,
                inProgressRight: false,
                isLoading: false,
            }), async () => {
                const batchDataString = await getItem(`RestorePage_${this.state.gridPage}`);
                if (batchDataString) {
                    const batchData = JSON.parse(batchDataString);
                    const currentItems = batchData.pages[this.state.gridPage];
                    if (currentItems.length > 0) {
                        this.setState(prev => {
                            const preFetched = currentItems;
                            return {
                                gridViewItems: preFetched,
                                noResults: preFetched.length === 0,
                                loadedCurrentConfig: true,
                            };
                        }, () => {
                            this.renderAgGrid(this.state.gridViewItems);
                        });
                    }
                }
            });
        }
      
    }

    async paginationNextPage(event, isSearch) {
        //event.preventDefault();
        const batchDataString = await getItem(`RestorePage_${this.state.gridPage + 1}`);
        if (!this.state.inProgressRight && !this.state.nextBlocked) {
            if (batchDataString) {
                const batchData = JSON.parse(batchDataString);
                const currentItems = batchData.pages[this.state.gridPage + 1];
                if (currentItems.length > 0) {
                    this.setState(prev => {
                        const preFetched = currentItems;
                        return {
                            gridPage: prev.gridPage + 1,
                            gridViewItems: preFetched,
                            nextBlocked: preFetched.length < prev.pageSize,
                            noResults: preFetched.length === 0,
                            inProgressRight: false,
                            loadedCurrentConfig: true,
                            isLoading: false
                        };
                    }, async () => {
                        this.renderAgGrid(this.state.gridViewItems);
                        //this.overlayProgress(false);
                        if (currentItems.length === 100) {
                            //this.fetchNextBackendBatch();
                            this.FetchExchangeSharePointData(this.state.selectedFolder.getItems, "next");
                        }
                        const ExbatchDataString = await getItem(`RestorePage_${this.state.gridPage+1}`);
                        if (currentItems.length < 100 && !ExbatchDataString) {
                            if (!this.state.hasLoadedAllData) {
                                this.setState({ dataCount: this.state.dataCount + 1, hasLoadedAllData: true })
                            }
                        }
                    });
                }
                
            }
        }
    }

    previousPage(event, isSearch) {
        event.preventDefault();
        if (this.state.displayPage > 0 && !this.state.inProgressRight) {
            this.overlayProgress(true);
            this.setState(
                {
                    nextBlocked: false,
                    inProgressRight: true,
                },
                () => {
                    if (isSearch) {
                        this.search(null, "previous");
                    } else {
                        this.getView(this.state.selectedFolder.getItems, "previous");
                    }
                }
            );
        }
    }

    nextPage(event, isSearch) {
        event.preventDefault();
        if (!this.state.inProgressRight) {
            this.overlayProgress(true);
            this.setState(
                {
                    loadedCurrentConfig: false,
                    nextBlocked: false,
                    inProgressRight: true,
                },
                () => {
                    if (isSearch) {
                        this.search(null, "next");
                    } else {
                        this.getView(this.state.selectedFolder.getItems, "next");
                    }
                }
            );
        }
    }
    // property == "startTime" ||
    // property == "endTime" ||
    // property == "sent" ||
    // property == "received" ||
    // property == "startDate" ||
    // property == "dueDate" ||
    // property == "modificationTime" ||
    // property == "modified" ||
    // property == "creationTime" 

    changeSearchField(event) {
        event.preventDefault();
        let value = event.target.value;
        let type = event.target.selectedOptions[0].getAttribute('type');

        let dateFieldValue = ['startTime', 'endTime', 'sent', 'received', 'start', 'end', 'modificationTime', 'modified', 'creationTime'];
        let CustomFieldValue = ['importance', 'priority'];
        let BooleanFieldValue = [ 'recurring', 'HasAttachments'];
        let SensitivityFieldValue = ['sensitivity'];
        let MeetingStatusFieldValue = ['meetingstatus'];
        let FlagStatusFieldValue = ['flagstatus'];
        let ColorFieldValue = ['color'];
        let SizeFieldValue = ['size'];

        let isDateFields = value && (value.includes('date') || dateFieldValue.includes(value));
        let isCustomField = value && CustomFieldValue.includes(value);
        let isBooleanField = value && BooleanFieldValue.includes(value);
        let isSensitivityField = value && SensitivityFieldValue.includes(value);
        let isMeetingStatusField = value && MeetingStatusFieldValue.includes(value);
        let isFlagStatusField = value && FlagStatusFieldValue.includes(value);
        let isColorField = value && ColorFieldValue.includes(value);
        let isSizeField = value && SizeFieldValue.includes(value);

        let conditionOptions = this.getConditionOptions(type);

        this.setState({
            searchField: value, 
            searchQueryType: '',
            isDateField: isDateFields,
            isCustomField: isCustomField,
            isBooleanField: isBooleanField,
            isSensitivityField: isSensitivityField,
            isMeetingStatusField: isMeetingStatusField,
            isFlagStatusField: isFlagStatusField,
            isColorField: isColorField,
            isSizeField: isSizeField,
            searchTerm: '', 
            searchTermDate: null, 
            value: null, 
            unit: 'KB', 
            isBetweenCondition: false, 
            dateRange: { start: '', end: '' }, 
            conditionOptions: conditionOptions, 
            searchTermVisible: !isDateFields && !isCustomField && !isSizeField && !isSensitivityField && !isFlagStatusField && !isColorField && !isBooleanField && !isMeetingStatusField,
            lblsearchTermVisible: !isDateFields && !isCustomField && !isSizeField,
            searchTermDateVisible: isDateFields,
            lblsearchTermDateVisible: isDateFields,
            customFieldDropdownVisible: isCustomField,
            lblBetweenDatesVisible: isCustomField && this.state.isBetweenCondition,
            fileSizeVisible: isSizeField,
            sensitivityDropdownVisible: isSensitivityField,
        });
    }


    handleValueChange(event) {
        const newValue = Number(event.target.value);
        this.setState(this.handleFileSizeChange(newValue, this.state.unit));
    }

    handleLitigationDescriptionChange = (event) => {
        const { value } = event.target;
        this.setState(prevState => ({
            litigation: {
                ...prevState.litigation,
                description: value
            }
        }));
    };

    handleUnitChange = (event) => {
        const newUnit = event.target.value;
        const { value } = this.state; 
        const updatedFileSize = this.handleFileSizeChange(value, newUnit);
        this.setState(updatedFileSize); 
    };

    handleFileSizeChange = (value, unit) => {
        const formattedSize = `${value} ${unit}`;
        return {
            value,
            unit,
            searchTerm:formattedSize,
        };
    };
    handleDropdownChange = (event) => {
        const { name, value } = event.target;
        this.setState((prevState) => ({
            dropdownValues: {
                ...prevState.dropdownValues,
                [name]: value,
            },
            searchTerm: value
        }));
    };

    handleStartDateChange = (date) => {
        this.setState({ startDate: date });
    };

    handleEndDateChange = (date) => {
        this.setState({ endDate: date });
    };
    changeSearchType(event) {
        event.preventDefault();
        let value = event.target.value;
        this.setState({
            searchType: value,
        }, this.resetSearchValues);
    }
    resetSearchValues = () => {
        this.setState({
            searchField: 'null',
            searchQueryType: '',
            searchTerm: '',
            searchTermDate: null,
            dateRange: { start: null, end: null },
            value: 0,
            isDateField: false,
            isCustomField: false,
            isBooleanField: false,
            isSensitivityField: false,
            isMeetingStatusField: false,
            isFlagStatusField: false,
            isColorField: false,
            isSizeField: false,
            selectedCondition: '',
        });
    }

    changeSearchQueryType(event) {
        event.preventDefault();
        let value = event.target.value;
        this.setState({
            searchQueryType: value,
            isBetweenCondition: value === 'between',
            selectedCondition: value,
            searchTermDate: null,
            dateRange: { start: null, end: null },
            searchTerm: '',
            value: 0,
            dropdownValues: {
                customDropdown: '----',
                sensitivityDropdown: '----',
                meetingStatusDropdown: '----',
                attachmentsDropdown: '----',
                flagStatusDropdown: '----',
                colorDropdown: '----',
            },
        });
    }

    getConditionOptions(type) {
        //const { conditionType } = this.state;

        if (type === "Text") {
            return [
                //{ value: "isExactly", label: "Is Exactly" },
                //{ value: "isNot", label: "Is Not" },
                { value: "contains", label: "Contains" },
                { value: "doesNotContain", label: "Doesn't Contain" },
                { value: "startsWith", label: "Starts With" },
                { value: "endsWith", label: "Ends With" },
                //{ value: "wordEquals", label: "Word Equals" },
                //{ value: "wordStartsWith", label: "Word Starts With" },
                //{ value: "dosWildcards", label: "DOS Wild Cards" },
            ];
        } else if (type === "Date") {
            return [
                { value: "isExactly", label: "Is Exactly" },
                { value: "isNot", label: "Is Not" },
                { value: "lessThan", label: "Less Than" },
                { value: "lessThanOrEqual", label: "Less Than or Equal" },
                { value: "greaterThan", label: "Greater Than" },
                { value: "greaterThanOrEqual", label: "Greater Than or Equal" },
                { value: "between", label: "Between" },
                { value: "today", label: "Today" },
                { value: "yesterday", label: "Yesterday" },
                { value: "tomorrow", label: "Tomorrow" },
                { value: "last7Days", label: "In the last 7 days" },
                { value: "next7Days", label: "In the next 7 days" },
                { value: "last Week", label: "Last week" },
                { value: "this Week", label: "This week" },
                { value: "next Week", label: "Next week" },
                { value: "lastMonth", label: "Last month" },
                { value: "nextMonth", label: "Next month" },
                { value: "thisMonth", label: "This month" },
                { value: "lastYear", label: "Last Year" },
                { value: "nextYear", label: "Next Year" },
                { value: "thisYear", label: "This Year" },
            ];
        } else if (type === "Custom") {
            return [
                { value: "isExactly", label: "Is Exactly" },
                { value: "isNot", label: "Is Not" },
            ]
        }
        return [];
    }
    
    addToQueryLines(event) {
        event.preventDefault();
        const dateConditions = [
            'today', 'yesterday', 'tomorrow', 'last7Days', 'next7Days',
            'last Week', 'this Week', 'next Week', 'lastMonth', 'nextMonth','thisMonth',
            'lastYear', 'nextYear', 'thisYear'
        ];
        let line = {
            Type: this.state.searchType,
            Field: this.state.searchField,
            Inclusion: this.state.searchQueryType,
            Term: this.state.searchTerm,
        };
        if (!line.Type && line.Type === '') {
            return false;
        }
        if (!line.Field && line.Field === '') {
            return false;
        }
        if (!line.Term && line.Term === '' && !dateConditions.includes(line.Inclusion)) {
            return false;
        }
        let lines = this.state.searchQueries;
        lines.push(line);
        this.setState({
            searchQueries: lines,
        });
    }

    onChange(event) {
        ////this.search(null, "", moment(event).format("DD-MM-YYYY"));//aadviewItems
        //if (this.state.aadviewItems.length > 0) {
        this.getAADBackupConfigDataListing(this.state.orgName, moment(event).format("DD-MM-YYYY"), "Date")
        this.setState({
            selectedRestoreDate: moment(event).format("DD-MM-YYYY"),
        });
        //}
    }
    onActiveStartDateChange = ({ activeStartDate }) => {
        this.getRestorePoints(activeStartDate);
        this.setState({
            restoreVisibleMonthandYear: moment(activeStartDate).format("MMMM YYYY"),
        });
    };
    selectRestoreOnChange(event, restorePoints) {
        //selectRestoreOnChange(event) {
        //    alert(event)
        //    alert(moment(event).format("DD-MM-YYYY"))
        if (new Date(event).getMonth() === new Date(this.state.restoreVisibleMonthandYear).getMonth() && new Date(event).getFullYear() === new Date(this.state.restoreVisibleMonthandYear).getFullYear()) {
            let filteredData = restorePoints.filter(e => e.localBackupTimeStr.split(' ')[0] === moment(event).format("DD-MM-YYYY"))
            if (filteredData.length > 0)
                this.setState({
                    selectedrestorePoints: filteredData,
                    activeAccordion: "2",
                    aadnoResults: true,
                    selectedRestoreDate: moment(event).format("DD-MM-YYYY")
                });
        }
        

    }
    getRestorePointsOnMonth() {
        let restorePoints = this.state.restorePoints;
        const [month, year] = this.state.restoreVisibleMonthandYear.split(' ');
        const monthNames = [
            "January", "February", "March", "April", "May", "June",
            "July", "August", "September", "October", "November", "December"
        ];
        let filteredData = restorePoints.filter(item => {
            const [datePart] = item.localBackupTimeStr.split(" ");
            const [day, monthStr, yearStr] = datePart.split("-");

            const monthIndex = parseInt(monthStr, 10) - 1;
            const monthName = monthNames[monthIndex];

            return monthName === month && yearStr === year;
        });


        if (filteredData.length > 0)
            this.setState({
                selectedrestorePoints: filteredData,
                activeAccordion: "2",
                aadnoResults: true,
                selectedRestoreDate: this.state.restoreVisibleMonthandYear
            });
    }
    handleRestoreChallangeSubmitted() {
        this.setState({
            restoreChallangeSubmitted: true
        });
    }
    accordianChange(type, accordionNumber) {

        if (accordionNumber === "1") {
            this.setState({
                selectedRestoreDate: "",
                selectedRestorePoint: "",
            });
        }
        if (accordionNumber === "2") {
            this.setState({
                selectedRestorePoint: "",
            });
        }
        if (type === 'previous' && this.state.restoreChallangeSubmitted) {
            if (accordionNumber < this.state.activeAccordion && this.state.activeAccordion.toString() === "3") {
                this.setState({
                    activeAccordion: accordionNumber,                    
                });
            }
            else if (accordionNumber < this.state.activeAccordion && this.state.activeAccordion.toString() === "2") {
                this.setState({
                    activeAccordion: accordionNumber,
                });
            }
        }
        else if (type === 'first') {
            this.setState({
                selectedRestoreType: "",
                selectedRestoreDate: "",
                selectedRestorePoint: "",
                activeAccordion: accordionNumber,
                restoreChallangeSubmitted: false
            });
        }
        else if (type === 'next') {
            this.setState({
                activeAccordion: String(Number(this.state.activeAccordion[0]) + 1),
            });
            document.getElementById('restoreCalendar').style.display = "block";
            document.getElementById('aadCalendar').style.display = "none";
        }
        else if (type === 'aadazure') {
            document.getElementById('restoreCalendar').style.display = "none";
            document.getElementById('aadCalendar').style.display = "block";
            this.setState({
                activeAccordion: String(Number(this.state.activeAccordion) + 1),
            });
            this.setState(
                {
                    restoreType: "aad",
                    inProgressLeft: false,
                    inProgressRight: false,
                    inProgressRestore: false,
                    gotSelectItems: false,
                    restore: null,
                    siteURL: "",
                    destinationOneDriveId: "",
                    type: "",
                    destinationOneDriveUserName: "",
                    destinationOneDriveUrl: "",
                    destinationFolder: "",
                    openSharepointModal: false,
                    showoneDriveModal: false,
                    restoreSessionGrid: false,
                    selectItems: [],
                    treeItems: [],
                    viewItems: [],
                    gridViewItems: [],
                    oldItems: [],
                    oldPage: 0,
                    gettingDeviceCode: false,
                    oldFlag: false,
                    noResults: false,
                    selectItem: null,
                    selectedFolder: null,
                    displayPage: 0,
                    gridPage: 0,
                    loadedCurrentConfig: false,
                    nextBlocked: true,
                    selectedItems: [],
                    clearLeftSection: false,
                    isMFA: false,
                    itemClicked: "",
                    copied: false,
                    verificationModalOpen: false,
                    restoreAction: "",
                    deviceCode: "",
                    password: "",
                    mailModalOpen: false,
                    mailSendTo: "",
                    mailFrom: "",
                    mailSubject: "",
                    mailMessage: "Here are the files you requested.",
                    command: "",
                    rootRestoreOpen: false,
                    folderRestoreOpen: false,
                    itemRestoreOpen: false,
                    fileName: "",
                    queryString: "",
                    restoreJob: null,
                    lastClicked: "",
                    downloadModalOpen: false,
                    entraModalOpen: false,
                    downloading: false,
                    litigation: {
                        state: false,
                        popUp: false,
                        description: "",
                        action: "",
                        type: ""
                    }, 
                    /*litigation: false,*/
                    restoreModalOpen: false,
                    //restorePoints: [],
                    restoring: false,
                    restoreDetails: {
                        restoredItem: "",
                    },
                    restoreSuccess: null,
                    errorMessage: "",
                    searchTerm: "",
                    searchResultsFlag: false,
                    searchQueries: [],
                    searchType: "null",
                    sarchField: "null",
                    searchQueryType: "includes",
                    conditionOptions: [],
                    searchFilters: [],
                    searchPanelOpen: true,
                    expandedFolders: ["root"],
                    serverPath: "",
                    extraLargeDownload: false,
                    restorePath: "",
                    listName: ""
                },
                () => {

                    this.getRestore();
                }
            );
        }

    }
    aadorNot(aadorNot) {
        if (aadorNot) {
            document.getElementById('Exchange_restore').style.display = "none";
            document.getElementById('Sharepoint_restore').style.display = "none";
            document.getElementById('OneDrive_restore').style.display = "none";
            document.getElementById('Teams_restore').style.display = "none";
            document.getElementById('AAD_restore').style.display = "block";
            document.getElementById('accordion_3').style.display = "none";
            this.setState({
                selectedRestoreType: "Azure Backup"
            });
        }
        else {
            document.getElementById('Exchange_restore').style.display = "block";
            document.getElementById('Sharepoint_restore').style.display = "block";
            document.getElementById('OneDrive_restore').style.display = "block";
            document.getElementById('Teams_restore').style.display = "block";
            document.getElementById('AAD_restore').style.display = "none";
            document.getElementById('accordion_3').style.display = "block";
            this.setState({
                selectedRestoreType: "365 Backup"
            });
        }
    }
    //renderCustomDay(event) {
    //    alert(event)

    //}
    //onAADChange(event) {
    //    this.search(null, "", moment(event, "DD-MM-YYYY").format("DD-MM-YYYY"));
    //}

    async getAADBackupConfigDataListing(orgName, filterDate, type) {
        const authContext = this.props.authContext || this.context;
        const { setAuthContext } = authContext;
        var tokenString = await setAuthContext(new Date());
        const config = {
            headers: {
                Authorisation: `Bearer ` + tokenString,
                CallDomain: window.location.origin,
                CloudCoverToken: sessionStorage.getItem('CloudCoverToken'),
            },
        };
        this.setState({
            isAADRestoreTableLoaded: false
        })
        //let fileName = "";
        //var restorePoint = null;
        //for (var i = 0; i < this.state.mark.length; i++) {
        //    restorePoint = this.state.mark[i];
        //    console.log(this.state.selectedRestoreTime);
        //    if (restorePoint.restoreDate.includes(this.state.selectedRestoreTime)) {
        //        this.setState({
        //            entraRestorePoint: restorePoint
        //        });
        //       // fileName = restorePoint.fileName;
        //        break;
        //    }
        //}

        Axios.get(API_ROUTE + Routes.ENTRA_BACKUP_LOGS(this.state.orgId, orgName,'0'), config)
            .then((response) => {
                this.overlayProgress(false);
                let results = JSON.parse(response.data);

                results = results.filter(item => item.startTime.includes(filterDate) && item.diffCount !== '0');
                if (results.length > 0) {
                    this.setState({
                        aadviewItems: results,
                        aadnoResults: false,
                        activeAccordion: "2",
                        isAADRestoreTableLoaded: true
                    })
                }
            })
            .catch((reason) => {
                this.overlayProgress(false);
                this.setState({
                    inProgressRight: false,
                    isAADRestoreTableLoaded: true
                });
                if (reason?.response?.status === 440) {
                    window.location.href = "/TimeoutErrorHandler";
                }
            });
    }
    deleteQuery(event, query) {
        event.preventDefault();
        var array = this.state.searchQueries;
        var index = array.indexOf(query);
        if (index !== -1) {
            array.splice(index, 1);
        }
        this.setState({
            searchQueries: array,
        });
    }

    openSearchPanel(event) {
        event.preventDefault();
        this.setState({
            searchPanelOpen: !this.state.searchPanelOpen,
        });
    }

    openSearchHistoryPanel(event) {
        event.preventDefault();
        this.setState({
            searchHistoryPanelOpen: !this.state.searchHistoryPanelOpen,
        });
    }

    clearFolder(event) {
        event.preventDefault();
        this.setState({
            selectedFolder: null,
            viewItems: [],
            gridViewItems: [],
            oldItems: [],
            noResults: false,
            selectedItems: [],
            expandedFolders: [],
        });
    }

    handleFilter(items) {
        /*return (searchValue) => {
            if (searchValue.length === 0) {
                return options;
            }
            const updatedItems = items.map((list) => {
                const newItems = list.items.filter((item) => {
                    return item.name.toLowerCase().includes(searchValue.toLowerCase());
                });
                return { ...list, items: newItems };
            });
            return updatedItems;*/
        // };
    };
    transformData = (data) => {
        const transformed = {
            id: data.id,
            name: data.title,
            email: data.email,
            _actions: {}
        };

        // Transforming actions array to _actions object
        data.actions.forEach(action => {
            const actionKey = action.name.replace(/ /g, ''); // Convert to lowercase and remove spaces
            transformed._actions[actionKey] = {
                uri: action.href,
                method: action.type,
            };
        });

        return transformed;
    };
    async BulkRestore(event) {
        const authContext = this.props.authContext || this.context;
        const { setAuthContext } = authContext;
        var tokenString = await setAuthContext(new Date());
        const config = {
            headers: {
                Authorisation: `Bearer ` + tokenString,
                CallDomain: window.location.origin,
                CloudCoverToken: sessionStorage.getItem('CloudCoverToken'),
            },
        };
        
        if (this.state.restoreType === "vex") {
            const transformedDataArray = this.state.multiSelectItems.map(this.transformData);
            let bulkRestoreJson = {
                mailboxes: transformedDataArray,
                changedItems: true,

                deletedItems: true,

                markRestoredAsUnread: true,

                skipUnresolved: false,

                excludeDrafts: this.state.bulkRestoreOptions.excludeDrafts,

                excludeDeletedItems: this.state.bulkRestoreOptions.excludeDeletedItems,

                excludeInPlaceHoldItems: this.state.bulkRestoreOptions.excludeInPlaceHoldItems,

                excludeLitigationHoldItems: this.state.bulkRestoreOptions.excludeLitigationHoldItems,
            }
            Axios.post(API_ROUTE + Routes.EXCHANGE_BULK_RESTORE(this.state.multiSelectItems[0].actions[0].href.split('/')[3]), bulkRestoreJson, config)
                .then((response) => {
                    try {
                        let results = JSON.parse(response.data.result);
                        const hasSessionId = results.hasOwnProperty('sessionId');
                        if (hasSessionId) {
                            toast.success('Bulk restore initiated', { autoClose: 10000 });
                        }
                        else {
                            toast.error('Error initiating bulk restore', { autoClose: 10000 });
                        }
                    }
                    catch (e) {

                    }
                    this.setState({
                        showBulkRestore: false
                    });
                })
                .catch((reason) => {

                    if (reason?.response?.status === 440) {
                        window.location.href = "/TimeoutErrorHandler";
                    }
                });
        }
        else {
            const transformedDataArray = this.state.multiSelectItems.map(item => ({
                id: item.id,
                name: item.title,
                url: item.email
            }));
            ////let queryString = this.state.multiSelectItems[0].getFolders.split('/')[1] + '/RestoreSessions/' + this.state.multiSelectItems[0].getFolders.split('/')[3] + '/Organization/OneDrives/restore';
            let bulkRestoreJson = {
                documentAction: "Overwrite",
                skipUnresolved: false,
                oneDrives: transformedDataArray
            }
            //Axios.post(API_ROUTE + Routes.ONEDRIVE_BULK_RESTORE + '?type=' + this.state.restoreType + '&queryString=' + queryString, bulkRestoreJson, config)
            Axios.post(API_ROUTE + Routes.ONEDRIVE_BULK_RESTORE(this.state.multiSelectItems[0].getFolders.split('/')[3]), bulkRestoreJson, config)
                .then((response) => {
                    
                    try {
                        let results = JSON.parse(response.data.result);
                        const hasSessionId = results.hasOwnProperty('sessionId');
                        if (hasSessionId) {
                            toast.success('Bulk restore initiated', { autoClose: 10000 });
                        }
                        else {
                            toast.error('Error initiating bulk restore', { autoClose: 10000 });
                        }
                    }
                    catch (e) {

                    }
                    this.setState({
                        showBulkRestore: false
                    });

                })
                .catch((reason) => {

                    if (reason?.response?.status === 440) {
                        window.location.href = "/TimeoutErrorHandler";
                    }
                });

        }
        this.setState({
            showBulkRestore: false,
            ////clearLeftSection:true
        });
    }
    showBulkRestore(type) {
        this.setState({
            showBulkRestore: true
        });
    }
    hideBulkRestore(event) {
        this.setState({
            showBulkRestore: false
        });
    }
    onBulkRestoreChecked(event) {
        let type = event.target.name;
        if (type ==="excludeDrafts") {
            this.setState(prevState => ({
                bulkRestoreOptions: {
                    ...prevState.bulkRestoreOptions,
                    excludeDrafts: !prevState.bulkRestoreOptions.excludeDrafts 
                }
            }));
        }
        else if (type === "excludeDeletedItems") {
            this.setState(prevState => ({
                bulkRestoreOptions: {
                    ...prevState.bulkRestoreOptions,
                    excludeDeletedItems: !prevState.bulkRestoreOptions.excludeDeletedItems
                }
            }));
        }
        else if (type === "excludeInPlaceHoldItems") {
            this.setState(prevState => ({
                bulkRestoreOptions: {
                    ...prevState.bulkRestoreOptions,
                    excludeInPlaceHoldItems: !prevState.bulkRestoreOptions.excludeInPlaceHoldItems
                }
            }));
        }
        else if (type === "excludeLitigationHoldItems") {
            this.setState(prevState => ({
                bulkRestoreOptions: {
                    ...prevState.bulkRestoreOptions,
                    excludeLitigationHoldItems: !prevState.bulkRestoreOptions.excludeLitigationHoldItems
                }
            }));
        }
    }
    render() {
        
        //true = disable
        let isAddButtonDisabled = false
        let dropdownsCheck = this.state.searchType !== "----" && this.state.searchType !== "null" && this.state.searchField !== "----" && this.state.searchField !== "null" && this.state.searchQueryType !== "----" && this.state.searchQueryType !== "null" && this.state.searchQueryType;
        if (this.state.isBetweenCondition) {
            isAddButtonDisabled = dropdownsCheck && this.state.searchTerm.trim() !== "";
        }
        else if (this.state.searchTermDateVisible) {
            isAddButtonDisabled = (dropdownsCheck && this.state.searchTermDate !== null) ||
                (dropdownsCheck && ['today', 'yesterday', 'tomorrow', 'last7Days', 'next7Days',
                'last Week', 'this Week', 'next Week', 'lastMonth', 'nextMonth', 'thisMonth', 'lastYear', 'nextYear', 'thisYear'].includes(this.state.selectedCondition));
        }
        else {
            isAddButtonDisabled = dropdownsCheck && this.state.searchTerm.trim() !== "" && this.state.searchTerm.trim() !== "---";
        }
        isAddButtonDisabled = !isAddButtonDisabled;
        
        //if (!this.state.gotRestoreDates) {
        //    return <React.Fragment>
        //        <div>Please wait..</div>
        //    </React.Fragment>;
        //} else 
        if (this.state.checkRestoreDates && this.state.noRestoreDates) {
            return (
                <React.Fragment>

                    <NavBar
                        page="restore"
                        impersonating={this.state.impersonating}
                        orgName={this.state.orgName}
                        isAzureGuardianOnly={this.state.GuardianOnlyEnabled}
                        authContext={this.props.authContext || this.context}
                    />
                    <div className="row">
                        {/* <div
                            className="col"
                            style={{ minWidth: "385px", maxWidth: "400px" }}
                        >
                            <div className="card">
                                <div className="card-header">Error</div>
                            </div>
                        </div>*/}
                        <div className="col">
                            <div className="card">
                                <div className="card-header">
                                    There are currently no restore points available for your organisation. Please wait for your first backup job to complete or contact support if you believe you have a problem.                                </div>
                            </div>

                        </div>

                    </div>

                </React.Fragment>
            );
        }
        let buttonDisabled =
            this.state.inProgressLeft ||
            this.state.inProgressRight ||
            this.state.inProgressRestore;
        let select = null;
        let selectOptions = [];
        let tree = null;
        let treeItems = [];
        let refreshIcon = [];
        let confirmationModal = [];
        let confirmationModalContent = [];

        if (this.state.restoreType === "vesp") {
            confirmationModalContent = (
                <div className="card">
                    <div className="card-body">
                        <p>Resetting your cache may take some time, Are you sure?</p>
                    </div>
                    <div className="card-footer">
                        <div className="row">
                            <div className="col" />
                            <div className="col">
                                <Button onClick={() => {
                                    selectOptions = [];
                                    this.setState({
                                        //dropdownOptions:[],
                                        clearCacheChecked: true,
                                        showConfirmationModal: false,
                                    });
                                    this.getSelectItems();
                                }}>
                                    Ok
                                </Button>

                            </div>
                            <div className="col" >

                                <Button onClick={() => {
                                    this.setState({
                                        showConfirmationModal: false
                                    });
                                }}>
                                    Cancel
                                </Button>
                            </div>
                            <div className="col" />
                        </div>
                    </div>
                </div>
            );
            confirmationModal = (
                <Modal isOpen={this.state.showConfirmationModal}>
                    {confirmationModalContent}
                </Modal>
            );

            refreshIcon = (<button className="link-button" title="Refresh" id="ContentPlaceHolder1_btnResetCache" onClick={() => {
                this.setState({
                    showConfirmationModal: true
                });

            }}
            ><i className="fas fa-sync"></i>&nbsp; </button>);
        }
        if (this.state.restoreType === 'aad') {

        }

        if (this.state.restore || this.state.timeoutError) {
            if (this.state.timeoutError) {
                select = (
                    <FormGroup>
                        <div style={{
                            display: "flex",
                            alignItems: "center",
                            border: "1px solid #ccc",
                            padding: "10px",
                            borderRadius: "5px",
                            backgroundColor: "#f9f9f9",
                            gap: "10px"
                        }}>

                            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="red" viewBox="0 0 16 16" style={{ marginBottom: "auto" }}>
                                <path d="M8.515 1.019A7 7 0 0 0 8 1V0a8 8 0 0 1 .589.022zm2.004.45a7 7 0 0 0-.985-.299l.219-.976q.576.129 1.126.342zm1.37.71a7 7 0 0 0-.439-.27l.493-.87a8 8 0 0 1 .979.654l-.615.789a7 7 0 0 0-.418-.302zm1.834 1.79a7 7 0 0 0-.653-.796l.724-.69q.406.429.747.91zm.744 1.352a7 7 0 0 0-.214-.468l.893-.45a8 8 0 0 1 .45 1.088l-.95.313a7 7 0 0 0-.179-.483m.53 2.507a7 7 0 0 0-.1-1.025l.985-.17q.1.58.116 1.17zm-.131 1.538q.05-.254.081-.51l.993.123a8 8 0 0 1-.23 1.155l-.964-.267q.069-.247.12-.501m-.952 2.379q.276-.436.486-.908l.914.405q-.24.54-.555 1.038zm-.964 1.205q.183-.183.35-.378l.758.653a8 8 0 0 1-.401.432z" />
                                <path d="M8 1a7 7 0 1 0 4.95 11.95l.707.707A8.001 8.001 0 1 1 8 0z" />
                                <path d="M7.5 3a.5.5 0 0 1 .5.5v5.21l3.248 1.856a.5.5 0 0 1-.496.868l-3.5-2A.5.5 0 0 1 7 9V3.5a.5.5 0 0 1 .5-.5" />
                            </svg>


                            <div style={{ color: 'red', fontWeight: 'bold' }}>
                                <span style={{ fontWeight: 'normal' }}>
                                    Please try again. If the issue persists, contact support.
                                </span>
                            </div>
                        </div>
                    </FormGroup>
                );             
            }
            else if (this.state.selectItems.length > 0) {
                for (var i = 0; i < this.state.selectItems.length; i++) {
                    const item = this.state.selectItems[i];
                    selectOptions.push({ label: item.title, value: item.id });
                }
                select = (
                    <>
                    <FormGroup>
                        <Label for="itemSelect">Select item to restore from.&emsp;&emsp;&emsp;&emsp;&emsp;</Label>
                            {refreshIcon}
                            {/*onChange={this.selectItem}*/}
                            <MultiSelect
                                isMulti={this.state.restoreType === "vex" || this.state.restoreType === "veod" }
                                options={this.state.showDropdown ? selectOptions : []}
                                placeholder="search"
                                
                                onChange={(value) => {
                                    if (this.state.restoreType === "vex" || this.state.restoreType === "veod") {
                                        this.selectItem(value);
                                    }
                                    else {
                                        this.singleSelectItem(value);
                                    }
                                }}
                                isClearable={(this.state.restoreType === "vex" || this.state.restoreType === "veod")}
                                className="multi-select"
                            />
                        </FormGroup>
                    </>
                );
                if (this.state.treeItems.length > 0) {
                    for (var j = 0; j < this.state.treeItems.length; j++) {
                        const folder = this.state.treeItems[j];
                        let treeItem = this.createTreeItem(folder, j);
                        treeItems.push(treeItem);
                    }
                }
            }
            let treeInner = null;
            if (this.state.selectItem) {
                let label = "";
                if (this.state.restoreType === "vex") {
                    label = "Mailbox";
                }
                if (this.state.restoreType === "vesp") {
                    label = "Sites";
                } else if (this.state.restoreType === "veod") {
                    label = "Drive";
                } else if (this.state.restoreType === "vet") {
                    label = "Team";
                }
                let buttonDisabled =
                    this.state.inProgressLeft ||
                    this.state.inProgressRight ||
                    this.state.inProgressRestore;
                ////if (this.state.restoreType === "veod") {
                ////    treeInner = <React.Fragment>{treeItems}</React.Fragment>;
                ////} else
                    if ((this.state.restoreType === "vex" || this.state.restoreType === "veod") && this.state.multiSelectItemsIds.length > 1) {
                    treeInner = (
                        <div className="d-flex justify-content-center mt-4">
                            <button className="btn-primary btn" onClick={(e) => {
                                if (this.state.restoreType === 'vex') {
                                    this.showBulkRestore('vex');
                                } else {
                                    this.showBulkRestore('veod');
                                }
                            }}>Bulk Restore</button>
                        </div>
                    );
                }

                else {
                    treeInner = (
                        <TreeItem
                            key={"root"}
                            nodeId={"root"}
                            label={label}
                            onClick={e => this.folderClick(e, null, null, true)}
                            disabled={buttonDisabled}
                        >
                            {treeItems}
                        </TreeItem>
                    );
                }
            }
            tree = (
                <TreeView
                    expanded={this.state.expandedFolders}
                    style={{ textAlign: "left" }}
                    disableSelection={buttonDisabled}
                    className="p-2"
                >
                    {select}
                    {treeInner}
                </TreeView>
            );
        }
        let noItemsWarning;
        if (this.state.gotSelectItems && this.state.selectItems.length === 0) {
            noItemsWarning = (
                <div className="row">
                    <div className="col">
                        <p>Could not retreive any items you can restore.</p>
                    </div>
                </div>
            );
        }
        let leftSpinner;
        if (!((this.state.restoreType === "vex" || this.state.restoreType === "veod") && this.state.multiSelectItemsIds.length > 1)) {
            if (this.state.inProgressLeft && !this.state.timeoutError) {
                leftSpinner = (
                    <div className="d-flex justify-content-center">
                        <img src={LoaderGif} alt="loading" style={{ height: '50px' }} />
                    </div>
                );
            }
        }
        let leftSection = (
            <React.Fragment>
                {tree}
                {leftSpinner}
            </React.Fragment>
        );



        if (this.state.restoreType === "aad") {
            leftSection = (
                <React.Fragment>
                    <Calendar style={{ height: 500 }}
                        onChange={this.onChange}
                        value={this.state.date}

                        tileClassName={({ date, view }) => {
                            for (var i = 0; i < this.state.mark.length; i++) {
                                var x = this.state.mark[i].restoreDate.split(' ')[0];
                                if (x === moment(date).format("DD-MM-YYYY")) {
                                    return 'highlight';
                                }
                            }

                        }}
                    >
                    </Calendar>

                    {!this.state.aadnoResults && (
                        <div>
                            <Table border="1" className="mt-3">
                                <thead>
                                    <tr>
                                        <th style={{ backgroundColor: 'rgb(81, 145, 206)', color: 'white' }}>Date</th>
                                        <th style={{ backgroundColor: 'rgb(81, 145, 206)', color: 'white' }}>Process</th>
                                        <th style={{ backgroundColor: 'rgb(81, 145, 206)', color: 'white' }}>Diff</th>
                                    </tr>
                                </thead>
                                <tbody style={{ fontSize: '13px' }}>
                                    {this.state.aadviewItems.map((item, index) => (
                                        <tr key={index}
                                            onClick={() => this.getAADBackupConfigData(item.diffFile, this.state.orgName, item)} style={{ cursor: 'pointer' }}>
                                            <td>{item.startTime}</td>
                                            <td>{item.process}</td>
                                            <td>{item.diffCount}</td>
                                        </tr>
                                    ))}
                                </tbody>
                            </Table>
                        </div>
                    )}
                </React.Fragment>
            )
        }
        let rightSection;
        if (this.state.viewItems.length === 0 && this.state.gridViewItems.length === 0 && this.state.selectItems.length === 0 && this.state.inProgressRight === false && !this.state.isAzureGuardianOnly) {

            rightSection = (
                <Collapse isOpen={!this.state.searchHistoryPanelOpen && this.state.allSessionEvents.length === 0}>
                    <div className="ps-3">
                        <p className="titletext" style={{ fontWeight: '500', fontSize: '25px', textAlign: "center" }}> CloudCover 365 </p>

                        <p className="mb-3">Restore all Microsoft 365 data from the CloudCover 365 recovery screen, including Exchange, SharePoint, OneDrive, Teams and Azure (if it forms part of your package).</p>
                        <p className="mb-3" style={{ fontWeight: 'bold' }}>How to use the recovery tool:</p>

                        <ol>
                            <li className="mb-2" style={{ display: 'list-item' }}>Select the restoration type.</li>
                            <li className="mb-2" style={{ display: 'list-item' }}>Add the reason for the restoration.</li>
                            <li className="mb-2" style={{ display: 'list-item' }}>Select a restoration date from the calendar, or via the &lsquo;Show all restore points &lsquo; option.</li>
                            <li className="mb-2" style={{ display: 'list-item' }}>Choose the item type you wish to restore.</li>
                            <li className="mb-2" style={{ display: 'list-item' }}>Select the required data and start the restoration process.</li>
                        </ol>


                        <p className="mb-3" style={{ fontWeight: 'bold' }}>Tips:</p>

                        <ul>
                            <li className="mb-2" style={{ display: 'list-item' }}>If you need to restore a file that was last seen two weeks ago, select a restore point before this date.</li>
                            <li className="mb-2" style={{ display: 'list-item' }}>To restore a tree item, highlight it and use the &lsquo;restore folders&lsquo; menu. This will show you your tree restoration options.</li>
                            <li className="mb-2" style={{ display: 'list-item' }}>To restore items with tree nodes (e.g. Mail items), simply select them with the tick box and then use the &lsquo;restore items&lsquo; menu. This will show you your item restore options.</li>

                        </ul>

                        <p className="mb-3">Please note that some items may take a while to download.</p>

                    </div>
                </Collapse>

            );


        }
        const style = {
            width: '99%',
            height: '100%'
        };
        const defaultColDef = {
            editable: false,
            sortable: true,
            wrapText: true,
            autoHeight: true,
            flex: 1,
            minWidth: 100,
            filter: false,
            resizable: true
        };
        let result;
        if (this.state.gridViewItems.length > 0) {

            let table = (
                <div style={{ maxHeight: "1300px" }}>

                    <div className="ag-theme-alpine" id='restore-grid' style={{ borderColor: "#F0F0F0", marginBottom:"10px", width: "100%", borderStyle: "Solid", maxHeight: '1300px', borderCollapse: "collapse", height: this.state.selectedRestoreType === "Azure Backup" ? "710px" : "500px" }}>
                        <AgGridReact style={style}
                            columnDefs={this.state.columnDefs}
                            defaultColDef={defaultColDef}
                            getRowStyle={this.getRowStyle}
                            onGridReady={this.restoreOnGridReady}
                            rowSelection={{ mode: 'multiRow' }}
                            enableCellTextSelection="true"
                            onRowSelected={this.OnItemSelected}
                            autoHeight={true}
                            pagination={false}
                            selectionChanged={this.OnselectionChanged}
                            overlayLoadingTemplate={
                                `<div style="position:absolute;top:50%;left:50%;transform:translate(-50%, -50%);"><img src="${LoaderGif}" alt="loading" style="height:50px;"></div>`}
                            overlayNoRowsTemplate={'<span className="ag-overlay-loading-center">No rows to display</span>'}
                            suppressScrollOnNewData={true}
                            suppressPaginationPanel={true}                        >
                        </AgGridReact>
                    </div>
                    {this.state.gridViewItems.length > 0 && (
                        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'right', marginTop: "5px" }}>
                            <span>
                                Go to:{" "}
                                <>
                                    <input
                                        type="number"
                                        min="1"
                                        max={this.state.dataCount}
                                        value={isNaN(this.state.pageInputValue) ? '' : (this.state.pageInputValue)}
                                        style={{ width: "60px", marginRight: "5px" }}
                                        id="go-to-page"
                                        onChange={(e) => {
                                            const value = parseInt(e.target.value);
                                            this.setState({ pageInputValue: value });
                                        }}
                                        onKeyDown={(e) => {
                                            if (e.key === "Enter") {
                                                const value = parseInt(e.target.value);
                                                const totalPages = this.state.dataCount ;

                                                if (!isNaN(value) && value >= 1 && value <= totalPages) {
                                                    this.goToPageFromInput(value -1);
                                                }
                                            }
                                        }}
                                    />

                                    {(this.state.pageInputValue < 1 || this.state.pageInputValue > (this.state.dataCount)) && (
                                        <div style={{ color: 'red', fontSize: '10px' }}>
                                            Page must be between 1 and {this.state.dataCount}
                                        </div>
                                    )}
                                </>

                            </span>

                            {/* Record Range */}
                            <span style={{ fontWeight: "bold" }}>
                                {(() => {
                                    const start = (this.state.gridPage * this.state.pageSize) + 1;
                                    const end = start + this.state.gridViewItems.length - 1;
                                    return `${start} to ${end}`;
                                })()}
                            </span>

                            <span style={{ margin: "0 5px" }}></span>

                            <button
                                style={{ fontWeight: "bold", outline: 'none', border: 'none', background: 'none', marginBottom: "3px" }}
                                onClick={(e) => this.paginationPreviousPage(e, false)}
                                disabled={this.state.gridPage === 0}>
                                {"<"}
                            </button>

                            <span style={{ margin: "0 5px" }}></span>

                            <span style={{ margin: "0 10px", fontWeight: "bold" }}>
                                {(() => {
                                    const currentPage = this.state.gridPage + 1;
                                    const totalPages = this.state.dataCount;
                                    return `Page ${currentPage} of ${totalPages}`;
                                })()}
                            </span>

                            <span style={{ margin: "0 5px" }}></span>

                            <button
                                style={{ fontWeight: "bold", outline: 'none', border: 'none', background: 'none', marginBottom: "3px" }}
                                onClick={(e) => this.paginationNextPage(e, false)}
                                disabled={this.state.nextBlocked || this.state.isLoading}>
                                {">"}
                            </button>
                        </div>
                    )}
                </div>
            );

            result = (
                <React.Fragment>
                    {table}
                    <div
                        className="row"
                        style={{
                            minWidth: "100%",
                        }}
                    >
                    </div>

                </React.Fragment>
            );
        }
        if (this.state.viewItems.length > 0) {

            let table = (
                <div style={{ maxHeight: "1300px" }}>
                    {/* {agGridValue} overflowY: "scroll", */}
                    {/* <Table style={{ textAlign: "center" }} striped>
                        {tableInner}
                    </Table> */}



                    <div className="ag-theme-alpine" id='restore-grid' style={{ borderColor: "#F0F0F0", width: "100%", borderStyle: "Solid", maxHeight: '1300px', borderCollapse: "collapse", height: this.state.selectedRestoreType ==="Azure Backup"?"710px":"500px"  }}>
                        <AgGridReact style={style}
                            columnDefs={this.state.columnDefs}
                            defaultColDef={defaultColDef}
                            getRowStyle={this.getRowStyle}
                            onGridReady={this.onGridReady}
                            rowSelection={{ mode: 'multiRow' }}
                            enableCellTextSelection="true"
                            onRowSelected={this.OnItemSelected}
                            //autoSizeStrategy={autoSizeStrategy}
                            autoHeight={true}
                            pagination={true}
                            paginationPageSizeSelector={[10, 20, 50,100]}
                            selectionChanged={this.OnselectionChanged}
                            paginationPageSize={100}
                            overlayLoadingTemplate={
                                `<div style="position:absolute;top:50%;left:50%;transform:translate(-50%, -50%);"><img src="${LoaderGif}" alt="loading" style="height:50px;"></div>`}
                            overlayNoRowsTemplate={'<span className="ag-overlay-loading-center">No rows to display</span>'}
                            suppressScrollOnNewData={true}>
                        </AgGridReact>
                    </div>
                </div>
            );

            result = (
                <React.Fragment>
                    {table}
                    <div
                        className="row"
                        style={{
                            minWidth: "100%",
                        }}
                    >
                    </div>

                </React.Fragment>
            );
        }
        let restoreButtons = [];
        if (this.state.restore) {
            if (this.state.selectItem) {
                let type = "root";
                let pstButton = null;
                let pstCommand;
                let restoreToOrignalCommand = "restore";
                if (this.state.restoreType === "vesp") {
                    restoreToOrignalCommand = "restore";
                }
                if (this.state.restoreType === "vet") {
                    restoreToOrignalCommand = "restore";
                }
                if (this.state.restoreType === "vex") {
                    pstCommand = "exporttoPst";
                    pstButton = (
                        <DropdownItem
                            onClick={(e) => this.openDownloadModal(e, pstCommand, type)}
                        >
                            Restore to Local PST
                        </DropdownItem>
                    );
                }
                let rootRestoreString = "Root Restore";
                if (this.state.restoreType === "vet") {
                    rootRestoreString = "Team Restore";
                }
                let rootRestore = (
                    <Dropdown
                        key="root"
                        value="rootRestoreOpens"
                        isOpen={this.state.rootRestoreOpen}
                        toggle={(e) => this.toggleDropdown(e, "rootRestoreOpen")}
                        className="me-2"
                    >
                        <DropdownToggle caret style={{ maxWidth: "150px" }}>
                            {rootRestoreString}
                        </DropdownToggle>
                        <DropdownMenu>
                            {!this.state.isEndUser && (< DropdownItem
                                onClick={(e) =>
                                    this.openVerificationModal(e, restoreToOrignalCommand, type)
                                }
                            >
                                Restore to Original Location
                            </DropdownItem>)}
                            {this.state.restoreType === "vesp" && !this.state.isEndUser &&
                                <DropdownItem
                                    disabled={this.state.isEndUser}
                                    onClick={(e) => {
                                        if (!this.state.isEndUser) {
                                            this.setState(
                                                {
                                                    openSharepointModal: true,
                                                    type: type

                                                },
                                                () => {

                                                }
                                            );

                                        }
                                    }}
                                >

                                    Restore to Another Sharepoint Site
                                </DropdownItem>
                            }
                            {this.state.restoreType === "veod" &&
                                <DropdownItem
                                    disabled={this.state.isEndUser}
                                    onClick={(e) => {
                                        if (!this.state.isEndUser) {

                                            this.setState(
                                                {
                                                    showoneDriveModal: true,
                                                    type: type

                                                },
                                                () => {

                                                }
                                            );

                                        }
                                    }}
                                >
                                    Copy to Another OneDrive Folder
                                </DropdownItem>
                            }
                            {pstButton}
                            {this.state.restoreType === "vex" && !this.state.isEndUser &&
                                <DropdownItem
                                    disabled={this.state.isEndUser}
                                    onClick={(e) => { this.anotherMailBox(e, type) }}
                                >
                                    Restore to Another Exchange Mailbox
                                </DropdownItem>
                            }
                        </DropdownMenu>
                    </Dropdown>
                );

                if (!((this.state.restoreType === "vex" || this.state.restoreType === "veod") && this.state.multiSelectItemsIds.length > 1)) {
                    if (!this.state.searchResultsFlag) {
                        restoreButtons.push(rootRestore);
                    }
                }
                
            }
            if (
                (this.state.restoreType === "vet" && this.state.lastClicked) ||
                (this.state.selectedFolder &&
                    !this.state.selectedFolder.isSharepointTopLevel &&
                    !this.state.selectedFolder.isOnedriveTopLevel)
            ) {
                let type = "folder";
                let pstCommand = "exporttoPst";
                let zipCommand = "save";
                let mailCommand = "send";
                let restoreToOrignalCommand = "restore";
                let pstButton;
                let zipButton;
                let mailButton;
                let litigationHoldButton;
                if (this.state.restoreType === "vex") {
                    restoreToOrignalCommand = "restore";
                    pstCommand = "exporttoPst";
                    pstButton = (
                        <DropdownItem
                            onClick={(e) => this.openDownloadModal(e, pstCommand, type)}
                        >
                            Restore to Local PST
                        </DropdownItem>
                    );

                    if (this.state.IsLitigationHoldApplicable) {
                        litigationHoldButton = (
                            <DropdownItem
                                onClick={(e) => {
                                    this.setState({
                                        /*litigation: true,*/
                                        litigation: {
                                            state: true,
                                            popUp: true,
                                            description: "",
                                            action: pstCommand,
                                            type: type
                                        },

                                    });
                                    /*this.openDownloadModal(e, pstCommand, type);*/
                                }}
                            >
                                Litigation Hold
                            </DropdownItem>
                        );
                    }
                } else if (this.state.restoreType === "vesp") {
                    restoreToOrignalCommand = "restore";
                } else if (this.state.restoreType === "veod") {
                    zipButton = (
                        <DropdownItem
                            onClick={(e) => this.openDownloadModal(e, zipCommand, type)}
                        >
                            Restore to Local Zip
                        </DropdownItem>
                    );
                    mailButton = (
                        <DropdownItem
                            onClick={(e) => this.openMailModal(e, mailCommand, type)}
                        >
                            Mail To Someone
                        </DropdownItem>
                    );
                    if (this.state.IsLitigationHoldApplicable) {
                        litigationHoldButton = (
                            <DropdownItem
                                onClick={(e) => {
                                    this.setState({
                                        /*litigation: true,*/
                                        litigation: {
                                            state: true,
                                            popUp: true,
                                            description: "",
                                            action: zipCommand,
                                            type: type
                                        },
                                    });
                                    /*this.openDownloadModal(e, zipCommand, type);*/
                                }}
                            >
                                Litigation Hold
                            </DropdownItem>
                        );
                    }
                }
                let folderRestoreString = "Folder Restore";
                if (this.state.restoreType === "vet") {
                    folderRestoreString = "Channel Restore";
                }
                let folderRestore = (
                    <Dropdown
                        key="folder"
                        value="folderRestoreOpen"
                        isOpen={this.state.folderRestoreOpen}
                        toggle={(e) => this.toggleDropdown(e, "folderRestoreOpen")}
                        className="me-2"
                    >
                        <DropdownToggle caret style={{ maxWidth: "150px" }}>
                            {folderRestoreString}
                        </DropdownToggle>
                        <DropdownMenu>
                            {!this.state.isEndUser && (< DropdownItem
                                onClick={(e) =>
                                    this.openVerificationModal(e, restoreToOrignalCommand, type)
                                }
                            >
                                Restore to Original Location
                            </DropdownItem>)}

                            {this.state.restoreType === "vesp" && !this.state.isEndUser &&
                                <DropdownItem
                                    disabled={this.state.isEndUser}
                                    onClick={(e) => {
                                        if (!this.state.isEndUser) {
                                            this.setState(
                                                {
                                                    openSharepointModal: true,
                                                    type: type
                                                },
                                                () => {

                                                }
                                            );

                                        }
                                    }}
                                >
                                    Restore to Another Sharepoint Site
                                </DropdownItem>
                            }


                            {this.state.restoreType === "veod" &&
                                <DropdownItem
                                    disabled={this.state.isEndUser}
                                    onClick={(e) => {
                                        if (!this.state.isEndUser) {
                                            this.setState(
                                                {
                                                    showoneDriveModal: true,
                                                    type: type

                                                },
                                                () => {

                                                }
                                            );

                                        }
                                    }}
                                >
                                    Copy to Another OneDrive Folder
                                </DropdownItem>
                            }
                            {pstButton}
                            {litigationHoldButton}
                            {zipButton}
                            {this.state.restoreMailTo !== "0" && mailButton}
                            {this.state.restoreType === "vex" && !this.state.isEndUser &&
                                <DropdownItem
                                    disabled={this.state.isEndUser}
                                    onClick={(e) => { this.anotherMailBox(e, type) }}
                                >
                                    Restore to Another Exchange Mailbox
                                </DropdownItem>
                            }
                        </DropdownMenu>
                    </Dropdown>
                );
                if (!((this.state.restoreType === "vex" || this.state.restoreType === "veod") && this.state.multiSelectItemsIds.length > 1)) {
                    if (!this.state.searchResultsFlag) {
                        restoreButtons.push(folderRestore);
                    }
                }
                
            }
            if (this.state.selectedItems.length > 0) {
                let type = "item";
                let restoreToOrignalCommand = "";
                let mailToCommand = "";
                let mailToOwnerCommand = "";
                let pstCommand = "";
                let zipCommand = "";
                let localPstButton = null;
                let localZipButton = null;
                let mailToOwnerButton = null;
                let mailToSomeoneButton = null;
                if (this.state.restoreType === "vex") {
                    restoreToOrignalCommand = "restore";
                    mailToCommand = "sendtoDifferentaddress";
                    mailToOwnerCommand = "sendtoDefaultaddress";
                    pstCommand = "exporttoPst";
                    zipCommand = "save";
                    localPstButton = (
                        <DropdownItem
                            onClick={(e) => this.openDownloadModal(e, pstCommand, type)}
                        >
                            Restore to Local PST
                        </DropdownItem>
                    );
                    mailToOwnerButton = (
                        <DropdownItem
                            onClick={(e) => this.openMailModal(e, mailToOwnerCommand, type)}
                        >
                            Mail to Owner
                        </DropdownItem>
                    );
                    mailToSomeoneButton = (
                        <DropdownItem
                            onClick={(e) => this.openMailModal(e, mailToCommand, type)}
                        >
                            Mail to Someone
                        </DropdownItem>
                    );
                    localZipButton = (
                        <DropdownItem
                            onClick={(e) => this.openDownloadModal(e, zipCommand, type)}
                        >
                            Restore to Local Zip
                        </DropdownItem>
                    );
                } else if (this.state.restoreType === "vesp") {
                    restoreToOrignalCommand = "restore";
                    mailToCommand = "send";
                    mailToOwnerCommand = "MailtoSource";
                    zipCommand = "save";
                    if (this.state.lastClicked === "Libraries") {
                        localZipButton = (
                            <DropdownItem
                                onClick={(e) => this.openDownloadModal(e, zipCommand, type)}
                            >
                                Restore to Local Zip
                            </DropdownItem>
                        );
                        mailToSomeoneButton = (
                            <DropdownItem
                                onClick={(e) => this.openMailModal(e, mailToCommand, type)}
                            >
                                Mail to Someone
                            </DropdownItem>
                        );
                    }
                } else if (this.state.restoreType === "veod") {
                    restoreToOrignalCommand = "restore";
                    mailToCommand = "send";
                    mailToOwnerCommand = "MailtoSource";
                    zipCommand = "save";
                    localZipButton = (
                        <DropdownItem
                            onClick={(e) => this.openDownloadModal(e, zipCommand, type)}
                        >
                            Restore to Local Zip
                        </DropdownItem>
                    );
                    mailToSomeoneButton = (
                        <DropdownItem
                            onClick={(e) => this.openMailModal(e, mailToCommand, type)}
                        >
                            Mail to Someone
                        </DropdownItem>
                    );
                } else if (this.state.restoreType === "vet") {
                    restoreToOrignalCommand = "restore";
                    mailToCommand = "send";
                    mailToOwnerCommand = "MailtoSource";
                    zipCommand = this.state.selectedFolder.title === "Files" ? "save" : "export";
                    let ddtext = this.state.selectedFolder.title === "Files" ? "Restore to Local Zip" : "Restore to Local HTML File";
                    localZipButton = (
                        <DropdownItem
                            onClick={(e) => this.openDownloadModal(e, zipCommand, type)}
                        >
                            {ddtext}                        </DropdownItem>
                    );
                    mailToSomeoneButton = (
                        <DropdownItem
                            onClick={(e) => this.openMailModal(e, mailToCommand, type)}
                        >
                            Mail to Someone
                        </DropdownItem>
                    );
                }
                if (this.state.restoreType === "vet") {
                    if (this.state.selectedFolder) {
                        if (this.state.selectedFolder.title === "Tabs") {
                            localPstButton = null;
                            localZipButton = null;
                            mailToOwnerButton = null;
                            mailToSomeoneButton = null;
                        }
                        if (this.state.selectedFolder.title === "Posts") {
                            localPstButton = null;
                            mailToOwnerButton = null;
                            mailToSomeoneButton = null;
                        }
                    }
                }
                let itemRestore = (
                    <Dropdown
                        key="item"
                        value="itemRestoreOpen"
                        isOpen={this.state.itemRestoreOpen}
                        toggle={(e) => this.toggleDropdown(e, "itemRestoreOpen")}
                    >
                        <DropdownToggle caret style={{ maxWidth: "150px" }}>
                            Item Restore
                        </DropdownToggle>
                        <DropdownMenu>
                            {!this.state.isEndUser && (< DropdownItem
                                onClick={(e) =>
                                    this.openVerificationModal(e, restoreToOrignalCommand, type)
                                }
                            >
                                Restore to Original Location
                            </DropdownItem>)}


                            {this.state.restoreType === "vesp" && !this.state.isEndUser &&
                                <DropdownItem
                                    disabled={this.state.isEndUser}
                                    onClick={(e) => {
                                        if (!this.state.isEndUser) {
                                            this.setState(
                                                {
                                                    openSharepointModal: true,
                                                    type: type
                                                },
                                                () => {

                                                }
                                            );

                                        }
                                    }}
                                >
                                    Restore to Another Sharepoint Site
                                </DropdownItem>
                            }


                            {this.state.restoreType === "veod" &&
                                <DropdownItem
                                    disabled={this.state.isEndUser}
                                    onClick={(e) => {
                                        if (!this.state.isEndUser) {
                                            this.setState(
                                                {
                                                    showoneDriveModal: true,
                                                    type: type
                                                },
                                                () => {

                                                }
                                            );

                                        }
                                    }}
                                >
                                    Copy to Another OneDrive Folder
                                </DropdownItem>
                            }
                            {localPstButton}
                            {localZipButton}
                            {mailToOwnerButton}
                            {this.state.restoreMailTo !== "0" && mailToSomeoneButton}
                            {this.state.IsLitigationHoldApplicable &&

                            (
                                this.state.restoreType === "vex" ?
                                    <DropdownItem
                                        onClick={(e) => {
                                            this.setState({
                                                /*litigation: true,*/
                                                litigation: {
                                                    state: true,
                                                    popUp: true,
                                                    description: "",
                                                    action: pstCommand,
                                                    type: type
                                                }
                                            });
                                            /*this.openDownloadModal(e, pstCommand, type);*/
                                        }}
                                    >
                                        Litigation Hold
                                    </DropdownItem> :
                                    this.state.restoreType !== "vet" ?
                                        <DropdownItem
                                            onClick={(e) => {
                                                this.setState({
                                                    //litigation: true,
                                                    litigation: {
                                                        state: true,
                                                        popUp: true,
                                                        description: "",
                                                        action: zipCommand,
                                                        type: type
                                                    }
                                                });
                                                //this.openDownloadModal(e, zipCommand, type);
                                            }}
                                        >
                                            Litigation Hold
                                        </DropdownItem> : null
                            )}
                            {this.state.restoreType === "vex" && !this.state.isEndUser &&
                                <DropdownItem
                                    disabled={this.state.isEndUser}
                                    onClick={(e) => { this.anotherMailBox(e, type) }}
                                >
                                    Restore to Another Exchange Mailbox
                                </DropdownItem>
                            }
                        </DropdownMenu>
                    </Dropdown>
                );
                if (!((this.state.restoreType === "vex" || this.state.restoreType === "veod") && this.state.multiSelectItemsIds.length > 1)) {
                    restoreButtons.push(itemRestore);
                }
                
            }
        }


        


        if (this.state.searchResultsFlag && !this.state.selectItem && this.state.selectedItems.length === 0) {
            restoreButtons = [];
        }
        let verificationModal = null;
        let mailModal = null;
        let toAnotherMailboxModal = null;
        let restoreModal = null;
        let restoreAAD = (
            <div>
                <Button key="RestoreAAD" onClick={this.onClickAADRestore}>
                    Restore
                </Button>
            </div>
        )
        if (this.state.restoreType === 'aad' && this.state.selectedItems.length > 0) {
            restoreButtons.push(restoreAAD);
        }
        let siteModal = null;
        let oneDriveModal = null;
                siteModal = (
                    <Modal isOpen={this.state.openSharepointModal}>
                        <div className="card">
                            <div className="card-body">
                                <div className="row">
                                    <div className="col">
                                        <p>Sharepoint Site :</p>
                                        <select className='form-select'
                                            value={this.state.siteURL}
                                            name="siteURL"
                                            onChange={this.editParameter}
                                        >
                                            <option value={"null"}>----</option>
                                            {this.state.selectItems.map(site => (
                                                <option key={site.email} value={site.email}>
                                                    {site.title}
                                                </option>
                                            ))}

                                        </select>
                                    </div>
                                </div>
                            </div>
                            <div className="card-footer">
                                <div className="row">
                                    <div className="col">
                                        <Button onClick={this.sharepointRestoreToContinue} disabled={this.state.siteURL === "null" || !this.state.siteURL} color="primary">
                                            Continue
                                        </Button>
                                    </div>
                                    <div className="col">
                                        <Button onClick={this.closesharepointRestoreToModal}>Cancel</Button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </Modal>
        );
       oneDriveModal = (
            <Modal isOpen={this.state.showoneDriveModal}>
                <div className="card">
                    <div className="card-body">
                        <div className="row">
                            <div className="col">
                               <p>Destination OneDrive:</p>
                                <select className='form-select'
                                   value={this.state.destinationOneDriveUrl}
                                   name="destinationOneDriveUrl"
                                    onChange={this.editParameter}
                               >
                                   <option value={"null"}>----</option>
                                    {this.state.selectItems.map(oneDrive => (
                                        <option key={oneDrive.email} value={oneDrive.email}>
                                            {oneDrive.title}
                                        </option>
                                    ))}

                                </select>
                           </div>
                           <div className="col">
                               <p>Destination OneDrive Folder:</p>
                               <input
                                   type="text"
                                   value={this.state.destinationFolder}
                                   placeholder="Destination Folder"
                                   name="destinationFolder"
                                   style={{ width: "80%" }}
                                   onChange={this.editParameter}
                               />
                              
                           </div>
                        </div>
                    </div>
                    <div className="card-footer">
                        <div className="row">
                           <div className="col">
                               <Button onClick={this.oneDriveRestoreToContinue} disabled={!(this.state.destinationOneDriveUrl && this.state.destinationFolder)} color="primary">
                                    Continue
                                </Button>
                            </div>
                            <div className="col">
                                <Button onClick={this.closeOneDriveRestoreToModal}>Cancel</Button>
                            </div>
                        </div>
                    </div>
                </div>
            </Modal>
        );

        if (this.state.restoreModalOpen) {
            let restoreModalContent = null;
            if (this.state.restoring ) {
                //restoreModalContent = (
                //    <div className="card">
                //        <div className="card-body">
                //            {/*    <p>Please wait while we prepare your restore.</p>*/}
                //        <div className="card-footer">
                //            <div className="d-flex justify-content-center">
                //                <img src={LoaderGif} alt="loading" style={{ height: '50px' }} />
                //            </div>
                //        </div>
                //    </div>
                //);
                restoreModalContent = (
                    <div className="card">
                        <div className="card-body">
                            <p>Depending on the size of your restore, your recovery may take some time. We will email you when it is completed. You can track its progress by reviewing the recovery sessions.</p>
                        </div>
                        <div className="card-footer">
                            <div className="d-flex justify-content-center">
                                {/*    <img src={LoaderGif} alt="loading" style={{ height: '50px' }} />*/}
                                <button className="btn btn-primary" onClick={this.closeRestoreModal}>OK</button>
                            </div>
                        </div>
                    </div>
                );
            } else {
                let restoreMessages = [];
                if (this.state.restoreSuccess) {
                    let result = this.state.restoreSuccess.result;
                    for (const item in result) {
                        const value = result[item];
                        if (item !== "restoreIssues") {
                            if (value) {
                                let messageObject = "";
                                if (item.toLocaleLowerCase() === "skippeditemscount") {
                                    messageObject = (
                                        <p key={item.toString()}>
                                            Skipped Items (already exist in original location): {value}
                                        </p>
                                    );
                                }
                                else {
                                    messageObject = (
                                        <p key={item.toString()}>
                                            {lodash.startCase(item)}: {value}
                                        </p>
                                    );
                                }
                                restoreMessages.push(messageObject);
                            }
                        } else {
                            if (value) {
                                for (var k = 0; k < value.length; k++) {
                                    const issue = value[k];
                                    let warningsItem = [];
                                    if (issue.warnings) {
                                        let warnings = [];
                                        for (var w = 0; w < issue.warnings.length; w++) {
                                            const warning = issue.warnings[w];
                                            var warningObject = <li key={warning}>{warning}</li>;
                                            warnings.push(warningObject);
                                        }
                                        warningsItem = <ul>{warnings}</ul>;
                                        if (issue.warnings.length > 0) {
                                            let messageObject = (
                                                <div key={item.toString() + issue.title}>
                                                    Warnings for {issue.title}: {warningsItem}
                                                </div>
                                            );
                                            restoreMessages.push(messageObject);
                                        }
                                    }
                                }
                            }
                        }
                    }
                    //if (!result.message) {
                    //    restoreMessage = <div>{restoreMessages}</div>;
                    //    restoreModalContent = (
                    //        <div className="card">
                    //            <div className="card-body">
                    //                <div className="row">
                    //                    <p>Restore completed.</p>
                    //                </div>
                    //                <div className="row">{restoreMessage}</div>
                    //            </div>
                    //            <div className="card-footer">
                    //                <div className="row">
                    //                    <div className="col" />
                    //                    <div className="col">
                    //                        <Button onClick={this.closeRestoreModal}>Ok</Button>
                    //                    </div>
                    //                    <div className="col" />
                    //                </div>
                    //            </div>
                    //        </div>
                    //    );
                    //}
                    //else {
                    //    restoreMessage = <p>{result.message}</p>;
                    //    restoreModalContent = (
                    //        <div className="card">
                    //            <div className="card-body">
                    //                <div className="row">
                    //                    <p>Error.</p>
                    //                </div>
                    //                <div className="row">{restoreMessage}</div>
                    //            </div>
                    //            <div className="card-footer">
                    //                <div className="row">
                    //                    <div className="col" />
                    //                    <div className="col">
                    //                        <Button onClick={this.closeRestoreModal}>Ok</Button>
                    //                    </div>
                    //                    <div className="col" />
                    //                </div>
                    //            </div>
                    //        </div>
                    //    );
                    //}
                }
            }
            if (this.state.restoreModalOpen) {
                restoreModal = (
                    <Modal isOpen={this.state.restoreModalOpen}>
                        {restoreModalContent}
                    </Modal>
                );
            }
        }        

        let entraModal = null;
        if (this.state.entraModalOpen) {
            let entraModalContent = (
                <div className="card">
                    <div className="card-body">
                        <p>{this.state.entraRestoreMessage}</p>
                    </div>
                    <div className="card-footer">
                        <div className="row">
                            <div className="col" />
                            <div className="d-flex align-items-center">
                                <Button onClick={this.closeDownloadModal}>
                                    Ok
                                </Button>
                            </div>
                            <div className="col" />
                        </div>
                    </div>
                </div>
            );
            if (this.state.entraModalOpen) {
                entraModal = (
                    <Modal isOpen={this.state.entraModalOpen}>
                        {entraModalContent}
                    </Modal>
                );
            }
        }


        let downloadModal = null;
        if (this.state.downloadModalOpen) {
            let downloadingModalContent = (
                <div className="card">
                    <div className="card-body">
                        <p>The requested file(s) will be available in the {this.state.litigation.state ? "litigation": "download"}  section once it is ready, and you will get an email.</p>
                    </div>
                    <div className="card-footer">
                        <div className="row">
                            <div className="col" />
                            <div className="d-flex align-items-center">
                                <Button onClick={this.closeDownloadModal}>
                                    Ok
                                </Button>
                            </div>
                            <div className="col" />
                        </div>
                    </div>
                </div>
            );            
            if (this.state.downloadModalOpen) {
                downloadModal = (
                    <Modal isOpen={this.state.downloadModalOpen}>
                        {downloadingModalContent}
                    </Modal>
                );
            }
        }
        let litigationModal = null;
        if (this.state.litigation.state) {
            litigationModal = (
                <Modal isOpen={this.state.litigation.popUp}>
                    <div className="card">
                        <div className="card-body">
                            <p>Please give the Description about the currently Litigated File</p>
                            <Form.Group controlId="restoreReason">
                                <Form.Control
                                    as="textarea"
                                    rows={5}
                                    value={this.state.litigation.description}
                                    onChange={this.handleLitigationDescriptionChange}
                                    placeholder="Enter the Description..."
                                    style={{
                                        borderColor: 'black',
                                        borderStyle: 'solid',
                                        padding: '10px',
                                        fontSize: '16px',
                                        height: '170px'
                                    }}
                                />
                            </Form.Group>
                        </div>
                        <div className="modal-footer">
                            <Button variant="secondary" onClick={() => {
                                this.setState({
                                    inProgressRight: false,
                                    mailModalOpen: false,
                                    deviceCode: "",
                                    verificationModalOpen: false,
                                    downloading: false,
                                    extraLargeDownload: false,
                                    litigation: {
                                        state: false,
                                        popUp: false,
                                        description: "",
                                        action: "",
                                        type: ""
                                    },
                                });
                            }}>
                                Cancel
                            </Button>
                            <Button variant="primary" className="btn btn-primary" onClick={(e) => {
                                this.setState(prevState => ({
                                    litigation: {
                                        ...prevState.litigation,
                                        popUp: false,
                                    }
                                }));
                                this.openDownloadModal(e, this.state.litigation.action, this.state.litigation.type);
                            }} disabled={!((this.state.litigation.description || '').trim())}>
                                Submit
                            </Button>
                        </div>
                    </div>
                </Modal>

            );
        }
        let waitForDeviceCode = [];
        if (this.state.ingettingDeviceCode) {
            waitForDeviceCode = (
                <div className="d-flex justify-content-center">
                    <img src={LoaderGif} alt="loading" style={{ height: '50px' }} />
                </div>
            );
        } else {
            waitForDeviceCode = (<div>
                <input type="text" value={this.state.deviceCode} name="deviceCode" id="deviceCode" disabled />
                <CopyToClipboard
                    text={this.state.deviceCode}
                    onCopy={() => {
                        this.setState({
                            copied: true,
                            disableBtn: false
                        });
                        window.open("https://microsoft.com/devicelogin", '_blank', 'noopener,noreferrer');
                    }
                    }
                >
                    <button style={{ color: "grey" }} className="btn">
                        Copy
                    </button>


                </CopyToClipboard>

            </div>);
        }

        if (this.state.verificationModalOpen) {
            if (this.state.isMFA) {
                // if (this.state.deviceCode != "")
                //{
                    verificationModal = (
                        <Modal isOpen={this.state.verificationModalOpen}>
                            <div className="card">
                                <div className="card-body">
                                    <p>To restore, authenticate with the code below at:</p>
                                    <a href="https://microsoft.com/devicelogin" target="_blank" rel="noopener noreferrer">
                                        https://microsoft.com/devicelogin
                                    </a>
                                    <p>
                                        Please copy below code to clipboard before following above
                                        URL.
                                    </p>
                                    <p>
                                        When you have done this please click the continue button
                                        below.
                                    </p>

                                    {waitForDeviceCode}
                                </div>
                                <div className="card-footer">
                                    <div className="row">
                                        <div className="col">
                                            <Button onClick={this.buildRestore} color="primary" disabled={this.state.disableBtn}>
                                                Continue
                                            </Button>
                                        </div>
                                        <div className="col">
                                            <Button onClick={this.closeVerificationModal}>
                                                Cancel
                                            </Button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </Modal>
                    );
                //}
            } else {
                verificationModal = (
                    <Modal isOpen={this.state.verificationModalOpen}>
                        <React.Fragment>
                            <div className="card">
                                <div className="card-body">
                                    <div className="row">
                                        <p>
                                            To restore, please provide us with your username and
                                            password. This will not be stored.
                                        </p>
                                    </div>
                                    <div className="row">
                                        <div className="col-12">
                                            <div style={{ width: "20%" }}>Email</div>
                                            <input
                                                type="text"
                                                value={this.state.username}
                                                placeholder="Email"
                                                name="username"
                                                style={{ width: "80%" }}
                                                onChange={this.editParameter}
                                            />
                                        </div>
                                    </div>
                                    <div className="row">
                                        <div className="col-12">
                                            <div style={{ width: "20%" }}>Password</div>
                                            <input
                                                type="password"
                                                value={this.state.password}
                                                name="password"
                                                style={{ width: "80%" }}
                                                onChange={this.editParameter}
                                            />
                                        </div>
                                    </div>
                                </div>
                                <div className="card-footer">
                                    <div className="row">
                                        <div className="col">
                                            <Button
                                                className="ml-3"
                                                onClick={this.buildRestore}
                                                color="primary"
                                            >
                                                Continue
                                            </Button>
                                        </div>
                                        <div className="col">
                                            <Button onClick={this.closeVerificationModal}>
                                                Cancel
                                            </Button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </React.Fragment>
                    </Modal>
                );
            }
        }
       
        if (this.state.mailModalOpen) {
            mailModal = (
                <Modal isOpen={this.state.mailModalOpen}>
                    <div className="card">
                        <div className="card-body">
                            <div className="row">
                                <div className="col">
                                    <p>To:</p>
                                    {this.state.restoreMailTo === "2" &&
                                        <input
                                            type="text"
                                            value={this.state.mailSendTo}
                                            name="mailSendTo"
                                            onChange={this.editParameter}
                                        />}
                                    {this.state.restoreMailTo === "1" &&
                                        <select className='form-select'
                                            value={this.state.mailSendTo}
                                            name="mailSendTo"
                                            onChange={this.editParameter}
                                        >
                                            <option value="" disabled>
                                                ---------
                                            </option>
                                            {this.state.usersList.map(user => (
                                                <option key={user.name} value={user.name}>
                                                    {user.name}
                                                </option>
                                            ))}
                                        </select>}
                                </div>
                                <div className="col">
                                    <p>Subject:</p>
                                    <input
                                        type="text"
                                        value={this.state.mailSubject}
                                        name="mailSubject"
                                        onChange={this.editParameter}
                                    />
                                </div>
                            </div>
                            <div className="row">
                                <div className="col-12">
                                    <p>Message:</p>
                                    <textarea
                                        type="text"
                                        style={{
                                            width: "100%",
                                            resize: "vertical",
                                            maxHeight: "150px",
                                            minHeight: "150px",
                                        }}
                                        value={this.state.mailMessage}
                                        name="mailMessage"
                                        onChange={this.editParameter}
                                    />
                                </div>
                            </div>
                        </div>
                        <div className="card-footer">
                            <div className="row">
                                <div className="col">
                                    <Button onClick={this.mailContinue} color={this.state.mailSendTo === ''?"#666":"primary"} disabled={this.state.mailSendTo===''}>
                                        Continue
                                    </Button>
                                </div>
                                <div className="col">
                                    <Button onClick={this.closeMailModal}>Cancel</Button>
                                </div>
                            </div>
                        </div>
                    </div>
                </Modal>
            );
        }
        if (this.state.toAnotherMailboxOpen) {
            toAnotherMailboxModal = (
                <Modal isOpen={this.state.toAnotherMailboxOpen}>
                    <div className="card">
                        <div className="card-body">
                            <div className="row">
                                
                                    <p>Exchange MailBox :</p>
                                    <select className='form-select'
                                        style={{ width: '100%', whiteSpace: "nowrap" }}
                                        value={this.state.mailbox}
                                        name="mailbox"
                                        onChange={this.editParameter}
                                    >
                                    <option value={"null"}>----</option>
                                    {this.state.usersList.map(mail => (
                                            <option key={mail.name} value={mail.name} title={mail.msid }>
                                                {mail.name}
                                            </option>
                                        ))}

                                    </select>
                                    
                                {/*<SelectSearch*/}
                                    {/*    style={{ width: '100%', whiteSpace: "nowrap" }}*/}
                                    {/*    options={this.state.allUserList}*/}
                                    {/*    value={this.state.mailbox ? this.state.mailbox : ""}*/}
                                    {/*    name="mailbox"*/}
                                    {/*    placeholder="Select a user"*/}
                                    {/*    search*/}
                                    {/*    filterOptions={fuzzySearch}*/}
                                    {/*    onChange={this.handleAnotherMailboxChange}*/}
                                    {/*    renderOption={this.CustomMailOption}*/}
                                    {/*/>*/}
                                    
                                
                            </div>
                        </div>
                        <div className="card-footer">
                            <div className="row">
                                <div className="col">
                                    <Button onClick={this.exchangeRestoreToContinue} disabled={this.state.mailbox === "null" || !this.state.mailbox} color="primary">
                                        Continue
                                    </Button>
                                </div>
                                <div className="col">
                                    <Button onClick={this.closeToAnotherMailBoxRestoreToModal}>Cancel</Button>
                                </div>
                            </div>
                        </div>
                    </div>
                </Modal>
            );
        }

        if (
            this.state.viewItems.length === 0 && this.state.gridViewItems.length === 0 && this.state.activeAccordion === '0' &&
            !this.state.inProgressRight &&
            !this.state.restore && this.state.allSessionEvents.length === 0
        ) {
            rightSection = (
                <div className="ps-3">
                    <p className="titletext" style={{ fontWeight: '500', fontSize: '25px', textAlign: "center" }}> CloudCover 365 </p>

                    <p className="mb-3">Restore all Microsoft 365 data from the CloudCover 365 recovery screen, including Exchange, SharePoint, OneDrive, Teams and Azure (if it forms part of your package).</p>
                    <p className="mb-3" style={{ fontWeight: 'bold' }}>How to use the recovery tool:</p>

                    <ol>
                        <li className="mb-2" style={{ display: 'list-item' }}>Select the restoration type.</li>
                        <li className="mb-2" style={{ display: 'list-item' }}>Add the reason for the restoration.</li>
                        <li className="mb-2" style={{ display: 'list-item' }}>Select a restoration date from the calendar, or via the &lsquo;show all restore points&lsquo; option.</li>
                        <li className="mb-2" style={{ display: 'list-item' }}>Choose the item type you wish to restore.</li>
                        <li className="mb-2" style={{ display: 'list-item' }}>Select the required data and start the restoration process.</li>
                    </ol>


                    <p className="mb-3" style={{ fontWeight: 'bold' }}>Tips:</p>

                    <ul>
                        <li className="mb-2" style={{ display: 'list-item' }}>If you need to restore a file that was last seen two weeks ago, select a restore point before this date.</li>
                        <li className="mb-2" style={{ display: 'list-item' }}>To restore a tree item, highlight it and use the &lsquo;restore folders&lsquo; menu. This will show you your tree restoration options.</li>
                        <li className="mb-2" style={{ display: 'list-item' }}>To restore items with tree nodes (e.g. Mail items), simply select them with the tick box and then use the &lsquo;restore items&lsquo; menu. This will show you your item restore options.</li>

                    </ul>

                    <p className="mb-3">Please note that some items may take a while to download.</p>

                </div>
            );
        }
        let searchBar = null;
        let searchPopup = null;
        if ((this.state.restoreType === "vet" && (this.state.selectItem) && (this.state.restore) && this.state.selectedRestoreType !== "Azure Backup") ||
            ((this.state.restore) && this.state.selectedRestoreType !== "Azure Backup" && this.state.restoreType !== "vet")) {
            let searchTypeOptions = [];
            let searchFieldOptions = [];
            for (let i = 0; i < this.state.searchFilters.length; i++) {
                const filter = this.state.searchFilters[i];
                var filterOption = (
                    <option key={i} value={filter.label}>
                        {filter.label}
                    </option>
                );
                searchTypeOptions.push(filterOption);
            }
            for (let j = 0; j < this.state.searchFilters.length; j++) {
                const option = this.state.searchFilters[j];
                if (option.label.trim() === this.state.searchType.trim()) {
                    for (let k = 0; k < option.fields.length; k++) {
                        const field = option.fields[k];
                        let filterOption = (
                            <option key={"field" + k.toString()} value={field.shortcut} type={field.conditionType}>
                                {field.label}
                            </option>
                        );
                        searchFieldOptions.push(filterOption);
                    }
                }
            }
            let queries = [];
            for (var q = 0; q < this.state.searchQueries.length; q++) {
                const query = this.state.searchQueries[q];
                // Split the Field by commas and take the first one
                let fields = query.Field.split(',');
                let field = fields[0].trim(); // Use only the first field value
                var queryLine = (
                    <tr key={q}>
                        <td className="pb-0 pt-0">{lodash.startCase(query.Type)} </td>
                        <td className="pb-0 pt-0">{lodash.startCase(field)}</td>
                        <td className="pb-0 pt-0">{lodash.startCase(query.Inclusion)}</td>
                        <td className="pb-0 pt-0">{query.Term}</td>
                        <td className="pb-0 pt-0">
                            <Button
                                className="btn-sm"
                                onClick={(e) => this.deleteQuery(e, query)}
                            >
                                X
                            </Button>
                        </td>
                    </tr>
                );
                queries.push(queryLine);
            }
            let tableBody;
            if (queries.length > 0) {
                tableBody = <tbody>{queries}</tbody>;
            }
            let queryTable = (
                <div
                    className="col-12"
                    style={{ overflowY: "auto", height: "150px" }}
                >
                    <Table>
                        <thead>
                            <tr>
                                <th scope="col">Category</th>
                                <th scope="col">Field</th>
                                <th scope="col">Condition</th>
                                <th scope="col">Search</th>
                                <th scope="col"></th>
                            </tr>
                        </thead>
                        {tableBody}
                    </Table>
                </div>
            );
            if (this.state.selectItems.length > 0 && this.state.activeAccordion === "3") {
                let searchString = "";
                let searchDisabled = true;
                if (!this.state.selectItems.length > 0 && this.state.searchQueries) {

                }
                else {
                     searchString = "- All";
                    if (this.state.restoreType === "vex") {
                        searchString += " Mailboxes";
                    } else if (this.state.restoreType === "vesp") {
                        searchString += " Sites";
                    } else if (this.state.restoreType === "veod") {
                        searchString += " OneDrives";
                    } else if (this.state.restoreType === "vet") {
                        searchString += " Teams";
                    }
                    if (this.state.selectItem) {
                        if (this.state.selectItem.email === null) {
                            searchString = "- " + this.state.selectItem.title;
                        }
                        else if (this.state.restoreType === "vex" || this.state.restoreType === "vet") {
                            searchString = "- " + this.state.selectItem.title + " - " + this.state.selectItem.email;
                        }
                        else {
                            searchString = "- " + this.state.selectItem.title + " - " + this.state.selectItem.email.toLowerCase();
                        }
                    }
                    if (this.state.selectedFolder) {
                        searchString = "- " + this.state.selectedFolder.title;
                    }
                   
                    if (this.state.searchQueries.length > 0) {
                        searchDisabled = false;
                    }
                }
                searchBar = (
                    <div className="">
                        <div style={{ width: "100%", margin: "auto" }} className="row p-1 restore-accordion" onClick={this.openSearchPanel}>
                            <div className="col-11" style={{ fontWeight: 'bold', fontSize: '17px', padding:'0.5rem 1rem' }}>
                                Search {searchString}
                            </div>
                            <div className="col clearfix">
                                <Button className="float-right" onClick={this.openSearchPanel} style={{ float: 'right' }}>
                                    <svg xmlns="http://www.w3.org/2000/svg"  width="20" height="20" fill="currentColor" className={`arrow ${this.state.searchPanelOpen ? 'arrow_rotate bi bi-chevron-down' : 'bi bi-chevron-down'}`} viewBox="0 0 16 16">
                                        <path  strokeWidth="2"  d="M1.646 4.646a.5.5 0 0 1 .708 0L8 10.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708" />
                                    </svg>
                                </Button>
                            </div>
                           
                        </div>
                        <Collapse isOpen={this.state.searchPanelOpen}>
                            <div className="row" id="searchbody">
                                <div className="col-12">
                                    <div className="row">{queryTable}</div>
                                    <div
                                        style={{ margin: "auto" }}
                                        className="row align-items-end pb-2 search-form"
                                    >
                                        <div className="col mt-2">
                                            <FormGroup>
                                                <Label className="h6" for="searchType">
                                                    Category
                                                </Label>
                                                <Input
                                                    onChange={this.changeSearchType}
                                                    value={this.state.searchType}
                                                    type="select"
                                                    name="searchType"
                                                    id="searchType"
                                                    className="form-select"
                                                >
                                                    <option value={"null"}>----</option>
                                                    {searchTypeOptions}
                                                </Input>
                                            </FormGroup>
                                        </div>
                                        <div className="col">
                                            <FormGroup>
                                                <Label className="h6" for="searchField">
                                                    Field
                                                </Label>
                                                <Input
                                                    onChange={this.changeSearchField}
                                                    value={this.state.searchField}
                                                    type="select"
                                                    name="searchField"
                                                    id="searchField"
                                                    className="form-select"
                                                >
                                                    <option value={"null"}>----</option>
                                                    {searchFieldOptions}
                                                </Input>
                                            </FormGroup>
                                        </div>
                                        <div className="col">
                                            <FormGroup>
                                                <Label className="h6" for="queryType">
                                                    Condition
                                                </Label>
                                                <Input
                                                    onChange={this.changeSearchQueryType}
                                                    value={this.state.searchQueryType}
                                                    type="select"
                                                    name="queryType"
                                                    id="queryType"
                                                    className="form-select"
                                                >
                                                    <option value={"null"}>----</option>
                                                    {this.state.conditionOptions.map((option, index) => (
                                                        <option key={index} value={option.value}>
                                                            {option.label}
                                                        </option>
                                                    ))}
                                                </Input>
                                            </FormGroup>
                                        </div>
                                        <div className="col">
                                            <FormGroup>
                                                <Label className="h6" >Search</Label>
                                                {/*<Label className="h6" for="searchTermDate" id="lblsearchTermDate">Search</Label>*/}
                                                {/*<Label className="h6" for="lblBetweenDates" id="lblBetweenDates">Search</Label>*/}

                                                {/*<DatePicker*/}
                                                {/*    selected={this.state.searchTermDate}*/}
                                                {/*    onChange={(date) => this.handleSearchDate(date)}*/}
                                                {/*    dateFormat="dd/MM/yyyy"*/}
                                                {/*    style={{ maxHeight: "30px" }}*/}
                                                {/*    className="mr-1 datepicker form-control"*/}
                                                {/*    id="searchTermDate"*/}
                                                {/*   // style={{ display: !this.state.isBetweenCondition && this.state.isDateField ? 'block' : 'none' }}*/}
                                                {/*/>*/}
                                                {/* For "between" condition */}
                                                {this.state.isBetweenCondition ? (
                                                    <div id="lblBetweenDates" style={{ display: 'flex', flexDirection: 'row', gap: '10px' }}>
                                                        <DatePicker
                                                            selected={this.state.dateRange.start}
                                                            onChange={(date) => this.handleBetweenDateChange('start', date)}
                                                            selectsStart
                                                            startDate={this.state.dateRange.start}
                                                            endDate={this.state.dateRange.end}
                                                            dateFormat="dd/MM/yyyy"
                                                            className="mr-1 datepicker form-control"
                                                            placeholderText="Start Date"
                                                            style={{ width: '100%' }}
                                                        />
                                                        <DatePicker
                                                            selected={this.state.dateRange.end}
                                                            onChange={(date) => this.handleBetweenDateChange('end', date)}
                                                            selectsEnd
                                                            startDate={this.state.dateRange.start}
                                                            endDate={this.state.dateRange.end}
                                                            minDate={this.state.dateRange.start}
                                                            dateFormat="dd/MM/yyyy"
                                                            className="mr-1 datepicker form-control"
                                                            placeholderText="End Date"
                                                            style={{ width: '100%' }}
                                                        />
                                                    </div>
                                                ) : <div style={{ width:"100%" }}>
                                                        {this.state.searchTermDateVisible && (
                                                            <DatePicker
                                                                selected={this.state.searchTermDate}
                                                                onChange={this.handleSearchDate}
                                                                dateFormat="dd/MM/yyyy"
                                                                className="mr-1 datepicker form-control"
                                                                disabled={['today', 'yesterday', 'tomorrow', 'last7Days', 'next7Days',
                                                                    'last Week', 'this Week', 'next Week', 'lastMonth', 'nextMonth','thisMonth',
                                                                    'lastYear', 'nextYear', 'thisYear'].includes(this.state.selectedCondition)
                                                                }
                                                            />
                                                        )}

                                                    </div>
                                                }
                                                {this.state.searchTermVisible && (
                                                    <Input
                                                        value={this.state.searchTerm}
                                                        onChange={this.changeSearchTerm}
                                                        type="text"
                                                        name="searchTerm"
                                                    />
                                                )}
                                                {this.state.fileSizeVisible && (
                                                        <div id="fileSize">
                                                        <Input
                                                            type="number"
                                                            value={this.state.value}
                                                            onChange={this.handleValueChange}
                                                            onKeyDown={this.blockInvalidChar}
                                                            style={{ width: "100px", height: "37px" }}
                                                        />
                                                            <Input style={{ height: "37px", width:"auto" }} value={this.state.unit} type="select" className="form-select" onChange={this.handleUnitChange}>
                                                            <option value="KB">KB</option>
                                                            <option value="MB">MB</option>
                                                        </Input>
                                                    </div>
                                                )}
                                                <div id="customFieldDropdown">
                                                    {this.state.customFieldDropdownVisible && (
                                                        <Input
                                                            type="select"
                                                            name="customDropdown"
                                                            value={this.state.dropdownValues.customDropdown}
                                                            onChange={this.handleDropdownChange}
                                                            className="form-select"
                                                        >
                                                            {this.state.isCustomField && this.state.searchField === 'importance' && (
                                                                ['----','Low', 'Normal', 'High'].map(option => (
                                                                    <option key={option} value={option}>{option}</option>
                                                                ))
                                                            )}
                                                            {this.state.isCustomField && this.state.searchField === 'priority' && (
                                                                ['----','Low', 'Normal', 'High'].map(option => (
                                                                    <option key={option} value={option}>{option}</option>
                                                                ))
                                                            )}
                                                        </Input>
                                                    )}
                                                    {this.state.sensitivityDropdownVisible && (
                                                        <Input
                                                            type="select"
                                                            name="sensitivityDropdown"
                                                            value={this.state.dropdownValues.sensitivityDropdown}
                                                            onChange={this.handleDropdownChange}
                                                            className="form-select"
                                                        >
                                                            {['----','Normal', 'Personal', 'Private', 'Confidential'].map(option => (
                                                                <option key={option} value={option}>{option}</option>
                                                            ))}
                                                        </Input>
                                                    )}
                                                    {this.state.isMeetingStatusField && (
                                                        <Input
                                                            type="select"
                                                            name="meetingStatusDropdown"
                                                            value={this.state.dropdownValues.meetingStatusDropdown}
                                                            onChange={this.handleDropdownChange}
                                                            className="form-select"
                                                        >
                                                            {['----','None', 'Organized', 'Tentative', 'Accepted', 'Declined', 'Not Responded'].map(option => (
                                                                <option key={option} value={option}>{option}</option>
                                                            ))}
                                                        </Input>
                                                    )}
                                                    {this.state.isBooleanField && (
                                                        <Input
                                                            type="select"
                                                            name="attachmentsDropdown"
                                                            value={this.state.dropdownValues.attachmentsDropdown}
                                                            onChange={this.handleDropdownChange}
                                                            className="form-select"
                                                        >
                                                            {['----','Yes', 'No'].map(option => (
                                                                <option key={option} value={option}>{option}</option>
                                                            ))}
                                                        </Input>
                                                    )}
                                                    {this.state.isFlagStatusField && (
                                                        <Input
                                                            type="select"
                                                            name="flagStatusDropdown"
                                                            value={this.state.dropdownValues.flagStatusDropdown}
                                                            onChange={this.handleDropdownChange}
                                                            className="form-select"
                                                        >
                                                            {['----','Not flagged', 'Completed','Follow Up'].map(option => (
                                                                <option key={option} value={option}>{option}</option>
                                                            ))}
                                                        </Input>
                                                    )}
                                                    {this.state.isColorField && (
                                                        <Input
                                                            type="select"
                                                            name="colorDropdown"
                                                            value={this.state.dropdownValues.colorDropdown}
                                                            onChange={this.handleDropdownChange}
                                                            className="form-select"
                                                        >
                                                            {['----','Blue', 'Green','Pink','Yellow','White','Light Green'].map(option => (
                                                                <option key={option} value={option}>{option}</option>
                                                            ))}
                                                        </Input>
                                                    )}
                                                </div>
                                            </FormGroup>
                                        </div>
                                        <div className="col-2 search-button" style={{ flex:"", width:"" }}>
                                            <Button
                                                className=""
                                                id="plusbutton"
                                                onClick={this.addToQueryLines}
                                                disabled={isAddButtonDisabled}
                                            >
                                                +
                                            </Button>
                                            <Button
                                                className="ms-2"
                                                disabled={searchDisabled}
                                                onClick={this.search}
                                            >
                                                {/*{this.state.inProgressRight ?'Stop' : 'Search' }*/}
                                                Search
                                            </Button>
                                            &nbsp;
                                           
                                                <Button title="Refresh" id="ContentPlaceHolder1_btnclr" className="RestoreButtons" onClick={(e) => {
                                                    if (this.state.gridApi) {
                                                        this.state.gridApi.setFilterModel(null);
                                                    }
                                                    this.setState(
                                                        {
                                                            //searchQueries: [],
                                                            searchType: "null",
                                                        },
                                                        () => {
                                                            this.resetSearchValues(); 
                                                        }
                                                    );
                                                }
                                                } style={{ padding: '5px 7px', color: '#fff' }}  >
                                                    <svg xmlns="http://www.w3.org/2000/svg" height="20" viewBox="0 0 28 28" width="20" style={{ cursor: 'pointer', margin: "5px 0 0 5px" }}>
                                                        <path d="M12 4V1L8 5l4 4V6c3.31 0 6 2.69 6 6 0 .29-.02.57-.06.85l1.52 1.52c.33-.79.54-1.64.54-2.54 0-4.42-3.58-8-8-8zm-1 14v3l4-4-4-4v3c-3.31 0-6-2.69-6-6 0-.29.02-.57.06-.85L3.94 8.47c-.33.79-.54 1.64-.54 2.53 0 4.42 3.58 8 8 8z" />
                                                    </svg>

                                                    {/*<svg xmlns="http://www.w3.org/2000/svg" height="20" fill="#fff" stroke="#fff" viewBox="0 0 32 32" width="20" style={{ cursor: 'pointer' }}>*/}
                                                    {/*    <path strokeWidth=".5" d="m30 11.414-1.414-1.414-4.586 4.586-4.586-4.586-1.414 1.414 4.586 4.586-4.586 4.585 1.415 1.415 4.585-4.586 4.587 4.586 1.413-1.413-4.586-4.587z"></path>*/}
                                                    {/*    <path strokeWidth=".5" d="m4 4a2 2 0 0 0 -2 2v3.1709a2 2 0 0 0 .5859 1.4145l7.4141 7.4146v8a2 2 0 0 0 2 2h4a2 2 0 0 0 2-2v-2h-2v2h-4v-8.8291l-.5859-.5855-7.4141-7.4145v-3.1709h20v2h2v-2a2 2 0 0 0 -2-2z"></path>*/}
                                                    {/*</svg>*/}
                                                </Button>

                                           
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </Collapse>
                    </div>
                );
                if (this.state.searchFailed.length > 0)
                {
                    searchPopup = (
                        <Modal isOpen={this.state.searchFailed.length > 0}>
                            <div className="card">
                                <div className="card-body">
                                    <div className="row">
                                        <p>
                                            Search Failed : {this.state.searchFailed}
                                        </p>
                                    </div>
                                </div>
                                <div className="card-footer">
                                    <div className="row">
                                        <div className="col">
                                            <Button
                                                className="ml-3"
                                                onClick={() => { this.resetState(""); }}
                                                color="primary"
                                            >
                                                Ok
                                            </Button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            </Modal>);
                }

            }
        }

        const ActiveSearch = ({ queriesList }) => {
            const getRowHeight = (params) => {
                const queriesListArray = params.data.queriesList || [];
                let rowHeight = 20;
                for (let i = 0; i < queriesListArray.length; i++) {
                    rowHeight += 25;
                }
                return rowHeight;
            };
            const headerHeight = 30;

            ////const [gridApi, setGridApi] = useState(null);

            const processQueriesList = (params) => {
                if (queriesList && queriesList.QueriesList) {
                    const searchHistoryQueries = [];

                    queriesList.QueriesList.forEach((queries, index) => {
                        searchHistoryQueries.push({
                            backupTime: queriesList.BackUpTime[index],
                            restoreType: queriesList.Type[index],
                            level: [queriesList.Title[index], queriesList.SubTitle[index]],
                            queriesList: queriesList.QueriesList[index],
                            resultCount: queriesList.SearchCount[index],
                            status: queriesList.Status[index],
                        });
                    });
                    params.setGridOption('rowData', searchHistoryQueries);
                }
            };

            const activeSearchOnGrid= (params) => {
                ////setGridApi(params.api);
                processQueriesList(params.api);
                    };
            const renderTooltip = (props) => (

                <Tooltip id={`tooltip-${props.id}`} {...props}>
                    {props.text}
                </Tooltip>

            );

            const TableRenderer = (props) => {
                const searchQuery = props.value;
                const headerHeight = 20;
                const rowHeight = 25;

                const columnDefs = useMemo(() => [
                    { headerName: 'Field', field: 'Field', sortable: true, cellStyle: { textAlign: 'center', display: 'flex', justifyContent: 'center', alignItems: 'center' }, filter: true},
                    { headerName: 'Condition', field: 'Inclusion', sortable: true, cellStyle: { textAlign: 'center', display: 'flex', justifyContent: 'center', alignItems: 'center' }, filter: true },
                    { headerName: 'Value', field: 'Term', sortable: true, cellStyle: { textAlign: 'center', display: 'flex', justifyContent: 'center', alignItems: 'center' }, filter: true }
                ], []);

                const defaultColDef = {
                    flex: 1,
                    minWidth: 100,
                    resizable: true,
                    sortable: true,
                    filter: false,
                    headerStyle: {
                        backgroundColor: '#007bff',  // Blue background
                        color: 'white',  // White text
                        fontWeight: 'bold',  // Bold font
                        textAlign: 'center',  // Centered text
                        padding: '10px',  // Padding for the header
                        display: 'flex',
                        justifyContent: 'center',
                        
                    }
                };

                return (
                    <div className="ag-theme-alpine" style={{ width: '100%', height: 200 }}>
                        <AgGridReact
                            rowData={searchQuery}
                            columnDefs={columnDefs}
                            defaultColDef={defaultColDef}
                            rowHeight={rowHeight}
                            headerHeight={headerHeight}
                            suppressVerticalScroll={true}
                        />
                    </div>
                );
            };

            const columnDefs = useMemo(() => [
                {
                    headerName: 'Type', field: 'restoreType', filter: 'agTextColumnFilter', maxWidth: 100,
                    cellStyle: { textAlign: 'center', display: 'flex', justifyContent: 'center', alignItems: 'center' },
                    cellRenderer: (params) => {
                        const imageSources = {
                            "mailboxes": Exchanges,
                            "sites": Sharepoints,
                            "onedrives": Onedrives,
                            "teams": Teams
                        };
                        const imageSrc = imageSources[params.value.toLowerCase()];

                        return (
                            <div>
                                {imageSrc &&
                                    <OverlayTrigger
                                        key="restoreTypeIcon-1"
                                        placement="top"
                                        width
                                        delay={{ show: 50, hide: 50 }}
                                        overlay={(props) => renderTooltip({ ...props, id: "sort-1", text: `${params.value.toUpperCase()}` })}
                                    >
                                        <img src={imageSrc} alt="Restore Type" style={{ width: '1.2vw', height: '1.2vw' }} />
                                    </OverlayTrigger>
                                }
                            </div>
                        );
                    }
                },
                {
                    headerName: 'Restore Point', field: 'backupTime', filter: 'agDateColumnFilter', sortable: true, maxWidth: 150,
                    cellStyle: { textAlign: 'center', display: 'flex', justifyContent: 'center', alignItems: 'center' },
                },
                {
                    headerName: 'Level', field: 'level', filter: 'agTextColumnFilter', minWidth: 50,
                    cellStyle: { textAlign: 'center', display: 'flex', justifyContent: 'center', alignItems: 'center' },
                    cellRenderer: (params) => {

                        let user = { email: "", title: "" };
                        let folder = {subtitle: "", url: "" };

                        if (params.value[0]) {
                            try {
                                
                                const parsedUser = JSON.parse(params.value[0]);
                                user.email = parsedUser.email || "";
                                user.title = parsedUser.title || "";
                            } catch (error) {
                               
                                user.email = params.value[0];
                                user.title = params.value[0];
                            }
                        }

                        if (params.value[0]) {
                            try {

                                const parsedUser = JSON.parse(params.value[1]);
                                folder.email = parsedUser.email || "";
                                folder.title = parsedUser.title || "";
                            } catch (error) {

                                folder.email = params.value[1];
                                folder.title = params.value[1];
                            }
                        }
                        return (
                            <div style={{ flexDirection: 'column', display: 'flex', justifyContent: 'center' }}>

                                <div style={{ margin: '0' }}>
                                    <OverlayTrigger
                                        key="sort-1"
                                        placement="top"
                                        width
                                        delay={{ show: 50, hide: 50 }}
                                        overlay={(props) => renderTooltip({ ...props, id: "sort-1", text: `${user.email}` })}
                                    >
                                        <span>{user.title}</span>
                                    </OverlayTrigger>
                                </div>

                                <div style={{ margin: '0' }}>
                                    <OverlayTrigger
                                        key="sort-1"
                                        placement="top"
                                        width
                                        delay={{ show: 50, hide: 50 }}
                                        overlay={(props) => renderTooltip({ ...props, id: "sort-1", text: `${folder.email}` })}
                                    >
                                        <span>{folder.title}</span>
                                    </OverlayTrigger>
                                </div>
                            </div>
                        )
                    }
                },
                {
                    headerName: 'Queries List',
                    field: 'queriesList',
                    filter: false, minWidth: 500,
                    cellRenderer: TableRenderer,

                },
                {
                    headerName: 'Count', field: 'resultCount', filter: 'agNumberColumnFilter', maxWidth: 100,
                    cellStyle: { textAlign: 'center', display: 'flex', justifyContent: 'center', alignItems: 'center' },
                },
                {
                    headerName: 'Status', field: 'status', maxWidth: 125, filter: false,
                    cellStyle: { textAlign: 'center', display: 'flex', justifyContent: 'center', alignItems: 'center' },
                    cellRenderer: (params) => <div>
                        {params.value === "Active" && 
                            < Button
                                style={{
                                    height: "24px",
                                    padding: "0",
                                    background: "transparent",
                                    border: "none",
                                    outline: "none",
                                    boxShadow: "none",
                                    display: "inline-flex",
                                    alignItems: "center"
                                }}
                                onClick={(e) => this.showSearch(e,params.rowIndex)}
                            >
                                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-search" viewBox="0 0 16 16">
                                    <path d="M11.742 10.344a6.5 6.5 0 1 0-1.397 1.398h-.001q.044.06.098.115l3.85 3.85a1 1 0 0 0 1.415-1.414l-3.85-3.85a1 1 0 0 0-.115-.1zM12 6.5a5.5 5.5 0 1 1-11 0 5.5 5.5 0 0 1 11 0" />
                                </svg>
                            </Button>
                        }
                        {params.value === "Expired" && <span style={{ color: 'red' }}>
                            {params.value}
                        </span>}
                        {params.value === "In Progress" && <span style={{ color: '#3498db' }}>
                            {params.value}
                        </span>}
                    </div>
                },

            ], []);



            const defaultColDef = useMemo(() => ({
                flex: 1,
                editable: false, 
                resizable: true,
                headerStyle: { textAlign: 'center', display: 'flex', justifyContent: 'center', alignItems: 'center' },
            }), []);

            if ((this.state.activeAccordion !== '0' && this.state.selectedRestoreType !== "Azure Backup") ) {
                return (
                    <>
                        <div className="">
                            <div style={{ width: "100%", margin: "auto" }} className="row p-1 restore-accordion" onClick={this.openSearchHistoryPanel}>
                                <div className="col-11" style={{ fontWeight: 'bold', fontSize: '17px', padding: '0.5rem 1rem' }}>
                                    Active Search List
                                    <OverlayTrigger placement="right" overlay={<Tooltip id="tooltip-diskspace">Active search results will expire in 8 hours and will be removed from Active search list in 10 hours</Tooltip>}>
                                        <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" className="ms-2 bi bi-info-circle" viewBox="0 0 16 16" >
                                            <path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14m0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16" />
                                            <path d="m8.93 6.588-2.29.287-.082.38.45.083c.294.07.352.176.288.469l-.738 3.468c-.194.897.105 1.319.808 1.319.545 0 1.178-.252 1.465-.598l.088-.416c-.2.176-.492.246-.686.246-.275 0-.375-.193-.304-.533zM9 4.5a1 1 0 1 1-2 0 1 1 0 0 1 2 0" />
                                        </svg>
                                    </OverlayTrigger>
                                </div>
                                <div className="col clearfix">
                                    <Button className="float-right" onClick={this.openSearchHistoryPanel} style={{ float: 'right' }}>
                                        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" className={`arrow ${this.state.searchHistoryPanelOpen ? 'arrow_rotate bi bi-chevron-down' : 'bi bi-chevron-down'}`} viewBox="0 0 16 16">
                                            <path strokeWidth="2" d="M1.646 4.646a.5.5 0 0 1 .708 0L8 10.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708" />
                                        </svg>
                                    </Button>
                                </div>
                            </div>
                            <Collapse isOpen={this.state.searchHistoryPanelOpen}>
                                <div className="row" id="searchQuerybody">
                                    <div className="col-12">
                                        <div className="row">
                                            <div className="ag-theme-alpine" style={{ width: '100%', maxHeight: 600 }}>
                                                <AgGridReact
                                                    //rowData={ActiveSearchrowData}
                                                    columnDefs={columnDefs}
                                                    defaultColDef={defaultColDef}
                                                    getRowHeight={getRowHeight}
                                                    headerHeight={headerHeight}
                                                    pagination={true}
                                                    paginationPageSize={10}
                                                    paginationPageSizeSelector={[10, 20, 50]}
                                                    overlayLoadingTemplate={
                                                        `<div style="position:absolute;top:50%;left:50%;transform:translate(-50%, -50%);"><img src="${LoaderGif}" alt="loading" style="height:50px;"></div>`}
                                                    overlayNoRowsTemplate={
                                                        '<span className="ag-overlay-loading-center">No Search records to show</span>'
                                                    }
                                                    onGridReady= {activeSearchOnGrid}
                                                    domLayout="autoHeight"
                                                />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </Collapse>
                        </div>
                    </>
                );
            } else {
                return null;
            }
        };
        let footer = null;
        if (this.state.viewItems.length > 0) {
            ////let nextPageButton;
            ////let previousPageButton;
            ////if (!this.state.nextBlocked) {
            ////    nextPageButton = (
            ////        <Button
            ////            onClick={(e) => this.nextPage(e, this.state.searchResultsFlag)}
            ////            disabled={this.state.nextBlocked}
            ////            style={{ marginLeft: "10px" }}
            ////        >
            ////            +
            ////        </Button>
            ////    );
            ////}
            ////if (this.state.displayPage !== 0) {
            ////    previousPageButton = (
            ////        <Button
            ////            onClick={(e) => this.previousPage(e, this.state.searchResultsFlag)}
            ////            disabled={this.state.displayPage === 0}
            ////            style={{ marginRight: "10px" }}
            ////        >
            ////            -
            ////        </Button>
            ////    );
            ////}
            footer = (
                <div className="card-footer">
                    <div
                        className="btn-toolbar"
                        role="toolbar"
                        style={{
                            position: "sticky",
                            bottom: "0",
                            justifyContent: "center",
                            width: "100%",
                        }}
                    >
                        {/*{previousPageButton}*/}
                        {/*<Button disabled>{this.state.displayPage + 1}</Button>*/}
                        {/*{nextPageButton}*/}
                    </div>
                </div>
            );
        }
        let noResultsSection;
        let searchMsgAfter10Sec = null;
        if( (this.state.noResults && !this.state.inProgressRight && !this.state.SearchQueued)) {
            noResultsSection = (
                <div className="row">
                    <div className="col" />
                    <div className="col">
                        <p>No results.</p>
                    </div>
                    <div className="col" />
                </div>
            );
            
        }
        if (this.state.SearchQueued && !this.state.inProgressRight){
            searchMsgAfter10Sec = (
                    <div className="row">
                        <div className="col" style={{ textAlign: 'center', padding : '10px' }}>
                            <p style={{ marginBottom: '5px', lineHeight: '1.2' }}>
                                Your search request has been successfully queued in the active search list.
                            </p>
                            <p style={{ marginBottom: '5px', lineHeight: '1.2' }}>
                                You will be notified once the results are ready, and you'll be able to view them as soon as they're available.
                            </p>
                        </div>
                    </div>
            );
        }
        let leftCardSection;
        if (
            this.state.selectItems.length > 0 ||
            this.state.inProgressLeft ||
            this.state.errorMessage !== ""
        ) {
            leftCardSection = (
                <div className="card-body m-2 p-1 mt-0 restore-left-accordion" style={{ maxHeight: '779px', overflowY: 'auto', minHeight:'470px' }}>
                    <p>{this.state.errorMessage}</p>
                    {leftSection}
                </div>
            );
        } else if (
            this.state.selectItems.length === 0 &&
            this.state.gotSelectItems
        ) {
            leftCardSection = <div className="card-body">{noItemsWarning}</div>;
        }
        if (this.state.clearLeftSection) {
            leftCardSection = []
        }
        if (this.state.inProgressRight) {
            noResultsSection = (
                <div className="d-flex justify-content-center">
                    <img src={LoaderGif} alt="loading" style={{ height: '50px' }} />
                </div>
            );
        }
        if (this.state.searchResultsFlag && this.state.viewItems.length > 0) {
            var clearButton = (
                <div>
                    <Button key="clear" onClick={this.clearSearch} className="ms-2">
                        Clear Search
                    </Button>
                </div>
            );
            restoreButtons.push(clearButton);
        }
        if (!this.state.downloadModalOpen) {
            downloadModal = null;
        }
        if (!this.state.verificationModalOpen) {
            verificationModal = null;
        }
        if (!this.state.mailModalOpen) {
            mailModal = null;
        }
        if (!this.state.restoreModalOpen) {
            restoreModal = null;
        }

        let exchangeTabClassName = "btn nav-link pad-5";
        let sharepointTabClassName = "btn nav-link pad-5";
        let onedriveTabClassName = "btn nav-link pad-5";
        let teamsTabClassName = "btn nav-link pad-5";
        let aadTabClassName = "btn nav-link pad-5";
        if (this.state.restoreType === "vex") {
            exchangeTabClassName += " active";
        } else if (this.state.restoreType === "vesp") {
            sharepointTabClassName += " active";
        } else if (this.state.restoreType === "veod") {
            onedriveTabClassName += " active";
        } else if (this.state.restoreType === "vet") {
            teamsTabClassName += " active";
        } else if (this.state.restoreType === "aad") {
            aadTabClassName += " active";
        }
        let chosenTheme;
        const ResellerTheme = React.lazy(() =>
            import("./ThemeObjects/RestorePage")
        );
        chosenTheme = <ResellerTheme />;
        let restorePointPopup = null;
        // if (this.state.showRestorePoints)
        
        restorePointPopup = (
            <></>
            //<Modal
            //    isOpen={this.state.showRestorePoints}>
            //    <RestorePoints
            //        restorePoints={this.state.restorePoints}
            //        popupSwap={this.showRestorePointsPopup}
            //        showPopup={this.state.showRestorePoints}
            //        setRestorePoint={this.setRestorePoint} />
            //</>
        );
        ////let restoreCalendar = null;
        ////restoreCalendar  =(<><Calendar style={{ height: 500 }}
        ////    onChange={(date) => this.selectRestoreOnChange(date, this.state.restorePoints)}
        ////    value={this.state.date}
        ////    tileClassName={({ date, view }) => {
        ////        for (var i = 0; i < this.state.restorePoints.length; i++) {
        ////            var x = this.state.restorePoints[i].backupTimeStr.split(' ')[0];
        ////            if (x === moment(date).format("DD-MM-YYYY")) {

        ////                return 'highlight';
        ////            }
        ////        }
        ////    }}
        ////    onActiveStartDateChange={this.onActiveStartDateChange}
        ////>
        ////</Calendar>
        ////    <div className="mt-2 mb-2" style={{ display: 'flex', justifyContent: 'center' }}>
        ////        <button onClick={this.getRestorePointsOnMonth} className="btn btn-primary">Show All</button>
        ////    </div>
        ////</>)
        const azureColDefs = [
            { field: "startTime", headerName: 'Date', wrapText: true, cellStyle: { 'text-align': 'left' }, minWidth:155 },
            { field: "process", headerName: 'Process', wrapText: true, cellStyle: { 'text-align': 'left' }, minWidth: 100 },
            { field: "diffCount", headerName: 'Diff', headerTooltip: 'Number of changes captured.', wrapText: true, cellStyle: { 'text-align': 'left' }, minWidth: 80 }
        ];
        //const [gridApi, setGridApi] = useState([]);
        const getRowStyle = params => {
            return { fontSize: "Small" };
        };
        const rowHeight = 25;
        const headerHeight = 30;
        const onRowClicked = (params) => {
            this.getAADBackupConfigData(params.data.diffFile, this.state.orgName, params.data)
            
        }
        const renderTooltip = (props) => (
            <Tooltip id="AzureInfo-tooltip" {...props}>
                <img
                    src={AzureToolTip}
                    alt="Tooltip"
                    style={{ width:'26vw' }}
                />
            </Tooltip>
        );
        const onGridReady = (params) => {
            //setGridApi(params.api);
            this.setState({
                azureGridApi: params.api,
            });
            //params.api.sizeColumnsToFit();
        }
        return (
            <React.Fragment>

                <React.Suspense fallback={<></>}>{chosenTheme}</React.Suspense>
                {verificationModal} 
                {mailModal}
                {toAnotherMailboxModal}
                {siteModal}
                {oneDriveModal}
                {downloadModal}
                {litigationModal}
                {entraModal}
                {restoreModal}
                {confirmationModal}
                <NavBar
                    page="restore"
                    impersonating={this.state.impersonating}
                    orgName={this.state.orgName}
                    authContext={this.props.authContext || this.context} 
                    isAzureGuardianOnly={this.state.isAzureGuardianOnly}
                />
                {restorePointPopup}
                <div id='main-div-form-elements' className='overlay'><div className="loader"></div></div>
                <div className="row pb-4" style={{ margin: "auto", overflowY: 'auto', maxHeight: '89vh', minHeight:'700px' }}>
                    <div className="col-3" style={{ width: '21%' }}>
                        <div className="accordion" style={{ minWidth: 'auto' }}>
                            <div className="accordion-item main-restore-accordion" style={{border :"0"} }>
                            {/* Accordion Header */}
                            <h4 className="accordion-header mb-1">
                                <button
                                    type="button"
                                    className={`accordion-button ${this.state.isAccordionOpen ? "" : "collapsed"}`}
                                    onClick={this.handleNewRestoreClick}
                                    aria-expanded={this.state.isAccordionOpen}
                                    style={{
                                        backgroundColor: "rgb(225 236 246)",
                                        fontFamily: "Roboto, sans-serif",
                                        padding: "9px",
                                        color: "#212529",
                                        borderRadius: "9px",
                                        display: "flex",
                                        justifyContent: "space-between",
                                        width: "100%",
                                        fontSize: "smaller",
                                    }}
                                >
                                    New Restore
                                </button>
                            </h4>

                            {/* Accordion Body */}
                            <div className={`accordion-collapse collapse ${this.state.isAccordionOpen ? "show" : ""}`}>
                                <Accordion defaultActiveKey={["0"]} activeKey={this.state.activeAccordion} style={{ minWidth: 'auto' }} id="restore_accordion">
                                <Accordion.Item eventKey="0">
                                    <Accordion.Header onClick={() => this.accordianChange("first", "0")}>Select a restore type {this.state.selectedRestoreType !== "" && "- " + this.state.selectedRestoreType}</Accordion.Header>
                                    <Accordion.Body className="p-0">
                                        {this.state.isAzureGuardianOnlyLoaded ?
                                            <div className="row">
                                                {!this.state.isAzureGuardianOnly && <div className="col">
                                                            <span className="p-1 m-1 ps-2 pe-2 accordion-btn-primary" onClick={() => { this.restoreChallengePopup(false); }} style={{ boxShadow: '2px 3px 7px gray', cursor: 'pointer', display: 'flex', borderRadius: '4px', alignItems: 'center', justifyContent: 'center' }}>
                                                        <b className="me-1">365 </b> Restore
                                                        <img
                                                            src={cloud}
                                                            alt="365 Restore"
                                                            title="365 Restore"
                                                            className={exchangeTabClassName}
                                                            style={{ paddingLeft: '7px', height: '22px' }}
                                                        />
                                                    </span>
                                                </div>}
                                                <div className="col">
                                                    {(Object.keys(this.state.priceModel).length !== 0 && this.state.priceModel.features.find(feature => feature.featureType === "AZURE") !== undefined && this.state.priceModel.features.find(feature => feature.featureType === "AZURE").featureValue.toLowerCase() === "true") && (sessionStorage.getItem('IsEndUser') !== "true") && (sessionStorage.getItem('IsEndUser') !== true) ?

                                                                <span className="p-1 m-1 ps-2 pe-2 accordion-btn-primary" onClick={() => { this.restoreChallengePopup(true); }} style={{ boxShadow: '2px 3px 7px gray', cursor: 'pointer', display: 'flex',  borderRadius: '4px', alignItems: 'center', justifyContent: 'center' }}> <b className="me-1">Azure </b> Restore
                                                            <img
                                                                src={cloud}
                                                                alt="AAD Restore"
                                                                title="AAD Restore"
                                                                className={aadTabClassName} style={{ paddingLeft: '7px', height: '22px' }} />
                                                        </span>
                                                        : !this.state.guardianStatusLoaded ?
                                                            <OverlayTrigger placement="right" overlay={<Tooltip id="tooltip-diskspace">Loading...</Tooltip>}>
                                                                        <span className={aadTabClassName + " p-1 m-1 ps-2 pe-2 accordion-btn-primary"} style={{ boxShadow: '2px 3px 7px gray', cursor: 'pointer', fontSize: '13px', display: 'flex', borderRadius: '4px', alignItems: 'center', justifyContent: 'center' }}> <b className="me-1">Azure </b> Restore
                                                                    <img
                                                                        src={cloud}
                                                                        alt="AAD Restore"
                                                                        title="AAD Restore"
                                                                        className={aadTabClassName} style={{ paddingLeft: '7px', height: '22px' }} />
                                                                </span>
                                                            </OverlayTrigger>
                                                            : <OverlayTrigger placement="right" overlay={<Tooltip id="tooltip-diskspace">{(Object.keys(this.state.priceModel).length !== 0 && this.state.priceModel.features.find(feature => feature.featureType === "AZURE") !== undefined && this.state.priceModel.features.find(feature => feature.featureType === "AZURE").featureValue.toLowerCase() === "true") ? "Not Available" : "Not Available in your selected package"}</Tooltip>}>
                                                                        <span className={aadTabClassName + " p-1 m-1 ps-2 pe-2 accordion-btn-primary"} style={{ boxShadow: '2px 3px 7px gray', cursor: 'pointer', fontSize: '13px', display: 'flex',  borderRadius: '4px', alignItems: 'center', justifyContent: 'center' }}> <b className="me-1">Azure </b> Restore
                                                                    <img
                                                                        src={cloud}
                                                                        alt="AAD Restore"
                                                                        title="AAD Restore"
                                                                        className={aadTabClassName} style={{ paddingLeft: '7px', height: '22px' }} />
                                                                </span>
                                                            </OverlayTrigger>}
                                                </div>
                                            </div>
                                            :
                                            <div className="row" style={{ height: '40px', display: 'flex', justifyContent: 'center', alignItems: 'center', }}>
                                            <img src={DotsTyping} alt="loading" style={{ height: '8px', width:'60px' }} />
                                            </div>}

                                    </Accordion.Body>
                                </Accordion.Item>
                                <Accordion.Item eventKey="1" >
                                <Accordion.Header className={`${this.state.activeAccordion[0] < '1' ? 'accordian-disabled' : ''}`} onClick={() => this.accordianChange("previous", "1")}>Select a restore date {this.state.selectedRestoreDate !== "" && "- " + this.state.selectedRestoreDate} {this.state.selectedRestoreType === "Azure Backup" &&
                                        <OverlayTrigger placement="right" overlay={renderTooltip} delay={{ show: 250, hide: 400 }}>
                                            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="ms-2 bi bi-info-circle" viewBox="0 0 16 16" >
                                                <path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14m0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16" />
                                                <path d="m8.93 6.588-2.29.287-.082.38.45.083c.294.07.352.176.288.469l-.738 3.468c-.194.897.105 1.319.808 1.319.545 0 1.178-.252 1.465-.598l.088-.416c-.2.176-.492.246-.686.246-.275 0-.375-.193-.304-.533zM9 4.5a1 1 0 1 1-2 0 1 1 0 0 1 2 0" />
                                            </svg>
                                        </OverlayTrigger>}</Accordion.Header>
                                    <Accordion.Body className="p-0">
                                        <div id="aadCalendar">
                                            {this.state.renderAzureRestoreestoreCalendar}
                                            {/*<Calendar style={{ height: 500 }}*/}
                                            {/*    onChange={this.onChange}   */}
                                            {/*    value={this.state.date}*/}
                                            {/*    tileClassName={({ date, view }) => {*/}
                                            {/*        for (var i = 0; i < this.state.mark.length; i++) {*/}
                                            {/*            var x = this.state.mark[i].restoreDate.split(' ')[0];*/}
                                            {/*            if (x === moment(date).format("DD-MM-YYYY")) {*/}
                                            {/*                return 'highlight';*/}
                                            {/*            }*/}
                                            {/*        }*/}
                                            {/*    }}*/}
                                            {/*>*/}
                                            {/*</Calendar>*/}

                                        </div>
                                        <div id="restoreCalendar">
                                            {this.state.renderRestoreestoreCalendar}
                                            {/*<Calendar style={{ height: 500 }} */}
                                            {/*    onChange={(date) => this.selectRestoreOnChange(date, this.state.restorePoints)}*/}
                                            {/*    value={this.state.date}*/}
                                            {/*    tileClassName={({ date, view }) => {*/}
                                            {/*        for (var i = 0; i < this.state.restorePoints.length; i++) {*/}
                                            {/*            var x = this.state.restorePoints[i].backupTimeStr.split(' ')[0];*/}
                                            {/*            if (x === moment(date).format("DD-MM-YYYY")) {*/}

                                            {/*                return 'highlight';*/}
                                            {/*            }*/}
                                            {/*        }*/}
                                            {/*    }}*/}
                                            {/*    onActiveStartDateChange={this.onActiveStartDateChange}*/}
                                            {/*>*/}
                                            {/*</Calendar>*/}
                                            {/*<div className="m-2" style={{ display: 'flex', justifyContent: 'center' }}>*/}
                                            {/*    <button onClick={this.getRestorePointsOnMonth} className="btn btn-primary w-100" style={{ fontFamily: 'Roboto, sans-serif', fontSize:'19px' }}>Show All Restore Points</button>*/}
                                            {/*</div>*/}
                                        </div>

                                        {/*<div style={{ textAlign: 'end' }}>*/}
                                        {/*    <svg className="m-1 me-3 mt-2" onClick={() => this.accordianChange("previous")} xmlns="http://www.w3.org/2000/svg" version="1.0" width="20" height="20" viewBox="0 0 512.000000 512.000000" preserveAspectRatio="xMidYMid meet">*/}
                                        {/*        <g transform="translate(0.000000,512.000000) scale(0.100000,-0.100000)" fill="#5191ce" stroke="#5191ce" strokeWidth="400">*/}
                                        {/*            <path d="M2450 3939 c-35 -15 -304 -279 -1223 -1197 -693 -692 -1187 -1193 -1198 -1215 -63 -121 -11 -279 112 -341 68 -33 162 -36 229 -5 35 15 284 259 1118 1092 l1072 1072 1073 -1072 c833 -833 1082 -1077 1117 -1092 67 -31 161 -28 229 5 123 62 175 220 112 341 -11 22 -505 523 -1198 1215 -919 918 -1188 1182 -1223 1197 -30 14 -66 21 -110 21 -44 0 -80 -7 -110 -21z" />*/}
                                        {/*        </g>*/}
                                        {/*    </svg>*/}
                                        {/*</div>*/}
                                    </Accordion.Body>
                                </Accordion.Item>
                                <Accordion.Item eventKey="2">
                                    <Accordion.Header className={`${this.state.activeAccordion < '2' ? 'accordian-disabled' : ''}`} onClick={() => this.accordianChange("previous", "2")}>Select a restore point {this.state.selectedRestorePoint !== "" && "- " + this.state.selectedRestorePoint}</Accordion.Header>
                                    <Accordion.Body className="p-0">
                                        {this.state.aadnoResults && (
                                            <RestorePoints
                                                restorePoints={this.state.selectedrestorePoints}
                                                popupSwap={this.showRestorePointsPopup}
                                                showPopup={this.state.showRestorePoints}
                                                setRestorePoint={this.setRestorePoint}
                                                isEndUser={this.state.isEndUser}
                                            />
                                        )}
                                        {!this.state.aadnoResults && (
                                            <div>
                                                {this.state.isAADRestoreTableLoaded ? <div className="card-body p-0">

                                                    <div id="azureRestorePointList" className="ag-theme-alpine" style={{ borderColor: "#F0F0F0", borderStyle: "Solid", width: "100%", height: 300, borderCollapse: "collapse" }} >

                                                        <AgGridReact
                                                            ref={this.gridRef}
                                                            rowData={this.state.aadviewItems}
                                                            enableCellTextSelection="true"
                                                            getRowStyle={getRowStyle}
                                                            onRowClicked={onRowClicked}
                                                            onGridReady={onGridReady}
                                                            defaultColDef={defaultColDef}
                                                            rowSelection={{ mode: 'singleRow', checkboxes: false, enableClickSelection: true }}
                                                            columnDefs={azureColDefs}
                                                            width={700}
                                                            headerHeight={headerHeight}
                                                            rowHeight={rowHeight}
                                                            overlayLoadingTemplate={
                                                                `<div style="position:absolute;top:50%;left:50%;transform:translate(-50%, -50%);"><img src="${LoaderGif}" alt="loading" style="height:50px;"></div>`}
                                                            overlayNoRowsTemplate={
                                                                '<span className="ag-overlay-loading-center">No error records to show</span>'
                                                            }
                                                        >
                                                        </AgGridReact>
                                                    </div>
                                                </div>
                                                    : <div className="justify-content-center align-items-center d-flex h-100" style={{ minHeight: '225px' }}>
                                                        <img src={LoaderGif} alt="loading" style={{ height: '50px' }} />
                                                    </div>}


                                                {/*<Table border="1" className="mt-0 mb-0">*/}
                                                {/*    <thead>*/}
                                                {/*        <tr>*/}
                                                {/*            <th style={{ backgroundColor: 'rgb(81, 145, 206)', color: 'white' }}>Date</th>*/}
                                                {/*            <th style={{ backgroundColor: 'rgb(81, 145, 206)', color: 'white' }}>Process</th>*/}
                                                {/*            <th style={{ backgroundColor: 'rgb(81, 145, 206)', color: 'white' }}>Diff</th>*/}
                                                {/*        </tr>*/}
                                                {/*    </thead>*/}
                                                {/*    <tbody style={{ fontSize: '13px' }}>*/}
                                                {/*        {this.state.aadviewItems.map((item, index) => (*/}
                                                {/*            <tr key={index}*/}
                                                {/*                onClick={() => this.getAADBackupConfigData(item.diffFile, this.state.orgName, item)} style={{ cursor: 'pointer' }}>*/}
                                                {/*                <td>{item.startTime}</td>*/}
                                                {/*                <td>{item.process}</td>*/}
                                                {/*                <td>{item.diffCount}</td>*/}
                                                {/*            </tr>*/}
                                                {/*        ))}*/}
                                                {/*    </tbody>*/}
                                                {/*</Table>*/}
                                            </div>)}
                                        {/*<div style={{ textAlign:'end' }}>*/}
                                        {/*    <svg className="m-1 me-3 mt-2" onClick={() => this.accordianChange("previous")} xmlns="http://www.w3.org/2000/svg" version="1.0" width="20" height="20" viewBox="0 0 512.000000 512.000000" preserveAspectRatio="xMidYMid meet">*/}

                                        {/*        <g transform="translate(0.000000,512.000000) scale(0.100000,-0.100000)" fill="#5191ce" stroke="#5191ce" strokeWidth="400">*/}
                                        {/*            <path d="M2450 3939 c-35 -15 -304 -279 -1223 -1197 -693 -692 -1187 -1193 -1198 -1215 -63 -121 -11 -279 112 -341 68 -33 162 -36 229 -5 35 15 284 259 1118 1092 l1072 1072 1073 -1072 c833 -833 1082 -1077 1117 -1092 67 -31 161 -28 229 5 123 62 175 220 112 341 -11 22 -505 523 -1198 1215 -919 918 -1188 1182 -1223 1197 -30 14 -66 21 -110 21 -44 0 -80 -7 -110 -21z" />*/}
                                        {/*        </g>*/}
                                        {/*    </svg>*/}
                                        {/*</div>*/}
                                    </Accordion.Body>
                                </Accordion.Item>
                                <Accordion.Item eventKey="3" id="accordion_3">
                                    <Accordion.Header className={`${this.state.activeAccordion < '3' ? 'accordian-disabled' : ''}`} onClick={() => this.accordianChange("previous", "3")}>Select an item type</Accordion.Header>
                                    <Accordion.Body className="p-0">
                                        <div className="card" style={{ maxHeight: '853px' }}>
                                            <div className="card-header">
                                                <ul className="nav nav-tabs card-header-tabs justify-content-between">
                                                    <li className="nav-item" id="Exchange_restore">
                                                        <img
                                                            src={this.state.restorePoint.length === 0 ? exchange : this.state.restorePoint.isExchange ? exchange : exchangeDisabled}
                                                            onClick={(e) => {
                                                                    this.setState({ timeoutError: false })
                                                                if (this.state.restorePoint.length === 0 || this.state.restorePoint.isExchange)
                                                                    this.getOrgRestore(e, "vex");
                                                                else
                                                                    return;
                                                            }
                                                            }
                                                            alt="Exchange Restore"
                                                            title="Exchange Restore"
                                                            className={exchangeTabClassName}
                                                            style={{ paddingLeft: '7px', paddingRight: '7px' }}
                                                        />
                                                    </li>
                                                    <li className="nav-item" id="Sharepoint_restore">
                                                        <img
                                                            src={(this.state.restorePoint.length === 0 ? sharepoint : this.state.restorePoint.isSharePoint ? sharepoint : sharepointDisabled)}
                                                            onClick={(e) => {
                                                                     this.setState({ timeoutError: false })
                                                                if (this.state.restorePoint.length === 0 || this.state.restorePoint.isSharePoint)
                                                                    this.getOrgRestore(e, "vesp");
                                                                else
                                                                    return;
                                                            }
                                                            }
                                                            alt="Sharepoint Restore"
                                                            title="Sharepoint Restore"
                                                            className={sharepointTabClassName}
                                                            style={{ paddingLeft: '7px', paddingRight: '7px' }}
                                                        />
                                                    </li>
                                                    <li className="nav-item" id="OneDrive_restore">
                                                        <img
                                                            src={
                                                                (this.state.restorePoint.length === 0 ? onedrive : this.state.restorePoint.isOneDrive ? onedrive : onedriveDisabled)
                                                            }
                                                            onClick={(e) => {
                                                                this.setState({ timeoutError: false })
                                                                if (this.state.restorePoint.length === 0 || this.state.restorePoint.isOneDrive) {
                                                                    this.getOrgRestore(e, "veod");
                                                                }
                                                                else
                                                                    return;
                                                            }}
                                                            alt="OneDrive Restore"
                                                            title="OneDrive Restore"
                                                            className={onedriveTabClassName}
                                                            style={{
                                                                paddingLeft: '7px',
                                                                paddingRight: '7px',
                                                            }}
                                                        />
                                                    </li>
                                                    <li className="nav-item" id="Teams_restore">
                                                        <img
                                                            src={
                                                                this.state.isEndUser
                                                                    ? teamsDisabled
                                                                    : (this.state.restorePoint.length === 0 ? teams : this.state.restorePoint.isTeams ? teams : teamsDisabled)}
                                                            onClick={(e) => {
                                                                this.setState({ timeoutError: false })
                                                                if (!this.state.isEndUser && (this.state.restorePoint.length === 0 || this.state.restorePoint.isTeams)) {
                                                                    this.getOrgRestore(e, "vet");
                                                                }

                                                            }}
                                                            alt="Teams Restore"
                                                            title={this.state.isEndUser ? "Disabled for End Users" : "Teams Restore"}
                                                            className={teamsTabClassName}
                                                            tyle={{
                                                                paddingLeft: '7px',
                                                                paddingRight: '7px',
                                                                opacity: this.state.isEndUser ? 0.5 : 1,
                                                                cursor: this.state.isEndUser ? 'not-allowed' : 'pointer'
                                                            }}
                                                        />
                                                    </li>

                                                    <li className="nav-item" id="AAD_restore">

                                                        {(Object.keys(this.state.priceModel).length !== 0 && this.state.priceModel.features.find(feature => feature.featureType === "AZURE") !== undefined && this.state.priceModel.features.find(feature => feature.featureType === "AZURE").featureValue.toLowerCase() === "true") && (sessionStorage.getItem('IsDirectCustomer') !== "true") && (sessionStorage.getItem('IsEndUser') !== true) ? <img
                                                            src={aadIcon}

                                                            onClick={(e) => { this.getOrgRestore(e, "aad"); }}
                                                            alt="AAD Restore"
                                                            title="AAD Restore"
                                                            className={aadTabClassName}
                                                            style={{ paddingLeft: '7px', paddingRight: '7px' }}
                                                        /> : <OverlayTrigger placement="right" overlay={<Tooltip id="tooltip-diskspace">{(Object.keys(this.state.priceModel).length !== 0 && this.state.priceModel.features.find(feature => feature.featureType === "AZURE") !== undefined && this.state.priceModel.features.find(feature => feature.featureType === "AZURE").featureValue.toLowerCase() === "true") ? "Not Available" : "Not Available in your selected package"}</Tooltip>}>
                                                            <img
                                                                src={aadIconDisabled}
                                                                alt="AAD Restore"
                                                                className={aadTabClassName}
                                                                style={{ paddingLeft: '7px', paddingRight: '7px' }}
                                                            />
                                                        </OverlayTrigger>}
                                                    </li>
                                                </ul>
                                            </div>
                                            <div id="RestoreLandingPage" style={{ padding: "20px" }}>
                                                {/*<span*/}
                                                {/*    style={{ fontSize: "18px", fontWeight: 500, textAlign: "center", display: "block", padding: "10px" }}*/}
                                                {/*>*/}
                                                {/*    Select a restore point.*/}
                                                {/*</span>*/}
                                                {/*<div className=" col-10 d-flex justify-content-center" id="datePickerRestore" style={{ padding: "15px 0 15px 0" }}>*/}
                                                {/*    <DatePicker*/}
                                                {/*        selected={this.state.restoreDate}*/}
                                                {/*        minDate={this.state.firstRestoreDate}*/}
                                                {/*        maxDate={this.state.lastRestoreDate}*/}
                                                {/*        onChange={(date) => this.handleDateChange(date)}*/}
                                                {/*        dateFormat="dd/MM/yyyy"*/}
                                                {/*        style={{ maxHeight: "30px" }}*/}
                                                {/*        className="mr-1 datepicker"*/}
                                                {/*    />*/}
                                                {/*    <TimePicker*/}
                                                {/*        onChange={(time) => this.handleTimeChange(time)}*/}
                                                {/*        disableClock={true}*/}
                                                {/*        value={this.state.restoreTime}*/}
                                                {/*        style={{ maxHeight: "30px" }}*/}
                                                {/*        className="timepicker"*/}
                                                {/*    />*/}
                                                {/*</div>*/}
                                                {/*<div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>*/}
                                                {/*    <a*/}
                                                {/*        id="ShowRestorePoints"*/}
                                                {/*        style={{ color: "#007bff", marginBottom: '1rem' }}*/}
                                                {/*        onClick={() => {*/}
                                                {/*            this.setState({*/}
                                                {/*                showRestorePoints: true*/}
                                                {/*            });*/}
                                                {/*        }}*/}
                                                {/*    >*/}
                                                {/*        Show restore points*/}
                                                {/*    </a>*/}
                                                {/*</div>*/}

                                                {/*<div style={{ textAlign: "center" }}>*/}
                                                {/*    <img*/}
                                                {/*        src={NavigateCalendar} alt="Click to choose"*/}
                                                {/*        style={{ margin: "18px auto 0 auto", display: "block" }}*/}
                                                {/*    />*/}
                                                {/*    <span style={{ fontSize: "18px", marginTop: "15px", fontWeight: 500 }}>Click to choose</span>*/}
                                                {/*</div>*/}
                                            </div>
                                            {leftCardSection}
                                        </div>
                                        {/*<div style={{ textAlign: 'end' }}>*/}
                                        {/*    <svg className="m-1 me-3 mt-2" onClick={() => this.accordianChange("previous")} xmlns="http://www.w3.org/2000/svg" version="1.0" width="20" height="20" viewBox="0 0 512.000000 512.000000" preserveAspectRatio="xMidYMid meet">*/}
                                        {/*        <g transform="translate(0.000000,512.000000) scale(0.100000,-0.100000)" fill="#5191ce" stroke="#5191ce" strokeWidth="400">*/}
                                        {/*            <path d="M2450 3939 c-35 -15 -304 -279 -1223 -1197 -693 -692 -1187 -1193 -1198 -1215 -63 -121 -11 -279 112 -341 68 -33 162 -36 229 -5 35 15 284 259 1118 1092 l1072 1072 1073 -1072 c833 -833 1082 -1077 1117 -1092 67 -31 161 -28 229 5 123 62 175 220 112 341 -11 22 -505 523 -1198 1215 -919 918 -1188 1182 -1223 1197 -30 14 -66 21 -110 21 -44 0 -80 -7 -110 -21z" />*/}
                                        {/*        </g>*/}
                                        {/*    </svg>*/}
                                        {/*</div>*/}
                                    </Accordion.Body>
                                </Accordion.Item>
                            </Accordion>
                            </div>
                        </div>
                        </div>
                        {/* Task 14 — PST export progress. Rendered as its own banner, NOT folded into
                            the Restore Sessions Status column: that column reports Veeam's own
                            session state and overloading it would make a running export look like a
                            running restore. */}
                        {this.state.pstExports.filter((e) => e.isInProgress || e.IsInProgress).length > 0 && (
                            <div
                                className="mt-3 p-3"
                                style={{
                                    backgroundColor: "rgb(225 236 246)",
                                    borderRadius: "9px",
                                    fontFamily: "Roboto, sans-serif",
                                    fontSize: "smaller",
                                    color: "#212529",
                                }}
                            >
                                <img src={LoaderGif} alt="" style={{ height: "18px", marginRight: "8px", verticalAlign: "middle" }} />
                                <strong>PST export in progress</strong>
                                {" — "}
                                {this.state.pstExports.filter((e) => e.isInProgress || e.IsInProgress).length === 1
                                    ? "1 export is running for this restore session."
                                    : `${this.state.pstExports.filter((e) => e.isInProgress || e.IsInProgress).length} exports are running for this restore session.`}
                                {" "}
                                We will email you when your files are ready to download.
                            </div>
                        )}

                        {this.state.showRestoreSession &&
                            this.state.selectedRestoreType !== "Azure Backup" && (
                            <div className="accordion">
                                <div className="accordion-item mt-3">
                                    {/* Accordion Header */}
                                    <h4 className="accordion-header">
                                        <button
                                            className={`accordion-button ${this.state.restoreSessionGrid ? "" : "collapsed"}`}
                                            type="button"
                                            onClick={this.toggleGridVisibility}
                                            aria-expanded={this.state.restoreSessionGrid}
                                            //disabled={this.state.restoreType === "aad"}
                                            disabled={this.state.selectedRestoreType === "Azure Backup"}
                                            style={{
                                                backgroundColor: "rgb(225 236 246)",
                                                fontFamily: "Roboto, sans-serif",
                                                padding: "9px",
                                                borderRadius: "9px",
                                                color: "#212529",
                                                display: "flex",
                                                justifyContent: "space-between",
                                                width: "100%",
                                                fontSize: "smaller",
                                            }}
                                        >
                                            Restore Sessions                                          
                                        </button>
                                    </h4>

                                    {/* Accordion Body */}
                                    <div className={`accordion-collapse collapse ${this.state.restoreSessionGrid ? "show" : ""}`}>
                                            <div className="ag-theme-alpine test" style={{ height: "300px", width: "100%" }}>
                                                <AgGridReact
                                                    rowData={this.state.restoreSessions}
                                                    columnDefs={this.columnDefs}
                                                    defaultColDef={this.defaultColDef}
                                                    pagination={false}
                                                    domLayout="normal"
                                                    onRowClicked={this.handleRowClick}
                                                    onGridReady={(params) => {
                                                        this.gridApi = params.api;
                                                        this.gridColumnApi = params.columnApi;
                                                        this.gridApi.setGridOption("loading", true);
                                                    }}
                                                    rowSelection={{ mode: 'singleRow', checkboxes: false, enableClickSelection: true }}
                                                    overlayLoadingTemplate={`
                                                    <div style="position:absolute;top:50%;left:50%;transform:translate(-50%, -50%);">
                                                        <img src="${LoaderGif}" alt="loading" style="height:50px;">
                                                    </div>`}
                                                    overlayNoRowsTemplate={`<span className="ag-overlay-loading-center">No rows to display</span>`}
                                                />
                                            </div>
                                    </div>
                                </div>
                            </div>
                        )}
                    </div>
                    <div className="col-9 ps-0" style={{ width: '79%' }}>
                        <div className="card">
                            <div className="card-header">
                                <div className="row">
                                    <div className="col-3">
                                        <span
                                            className="SectionTitle mb-3"
                                            style={{ fontSize: "21px", fontWeight: '500' }}
                                        >
                                            CloudCover Recovery Suite
                                        </span>
                                    </div>
                                    {/*<div className="col-3" id="datePickerRestore" style={{ padding: "none" }}>*/}
                                    {/*    <DatePicker*/}
                                    {/*        selected={this.state.restoreDate}*/}
                                    {/*        minDate={this.state.firstRestoreDate}*/}
                                    {/*        maxDate={this.state.lastRestoreDate}*/}
                                    {/*        onChange={(date) => this.handleDateChange(date)}*/}
                                    {/*        dateFormat="dd/MM/yyyy"*/}
                                    {/*        style={{ maxHeight: "30px" }}*/}
                                    {/*        className="mr-1 datepicker"*/}
                                    {/*    />*/}
                                    {/*    <TimePicker*/}
                                    {/*        onChange={(time) => this.handleTimeChange(time)}*/}
                                    {/*        disableClock={true}*/}
                                    {/*        value={this.state.restoreTime}*/}
                                    {/*        style={{ maxHeight: "30px" }}*/}
                                    {/*        className="timepicker"*/}
                                    {/*    />*/}
                                    {/*</div>*/}

                                  
                                    <div className="col-4 btn-group restore-button-group" role="group">
                                            {restoreButtons}
                                    </div>
                                    
                                    {this.state.orgName && this.state.orgName !== "" &&
                                        <div className="col-5  d-flex justify-content-end primary_text" style={{ fontWeight: '500', fontSize:"21px" }}>
                                            {this.state.orgName}
                                        </div>
                                    }
                                </div>
                            </div>
                            <div
                                className="col-12 m-2"
                                id="restore_activeAggrid"
                            >
                                {((this.state.isAzureGuardianOnly || this.state.selectedRestoreType === "Azure Backup") && this.state.viewItems.length === 0 && this.state.gridViewItems.length === 0 &&
                                    !this.state.inProgressRight && !this.state.restore && this.state.selectedSessionEvents.length === 0) ? (

                                        <div className="ps-3">
                                            <p className="titletext" style={{ fontWeight: '500', fontSize: '25px', textAlign: "center" }}> CloudCover Guardian for Azure </p>

                                            <p className="mb-3">The highlighted dates show when there has been a configuration change.</p>

                                            <p className="mb-3">Select the date to see a list of configuration backups for that day.</p>

                                            <p className="mb-3">Select a configuration file to see the actual changes.</p>

                                            <p className="mb-3">You will be able to revert these changes from this interface.</p>


                                            <p className="mb-0">Notes:</p>
                                            <div className="ms-4">
                                                <p className="mb-0" style={{ display: 'list-item' }}>You should not revert changes unless you fully understand what you are doing.</p>
                                                <p className="mb-0" style={{ display: 'list-item' }}>Microsoft constantly changes the content of configuration components; some changes may be as a result of MS configuration</p>
                                                <p className="mb-3" style={{ display: 'list-item' }}>updates, It is therefore important to verify the changes reported.</p>
                                            </div>
                                            
                                        </div>
                                ) : (rightSection)}
                                <>                                  
                                    {!this.state.restoreSessionGrid && (
                                        <>
                                            <ActiveSearch queriesList={this.state.activeSearchList} />
                                            {searchBar}
                                            {result}
                                            {noResultsSection}
                                            {searchMsgAfter10Sec}
                                            {searchPopup}
                                        </>
                                    )}
                                </>
                            </div>
                            {this.state.allSessionEvents.length > 0 ? (
                                <Container fluid className="m-0 p-0">
                                    <Card body>
                                        <Row className="mb-2 align-items-center" style={{ backgroundColor: "rgb(33 37 41 / 3 %)" }}>
                                            <Col><h2 className="h5">Restore Session Events
                                               </h2></Col>
                                        </Row>
                                        <Row className="d-flex align-items-center w-100" style={{ fontSize: "13px" }}>
                                            <Col className="d-flex justify-content-center gap-3">
                                                <div className="d-flex align-items-center">
                                                    <Checkbox
                                                        style={{ transform: "scale(0.8)", padding: "0" }}
                                                        checked={this.state.filters.errors}
                                                        onChange={() => this.handleFilterChange("errors")}
                                                    />
                                                    <span>Errors</span>
                                                </div>
                                                <div className="d-flex align-items-center">
                                                    <Checkbox
                                                        style={{ transform: "scale(0.8)", padding: "0" }}
                                                        checked={this.state.filters.warnings}
                                                        onChange={() => this.handleFilterChange("warnings")}
                                                    />
                                                    <span>Warnings</span>
                                                </div>
                                                <div className="d-flex align-items-center">
                                                    <Checkbox
                                                        style={{ transform: "scale(0.8)" ,padding :"0"}}
                                                        checked={this.state.filters.success}
                                                        onChange={() => this.handleFilterChange("success")}
                                                    />
                                                    <span>Success</span>
                                                </div>
                                            </Col>

                                            <Col xs="auto" className="d-flex justify-content-end">
                                                <button title="Refresh" className="link-button" ><BootStrapButton className="mb-2" onClick={this.refreshSessionEventClick}
                                                    variant="primary"> <i className="fas fa-sync" style={{ color: 'white' }}></i> </BootStrapButton></button>
                                                {/*<a onClick={this.refreshSessionEventClick} className="d-flex align-items-center">*/}
                                                {/*    <svg className="me-1 ms-1" xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="blue" viewBox="0 0 512 512">*/}
                                                {/*        <path fill="currentColor" d="M440.65 12.57l4 82.77A247.16 247.16 0 0 0 255.83 8C134.73 8 33.91 94.92 12.29 209.82A12 12 0 0 0 24.09 224h49.05a12 12 0 0 0 11.67-9.26 175.91 175.91 0 0 1 317-56.94l-101.46-4.86a12 12 0 0 0-12.57 12v47.41a12 12 0 0 0 12 12H500a12 12 0 0 0 12-12V12a12 12 0 0 0-12-12h-47.37a12 12 0 0 0-11.98 12.57zM255.83 432a175.61 175.61 0 0 1-146-77.8l101.8 4.87a12 12 0 0 0 12.57-12v-47.4a12 12 0 0 0-12-12H12a12 12 0 0 0-12 12V500a12 12 0 0 0 12 12h47.35a12 12 0 0 0 12-12.6l-4.15-82.57A247.17 247.17 0 0 0 255.83 504c121.11 0 221.93-86.92 243.55-201.82a12 12 0 0 0-11.8-14.18h-49.05a12 12 0 0 0-11.67 9.26A175.86 175.86 0 0 1 255.83 432z"></path>*/}
                                                {/*    </svg>*/}
                                                {/*</a>*/}
                                            </Col>
                                        </Row>

                                        <div className="ag-theme-alpine" style={{ width: "100%",height: '350px' }}>
                                            <AgGridReact
                                                ref={this.gridRef} // Assign ref to the grid
                                                columnDefs={this.aggridColumnDefs}
                                                defaultColDef={this.defaultColDef}
                                                pagination={true}
                                                paginationPageSize={10}
                                                paginationPageSizeSelector={[10, 20]}
                                                enableCellTextSelection={true}
                                                suppressClipboardPaste={false}
                                                onGridReady={this.sessionEventOnGridReady}
                                                overlayLoadingTemplate={
                                                    `<div style="position:absolute;top:50%;left:50%;transform:translate(-50%, -50%);"><div><div style="text-align: center;"><img src="${LoaderGif}" alt="loading" style="height: 50px;"></div><span>Please wait while your rows are loading...</span></div></div>`}
                                                overlayNoRowsTemplate={
                                                    '<span className="ag-overlay-loading-center">No records to show</span>'
                                                }

                                            />
                                       </div>
                                    </Card>
                                </Container>
                            ) : null}
                            {footer}
                        </div>
                    </div>
                    <RestoreAccessModal displayModal={this.state.showCommentPopup} type={this.state.selectedRestoreType} closeModal={this.hideRestorePopup} orgId={this.state.orgId} onCommentSubmitted={this.handleCommentSubmitted} handleRestoreChallangeSubmitted={this.handleRestoreChallangeSubmitted } />
                    
                    <BootstrapModal id="AAD-difference-report" show={this.state.AADReportshow} onHide={this.AADReporthandleClose} centered size="xl">
                        <BootstrapModal.Header closeButton>
                            <BootstrapModal.Title>{this.state.AADPreviousCConfigHeadar} - Comparison</BootstrapModal.Title>
                        </BootstrapModal.Header>
                        <BootstrapModal.Body style={{ maxHeight:'80vh' }}>
                            {this.state.AADPreviousCurrent && this.state.AADPreviousCurrent}
                        </BootstrapModal.Body>
                    </BootstrapModal>



                    <BootstrapModal id="bulkRestore-popup" show={this.state.showBulkRestore} onHide={this.hideBulkRestore} centered size="xl">
                        <BootstrapModal.Header closeButton>
                            <BootstrapModal.Title>{this.state.restoreType === 'vex' ? 'Exchange Bulk Restore':  'One Drive Bulk Restore'}</BootstrapModal.Title>
                        </BootstrapModal.Header>
                        <BootstrapModal.Body>
                            <div className='row'>
                                <div className='col-2'>
                                    <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '58%', fontWeight:'600' }}>Selected Users:</div>
                                    </div>
                                    <div className='col-10'>
                                        <div style={{ display: 'flex', flexWrap: 'wrap' }}>
                                            {this.state.multiSelectItems.map((item) => (
                                                <span style={{ padding: '.25rem', margin: '.5rem', fontSize: '16px', border: '1px solid', borderRadius: '6px', fontWeight: '500' }}>{item.title}</span>
                                            ))}
                                    </div>
                                    {this.state.restoreType === 'vex' &&
                                        < hr />
                                        }
                                </div>
                                {this.state.restoreType === 'vex' && <>
                                    <div className="col-2">
                                        <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '80%', fontWeight: '600' }}>
                                            Exclusions:
                                            <OverlayTrigger placement="right" overlay={<Tooltip id="tooltip-diskspace">Use this option to exclude specific items from being restored during the Bulk Restore.</Tooltip>}>
                                                <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" className="ms-2 bi bi-info-circle" viewBox="0 0 16 16" >
                                                    <path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14m0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16" />
                                                    <path d="m8.93 6.588-2.29.287-.082.38.45.083c.294.07.352.176.288.469l-.738 3.468c-.194.897.105 1.319.808 1.319.545 0 1.178-.252 1.465-.598l.088-.416c-.2.176-.492.246-.686.246-.275 0-.375-.193-.304-.533zM9 4.5a1 1 0 1 1-2 0 1 1 0 0 1 2 0" />
                                                </svg>
                                            </OverlayTrigger>
                                        </div>
                                    </div>
                                    <div className="col-10">
                                        <div className="d-flex">
                                            <div className="p-1 mb-3" style={{ display: 'flex' }}>
                                                <label htmlFor="CheckBoxExcludeDrafts">
                                                    <span className="card-radio border p-2" style={{ borderRadius: '0.375rem' }}>
                                                        <span style={{ fontFamily: "'Poppins', sans-serif", fontSize: '15px', display: 'inline-flex' }} className="me-3">Drafts</span>
                                                        <input id="CheckBoxExcludeDrafts" type="checkbox" name="excludeDrafts" onChange={this.onBulkRestoreChecked} checked={this.state.bulkRestoreOptions.excludeDrafts} />
                                                    </span>
                                                </label>
                                            </div>
                                            <div className="p-1 mb-3" style={{ display: 'flex' }}>
                                                <label htmlFor="CheckBoxExcludeDeletedItems">
                                                    <span className="card-radio border p-2" style={{ borderRadius: '0.375rem' }}>
                                                        <span style={{ fontFamily: "'Poppins', sans-serif", fontSize: '15px', display: 'inline-flex' }} className="me-3">Deleted Items</span>
                                                        <input id="CheckBoxExcludeDeletedItems" type="checkbox" name="excludeDeletedItems" onChange={this.onBulkRestoreChecked} checked={this.state.bulkRestoreOptions.excludeDeletedItems} />
                                                    </span>
                                                </label>
                                            </div>
                                            <div className="p-1 mb-3" style={{ display: 'flex' }}>
                                                <label htmlFor="CheckBoxExcludeInPlaceHoldItems">
                                                    <span className="card-radio border p-2" style={{ borderRadius: '0.375rem' }}>
                                                        <span style={{ fontFamily: "'Poppins', sans-serif", fontSize: '15px', display: 'inline-flex' }} className="me-3">In-Place Hold Items</span>
                                                        <input id="CheckBoxExcludeInPlaceHoldItems" type="checkbox" name="excludeInPlaceHoldItems" onChange={this.onBulkRestoreChecked} checked={this.state.bulkRestoreOptions.excludeInPlaceHoldItems} />
                                                    </span>
                                                </label>
                                            </div>
                                            <div className="p-1 mb-3" style={{ display: 'flex' }}>
                                                <label htmlFor="CheckBoxExcludeLitigationHoldItems">
                                                    <span className="card-radio border p-2" style={{ borderRadius: '0.375rem' }}>
                                                        <span style={{ fontFamily: "'Poppins', sans-serif", fontSize: '15px', display: 'inline-flex' }} className="me-3">Litigation Hold Items</span>
                                                        <input id="CheckBoxExcludeLitigationHoldItems" type="checkbox" name="excludeLitigationHoldItems" onChange={this.onBulkRestoreChecked} checked={this.state.bulkRestoreOptions.excludeLitigationHoldItems} />
                                                    </span>
                                                </label>
                                            </div>
                                        </div>
                                    </div>
                                </>}
                               
                            </div>
                            
                        </BootstrapModal.Body>
                        <BootstrapModal.Footer>
                            <button className="btn btn-primary btn-sm two" onClick={() => this.BulkRestore()} >Restore</button>
                        </BootstrapModal.Footer>
                    </BootstrapModal>
                    {searchPopup}
                </div>

            </React.Fragment>
        );
    }
}
